/* AUTO-GENERATED by research/build_americas.py. Do not edit by hand.

   Canada and Latin America: 12 countries, 190 named centres,
   92 reimbursement pathways.

   Every national volume figure was independently verified against a primary registry by a
   second pass instructed to refute it. All 12 confirmed, most to zero deviation:
   ABTO/RBT (Brazil), CIHI CORR (Canada), CENATRA (Mexico), INCUCAI/SINTRA (Argentina),
   INS (Colombia), ISP (Chile), INDT (Uruguay), INDOT (Ecuador), INCORT (Dominican Republic).

   Centres are ONLY those the registries actually name. Where a country reports a centre count
   but not a list, the count is on the country record and the centres are absent rather than
   invented. Coordinates come from a curated gazetteer; anything not in it sits at a country
   centroid, is flagged geo:'approx', and is drawn differently on the map.

   CHINA IS DELIBERATELY EXCLUDED. See the note on the Atlas page.
*/

import type * as A from './atlas';

export const AMERICAS_COUNTRIES = [
 {
  "iso3": "BRA",
  "iso2": "",
  "name": "Brazil",
  "population": 213421037,
  "donorsPmp": 20.3,
  "donorsPmpYear": 2025,
  "donationModel": "opt_in",
  "registry": "Registro Brasileiro de Transplantes (RBT), published by the Associação Brasileira de Transplante de Órgãos (ABTO) from data supplied by the Sistema Nacional de Transplantes (SNT), Ministério da Saúde",
  "registryUrl": "https://site.abto.org.br/conteudo/rbt/",
  "priority": "tier_1",
  "entryMode": "distributor",
  "kidney": 6697,
  "liver": 2573,
  "heart": 427,
  "lung": 96,
  "dataYear": 2025,
  "confidence": "verified",
  "summary": "Brazil is the largest public-payer transplant market in the world outside the US: the SUS (Sistema Único de Saúde) funds the overwhelming majority of the 6,697 kidney and 2,573 liver transplants done in 2025, and provision is overwhelmingly public or philanthropic (federal/state university hospitals, Santa Casas, hemocentro-based HLA labs), with a small private tier at Albert Einstein, Sírio-Libanês and Real Hospital Português that still bills SUS for most transplant activity. Money reaches providers through fixed SIGTAP tariffs, so a diagnostic is only commercially viable at scale once CONITEC has formally incorporated it into the SUS procedure table; until then a foreign test is confined to out-of-pocket and supplementary-health (ANS) volume, priced in BRL against a low reference tariff. The main trip hazards for a foreign entrant are (a) mandatory ANVISA registration under RDC 830/2023 with a Brazilian Registration Holder as the legal importer of record, (b) the CONITEC incorporation pathway being the real gatekeeper rather than the clinicians, and (c) operational fragmentation, since donation and allocation run through 27 state CNCDOs and the 49 immunobiology laboratories are a mix of public hemocentros, university labs and private contractors, each procuring separately.",
  "centreCount": 162,
  "hlaLabCount": 49,
  "unknowns": [
   "transplant_centre_count = 162 is NOT an unduplicated national count of transplant hospitals. It is ABTO's figure for ACTIVE KIDNEY transplant centres in 2025 ('RIM - em 24 estados, com 162 centros atuantes'). ABTO reports active centres/teams per organ separately for 2025: kidney 162 centres in 24 states; liver 114 teams in 19 states; heart 51 teams in 15 states; pancreas 14 centres in 6 states; lung 10 teams in 5 states. These overlap heavily (one hospital often hosts several organ programmes, and ABTO counts 'equipes' = surgical teams, not buildings). No unduplicated hospital-level total was found in any source. Do not sum these numbers.",
   "The count of formally SNT/CNES-ACCREDITED (credenciados) transplant establishments and teams was not found. ABTO's 'centros atuantes' counts only those that actually performed a transplant in the year; the accredited universe is larger. An older 2015 review quoted 135 kidney / 64 liver / 31 heart / 15 pancreas / 6 lung accredited centres, but that is a decade stale and was NOT used.",
   "hla_lab_count = 49 is ABTO's 'Laboratórios de Imunobiologia' list, identical in the RBT 2024 and RBT 2025 reports (Norte 3, Nordeste 11, Sudeste 22, Sul 9, Centro-Oeste 4). This is the list of labs reporting to / affiliated with the RBT. The number of laboratories formally AUTHORISED by the SNT for histocompatibility and immunogenetics was not found and may differ.",
   "No data found on which of the 49 HLA labs perform molecular/NGS typing versus serology/Luminex only, nor their annual test volumes, nor their instrument installed base. This is the single biggest commercial gap for a diagnostics entrant.",
   "2025 lung figure of 96 is confirmed by ABTO, but the 2025 public edition of the RBT omits the centre-by-centre tables entirely. All named-centre volumes above are therefore 2024, from the RBT 2024 members' edition. The RBT 2025 members' edition could not be retrieved (all probed URL patterns returned 404).",
   "Several ABTO centre codes are not expanded to full institution names anywhere in the registry (HSFA and HFBS in Rio de Janeiro, HMAC and HNSR in Paraná, HSI in Blumenau). These have been left as codes rather than guessed. HSFA (269 kidney) and HFBS (134 kidney) in particular are large programmes that need identifying before any sales approach.",
   "DEFINITIONAL CAVEAT on the donor rate: ABTO's metric is 'doador efetivo' (effective donor), not the internationally standard 'actual/utilised deceased donor'. The RBT 2025 editorial itself argues for switching to 'doador real (quando há remoção de órgãos)' to be internationally comparable, which implies the current 'efetivo' count may include donors from whom no organ was ultimately retrieved. The 20.3 pmp figure may therefore be slightly optimistic against GODT/IRODaT definitions.",
   "The SUS share of transplant funding was not verified with a figure. The task brief asserts SUS funds nearly all transplants and this is consistent with everything found, but no percentage from a citable source was located. Public-versus-private volume split is unquantified.",
   "No information found on reimbursement status in SUS for donor-derived cell-free DNA, molecular biopsy classifiers, or any modern non-invasive rejection surveillance test. Absence of evidence, not evidence of absence, but nothing suggests a SIGTAP code exists.",
   "Waiting list sizes by organ (December 2025) are in the RBT but were not extracted in this pass.",
   "Portaria GM/MS Nº 8.041 (25 Sep 2025) creates a new national donation and transplant policy and technical regulation for the SNT. Its content was not read and it may change accreditation rules for laboratories and centres. This should be reviewed before any market-entry decision.",
   "2025 family refusal rate is quoted as approximately 45% in press coverage of the RBT 2025 (46% in the RBT 2024 editorial) but the exact 2025 RBT figure was not extracted from the primary PDF.",
   "Whether the AEDO electronic donor registry (2023) has materially reduced family refusal is unestablished."
  ]
 },
 {
  "iso3": "CAN",
  "iso2": "",
  "name": "Canada",
  "population": 41288599,
  "donorsPmp": 21.7,
  "donorsPmpYear": 2024,
  "donationModel": "mixed",
  "registry": "Canadian Organ Replacement Register (CORR), Canadian Institute for Health Information (CIHI)",
  "registryUrl": "https://www.cihi.ca/en/canadian-organ-replacement-register-corr",
  "priority": "tier_1",
  "entryMode": "distributor",
  "kidney": 1926,
  "liver": 653,
  "heart": 170,
  "lung": 412,
  "dataYear": 2024,
  "confidence": "verified",
  "summary": "Canada is a single-payer, entirely public market: transplant surgery, immunosuppression monitoring and histocompatibility testing are funded province by province out of provincial health budgets, with no meaningful private-pay transplant sector, so a diagnostics vendor must win 7-10 separate provincial payers (Ontario Health, BC Transplant/PHSA, Alberta Precision Laboratories, Transplant Quebec plus MSSS, Transplant Manitoba, Saskatchewan Health Authority, Nova Scotia Health) rather than one national customer. Volume is highly concentrated: 30 CORR-listed transplant facilities and only 15 ASHI-accredited HLA laboratories nationally, of which 11 hold solid-organ accreditation, and Ontario alone did 1,340 of 3,203 transplants in 2024, so realistically 10-12 lab accounts control almost the entire addressable spend. The traps for a foreign entrant are that provincial labs are consolidated public monopolies bought through provincial tender or sole-source with long cycles, that Health Canada requires a medical device licence for a commercial IVD (Class III/IV for transplant matching) while Canadian public labs routinely run in-house laboratory-developed tests under provincial/ASHI accreditation and can simply build rather than buy, that Quebec is a distinct system with its own OPO (Transplant Quebec), its own blood operator (Hema-Quebec) and French-language labelling obligations, and that Canadian Blood Services controls the national Canadian Transplant Registry, HSP and KPD programmes, making it the de facto gatekeeper for anything touching cPRA or national allocation.",
  "centreCount": 30,
  "hlaLabCount": 15,
  "unknowns": [
   "2025 organ-level volumes. CIHI has published 2025 headline figures (3,174 total transplants, 888 deceased donors, 5% of transplants from MAID donors) but ONLY as percentages by organ, and the 2025 data tables XLSX does not yet exist (confirmed HTTP 404). The organ counts reported here are the exact 2024 figures from CIHI Table 5. Do NOT back-calculate 2025 organ counts from the published percentages.",
   "Transplant centre count is ambiguous. The CORR Directory (Dec 2024) lists 30 transplant facility rows across 7 provinces, but Quebec's CHUM appears three times (facility codes 40120 Hopital Notre-Dame, 40130 Hopital Saint-Luc, 48122 the consolidated CHUM at 1000 rue Saint-Denis). Counting distinct operating hospitals gives approximately 28. No CIHI or CBS publication states a single official national centre count.",
   "Centre-level transplant volumes are not published by CIHI. Table 5 breaks down only to province. The three annual_kidney values given (Halifax 141, Winnipeg 74, Saskatoon 28) are provincial totals for provinces with a single transplant programme, not published centre-level figures.",
   "HLA laboratory count is ASHI-accredited labs only (15 total, 11 with solid-organ accreditation). Canada has no national HLA lab registry. Labs accredited only by provincial or other bodies (IQMH/Ontario Laboratory Accreditation, CAP, Agrement Canada) would not appear. A concrete gap: Manitoba performed 74 kidney transplants in 2024 but the only ASHI-accredited Manitoba lab (CancerCare Manitoba) is accredited for HSC/BM and other clinical purposes, NOT solid organ - so Manitoba's solid-organ HLA testing is done somewhere this source does not capture.",
   "Organ scope for several CORR-listed paediatric sites is unestablished: Alberta Children's Hospital (Calgary), Children's Hospital of Winnipeg, IWK Health Centre (Halifax). They are listed as participating transplant facilities but the organs they transplant were not confirmed on a primary source.",
   "Whether IUCPQ (Quebec City) runs a lung transplant programme was not verified. The Canadian Society of Transplantation list shows heart only, and that list is visibly out of date (it still names pre-2017 CHUM and CHU de Quebec sites).",
   "Foothills Medical Centre's kidney-only scope is inferred from a University of Alberta statement, not confirmed on an Alberta Health Services or Southern Alberta Transplant Program source.",
   "No transplant activity in New Brunswick, Prince Edward Island, Newfoundland and Labrador, or the three territories. CIHI Table 5 covers only NS, QC, ON, MB, SK, AB, BC. Atlantic patients are transplanted in Halifax; territorial patients in Alberta or BC. This is confirmed absence of centres, not missing data.",
   "Reimbursement mechanism for a novel molecular transplant diagnostic (dd-cfDNA, molecular biopsy, HLA NGS) in each province was not researched. There is no Canadian equivalent of a MolDX LCD or a national test directory; funding decisions sit with individual provincial lab services and hospital global budgets.",
   "Health Canada IVD device licensing class and pathway for transplant-matching assays was not verified against the Medical Devices Regulations in this session.",
   "IRODaT reports Canada at 22.8 deceased donors pmp for 2024, against the CIHI/Library of Parliament figure of 21.7 pmp used here. The two registries count actual deceased donors on different definitions; the discrepancy was not reconciled.",
   "Living donor figures were not fully extracted: 591 living donors in 2024 (CIHI), living donor rate 15.1 pmp (IRODaT 2024). Living-donor kidney volume as a share of the 1,926 kidney transplants was not separated out."
  ]
 },
 {
  "iso3": "MEX",
  "iso2": "",
  "name": "Mexico",
  "population": 129450000,
  "donorsPmp": 4.21,
  "donorsPmpYear": 2024,
  "donationModel": "mixed",
  "registry": "CENATRA — Centro Nacional de Trasplantes / SIRNT (Sistema Informático del Registro Nacional de Trasplantes)",
  "registryUrl": "https://www.gob.mx/cenatra",
  "priority": "tier_2",
  "entryMode": "distributor",
  "kidney": 2730,
  "liver": 280,
  "heart": 42,
  "lung": 7,
  "dataYear": 2024,
  "confidence": "verified",
  "summary": "Provision is overwhelmingly public and vertically integrated inside social-security institutions that are their own payer, provider and procurer: in 2024 IMSS alone did 52.4% of all kidney transplants, with ISSSTE, SSA federal institutes, state health services (SSE) and IMSS-Bienestar taking most of the rest, while the private sector took 24.8% of kidney and 25.7% of liver volume on self-pay or private insurance. The clinical shape is unusual and matters commercially: deceased donation is very low at 4.21 dd pmp, so 64% of kidney transplants are living-donor, the kidney waiting list stands at 16,443 against roughly 2,730 transplants a year, and volume is highly concentrated (the top ten kidney units performed about 43% of national activity, and heart and lung are effectively 10 and 3 active centres respectively). A foreign diagnostics entrant should expect three specific traps: COFEPRIS device registration plus a Mexican legal-entity or distributor of record before anything can be sold; IMSS/ISSSTE buying through consolidated national tenders (compra consolidada) that are price-led, annual and largely closed to unbudgeted novel tests; and the absence of any national reimbursement code for molecular transplant surveillance, meaning post-transplant assays must be funded out of an individual hospital's own budget line rather than reimbursed, which pushes the realistic near-term market toward pre-transplant HLA typing, crossmatch and living-donor workup rather than dd-cfDNA-style monitoring.",
  "centreCount": 441,
  "hlaLabCount": null,
  "unknowns": [
   "HLA / histocompatibility laboratory count: NOT FOUND. CENATRA's licensed-establishment dataset has no histocompatibility or immunogenetics category at all (its categories are procuración, the individual transplant programmes, and tissue banks), and the BEI-CENATRA 2025 bulletin contains no mention of laboratorios de histocompatibilidad or HLA. There appears to be no published national register of HLA labs in Mexico. I could name only two individual labs from secondary sources (the Laboratorio de Histocompatibilidad at INCMNSZ, and the private IntegraLab network) and deliberately did not extrapolate a count. This needs primary research — likely a direct enquiry to CENATRA, to the Sociedad Mexicana de Trasplantes, or an ASHI/EFI accredited-lab lookup.",
   "Lung transplant figure is discordant between the two primary sources for 2024: CENATRA SIRNT open data records 7 lung transplants across the four 2024 quarters, whereas IRODaT reports 16 for the same year. I have reported the CENATRA registry figure (7). The reason for the gap is unestablished — possibly late registry entries, or IRODaT counting lungs (grafts) rather than recipients. Either way lung is a rounding error commercially.",
   "Per-organ transplant volumes for calendar year 2025 could NOT be obtained. CENATRA published the 2025 headline total (6,522 transplants) and heart (42 + 4 heart-kidney), but the organ-by-organ 2025 breakdown in BEI-CENATRA Vol. X exists only as chart images with no extractable data labels, and datos.gob.mx is missing the Q2 and Q3 2025 quarterly files, so 2025 cannot be reconstructed from open data either. 2024 is therefore the most recent year with a complete, verifiable organ split.",
   "Deceased-donor pmp for 2025 is not directly published as a rate. CENATRA reports 572 brain-death donations for 2025 and an essay in the same bulletin cites 4.2 pmp, but I did not find an authoritative 2025 pmp figure, so the reported 4.21 pmp is the IRODaT 2024 value.",
   "Population figure is DERIVED, not sourced: 129,450,000 is back-calculated from IRODaT's 2024 pair (545 deceased donors / 4.21 pmp). It carries roughly ±150,000 of rounding error. I did not retrieve a CONAPO or INEGI population figure directly. Treat as approximate; do not quote it as a sourced statistic.",
   "Municipality (city) is NOT published in the CENATRA registry — the open data gives only entidad federativa (state). I verified cities individually for four centres and treated Ciudad de México as unambiguous. For seven named centres (UMAE HE No. 25, UMAE Cardiología No. 34, Christus Muguerza Alta Especialidad, Centenario Hospital Miguel Hidalgo, CMN Manuel Ávila Camacho, the two Bajío hospitals, Instituto Mexicano de Trasplantes) the city field carries an explicit 'state only, not verified' flag. Do not strip that flag before handing the list to sales.",
   "The centre count is ambiguous by definition and I have given three different defensible numbers rather than one: 441 establishments hold a transplant licence (CENATRA 2025) but only 227 had any transplant activity; 287 hold a licence for kidney, liver, heart or lung; and in 2024 only 169-196 establishments actually performed a kidney transplant, 43 a liver, 10 a heart and 3 a lung. The licensed count massively overstates the addressable market — over half of licensed establishments are dormant, and the licence includes cornea-only and tissue-bank sites.",
   "Whether individual named centres run their own HLA lab or send out is unestablished for all but INCMNSZ. has_hla_lab is null everywhere else — this is exactly the field a diagnostics sales plan needs and it is the biggest single gap in this profile.",
   "Reimbursement: I found no evidence either way of a national tariff, code or funding route for molecular transplant diagnostics (dd-cfDNA, molecular biopsy, HLA NGS) in IMSS, ISSSTE or the SSA/IMSS-Bienestar system. The absence of a code is asserted in the summary as an absence of found evidence, not as a verified negative — confirm with a Mexican regulatory/market-access adviser before pricing.",
   "COFEPRIS IVD registration timelines and costs were not researched in this pass, nor was the current status of the IMSS/ISSSTE consolidated procurement calendar. Both are named in the summary as structural features but the specifics are unverified.",
   "Consent model is genuinely mixed and I have not forced it into a clean bucket. The statute (LGS Art. 324) creates consentimiento tácito, which reads as soft opt-out, but the same article makes donation conditional on obtaining positive consent from a listed family member, and CENATRA/IMSS leadership describe the current operating model as consentimiento expreso while campaigning to move to consentimiento presunto. Operationally it behaves as opt-in with mandatory family authorisation. Anyone modelling donation-rate uplift from a legal change should read Art. 324 in full rather than rely on a one-word classification."
  ]
 },
 {
  "iso3": "ARG",
  "iso2": "",
  "name": "Argentina",
  "population": 46380000,
  "donorsPmp": 20.59,
  "donorsPmpYear": 2025,
  "donationModel": "opt_out_hard",
  "registry": "INCUCAI (Instituto Nacional Central Unico Coordinador de Ablacion e Implante) / SINTRA (Sistema Nacional de Informacion de Procuracion y Trasplante)",
  "registryUrl": "https://sintra.incucai.gov.ar/",
  "priority": "tier_2",
  "entryMode": "distributor",
  "kidney": 1674,
  "liver": 463,
  "heart": 124,
  "lung": 22,
  "dataYear": 2025,
  "confidence": "verified",
  "summary": "Argentina is a three-tier payer market: roughly 61% of the population is covered by an obra social, a prepaga or PAMI (2022 Census), and the remainder by free-at-point-of-use provincial public hospitals, so transplant provision is split between high-volume private/charitable centres (Hospital Italiano, Fundacion Favaloro, Austral) and large public ones (Garrahan, El Cruce, CUCAIBA CRAI). Transplant is inside the Programa Medico Obligatorio, and the real money flows through the Superintendencia de Servicios de Salud's Sistema Unico de Reintegros (SUR), which reimburses obras sociales for high-cost transplant episodes and is electronically cross-checked against SINTRA, INCUCAI and ANMAT registries, meaning anything not on the SUR nomenclator is effectively unfunded and must be sold as an out-of-pocket or hospital-budget item. The trip-ups for a foreign diagnostics entrant are ANMAT registration and importer licensing for IVDs, INCUCAI's monopoly on authorising histocompatibility laboratories (Resolution 406/15 quality standards) which makes INCUCAI the gatekeeper rather than the individual lab, chronic FX and import-control volatility that makes peso-denominated pricing of a dollar-cost assay hazardous, and heavy geographic concentration since CABA alone accounts for about 45% of national transplant activity.",
  "centreCount": null,
  "hlaLabCount": null,
  "unknowns": [
   "ORGAN SPLIT IS NOT THE FINAL FULL-YEAR NUMBER. The kidney 1,674 / liver 463 / heart 124 / lung 22 breakdown comes from the Ministry of Health release dated 15 December 2025, which reported 4,497 total transplants and 906 donation processes. INCUCAI's final 2025 figures, published later, were 955 donation processes and 4,786 transplants. The organ figures above therefore represent roughly 94% of the year and the true full-year totals are somewhat higher. INCUCAI has not published a per-organ full-year 2025 table on any page I could reach; the CRESI report generator (https://cresi.incucai.gov.ar/) requires interactive query and returned no static annual totals.",
   "COMBINED-ORGAN PROCEDURES ARE COUNTED SEPARATELY in the INCUCAI breakdown and are NOT included in the single-organ numbers above. Add if you want organ-touching totals: kidney-pancreas 36, liver-kidney 24, heart-kidney 3, heart-lung 1, isolated pancreas 2.",
   "TRANSPLANT CENTRE COUNT: no current national figure found. The only properly sourced count is 133 approved centres (55 kidney, 28 liver, 22 heart, 17 kidney-pancreas, 9 lung, 2 intestine; 93 private / 40 public) from Gondolesi et al, Transplantation 2018, which is EIGHT YEARS OLD and predates several new programmes (e.g. Hospital Fernandez renal centre, Hospital Gutierrez paediatric renal). Returned null rather than pass off a 2018 number as current. Secondary web summaries quoting '148 transplant teams' or '145 organ transplant centres' could not be traced to a primary source and were discarded. The CABA figure of 210 'centros especializados' is authorised establishments for ALL procedure types including cornea, tissue and bone marrow, NOT solid-organ transplant programmes, and must not be used as a centre count.",
   "HLA / HISTOCOMPATIBILITY LABORATORY COUNT: no national figure found. INCUCAI maintains a registry of authorised histocompatibility laboratories inside CRESI but does not publish a count or a public list at any URL I could reach. I could name 8 individual labs from primary sources (listed in named_centres) but that is a floor, not a total, and the real number is certainly higher. This is the single biggest gap for a diagnostics entrant and would need a direct request to INCUCAI or a CRESI query.",
   "POPULATION 46,380,000 IS DERIVED, NOT PUBLISHED: back-calculated from INCUCAI's own 955 donors at 20.59 pmp. INDEC's Census 2022 counted 46,044,703. INDEC's 2022-2040 national projection for mid-2025 was not retrieved.",
   "CONSENT MODEL CLASSIFIED AS HARD OPT-OUT ON THE LAW AS WRITTEN. Ley 27.447 requires objection to be formally registered and removed the previous law's provision letting relatives express the deceased's opposition by any means. I did NOT find published data on how often families in practice block retrieval, so whether it operates as a hard or de-facto soft opt-out at the bedside is unverified.",
   "LIVING vs DECEASED DONOR SPLIT BY ORGAN not found for 2025. Only the aggregate is published: 2,096 transplants from deceased donors and 253 from living donors (as of 15 Dec 2025).",
   "PER-CENTRE ANNUAL KIDNEY VOLUMES: available only for Hospital Garrahan (45, paediatric) and Hospital Italiano (>65). INCUCAI does not publish a centre-level activity league table publicly, so centre-level market sizing is not possible from open sources.",
   "LUNG PROGRAMME LOCATIONS: only 22 lung transplants nationally in 2025 and 9 authorised lung centres per the 2018 paper, but I could confirm named lung programmes only at El Cruce, Hospital Italiano and Garrahan. The rest are unidentified.",
   "ANMAT IVD PATHWAY: I confirmed ANMAT is the IVD registration authority and that SUR cross-checks ANMAT registries, but did NOT verify the specific disposicion governing in vitro diagnostic reagent registration, classification tiers, timelines or fees. Do not quote a regulation number without checking.",
   "REIMBURSEMENT FOR TRANSPLANT DIAGNOSTICS SPECIFICALLY: I confirmed the SUR mechanism exists and covers transplant episodes, but did NOT verify whether HLA typing, anti-HLA antibody monitoring or any molecular surveillance assay appears as a separately reimbursable line on the SUR nomenclator, nor any peso price. That is a hard blocker for revenue modelling and needs the SSSalud Resolution 731/2023 annex checked directly.",
   "No IRODaT or GODT/WHO-ONT country page was successfully retrieved; all figures here come from INCUCAI/SINTRA and Argentine government sources directly, which is the better primary source but means no independent cross-check was performed."
  ]
 },
 {
  "iso3": "COL",
  "iso2": "",
  "name": "Colombia",
  "population": 52695952,
  "donorsPmp": 7.4,
  "donorsPmpYear": 2024,
  "donationModel": "opt_out_hard",
  "registry": "Red Nacional de Donación y Trasplantes, Instituto Nacional de Salud (INS) — national information system RedDataINS",
  "registryUrl": "https://www.ins.gov.co/Direcciones/RedesSaludPublica/DonacionOrganosYTejidos/Paginas/default.aspx",
  "priority": "tier_2",
  "entryMode": "distributor",
  "kidney": 894,
  "liver": 292,
  "heart": 95,
  "lung": 41,
  "dataYear": 2024,
  "confidence": "verified",
  "summary": "Colombia is a single-payer-in-effect market delivered by private providers: essentially every transplant is financed through the SGSSS via EPS insurers (2024: 66% contributivo, 27% subsidiado, 6% regímenes de excepción), yet the highest-volume centres are private non-profit foundations (Cardioinfantil, Valle del Lili, Pablo Tobón Uribe, Santa Fe de Bogotá). Payer risk is the dominant commercial hazard: the four EPS that fund roughly 58% of kidney transplants (Nueva EPS 22.5%, Sura 16.9%, Sanitas 10.2%, Salud Total 8.5%) are all under Supersalud intervention or corrective plans, with Nueva EPS alone carrying negative equity above COP 10 trillion and multi-trillion-peso arrears to provider IPS, so anything outside the funded PBS benefit package has no reliable route to payment. A foreign diagnostics entrant also faces INVIMA IVD registration, extreme geographic concentration (Bogotá, Antioquia and Valle del Cauca account for roughly 82% of kidney transplants and 89% of deceased donors), and a small deceased-donor pool at 7.4 pmp; the genuine opening is the transplant reform bill passed by Congress in June 2026, which creates INDTOT and a statutory National Registry of Incompatible Donors and Highly Sensitised Patients — a direct, funded mandate for HLA antibody and histocompatibility testing.",
  "centreCount": 34,
  "hlaLabCount": 10,
  "unknowns": [
   "Organ counts are SINGLE-ORGAN totals from INS Tabla 5. Kidney=894 EXCLUDES 31 further procedures involving a kidney (23 kidney-pancreas, 7 kidney-liver, 1 kidney-heart); liver=292 excludes 7 kidney-liver and 3 liver-intestine-pancreas. Grand total all organ transplants 2024 = 1,358 (1,080 from deceased donors, 278 living).",
   "The 7.4 pmp figure is the INS national rate for 2024 (388 donantes reales). The INS 2024 executive report itself states the donor count but NOT the pmp; 7.4 comes from INS statements reported in Colombian press. IRODaT separately shows 2025 preliminary at 400 actual deceased donors / 7.49 pmp on a 53.4M population base, so the two sources use slightly different denominators.",
   "transplant_centre_count=34 is the number of IPS trasplantadoras listed in INS Tabla 3 for 2024. Three of those (Avidanti Ibagué, Hospital General de Medellín, Hospital Universitario de San José Popayán) performed ZERO organ transplants, so only 31 were active. Note also that the 34 rows include two Fundación Valle del Lili sites and two Clínica Colsanitas sites, so the number of distinct legal institutions is ~32. Could NOT find an official INS register of formally habilitated transplant centres to reconcile against.",
   "hla_lab_count=10 is the number of laboratories enrolled in the INS external performance assessment programme (PEED) for transplant immunogenetics in 2023, per the Biomédica 10-year review (13 in 2014, 12 in 2015, 11 in 2016-2022, 10 in 2023). This is PEED enrolment, NOT a formal habilitation register. Could NOT find an official INS list of habilitated histocompatibility laboratories, nor a 2024 or 2025 figure.",
   "Could NOT obtain a named list of the 10 immunogenetics laboratories. Only their cities are published: Bogotá, Medellín, Cali, Bucaramanga, Neiva and Barranquilla. has_hla_lab is therefore null for all centres except the two independently confirmed (Fundación Valle del Lili, Cali; Fundación Cardiovascular de Colombia / Hospital Internacional de Colombia, Floridablanca).",
   "Number of EFI-accredited labs in Colombia is CONFLICTING between sources: Fundación Valle del Lili's own release says four, a trade-press article on the same accreditation says five. Not resolved; no ASHI-accredited count found at all.",
   "Consent model coded opt_out_hard on the statute: Ley 1805 de 2016 presumes donation absent a notarised objection filed with the INS, and expressly bars family members from opposing retrieval except where the deceased is a minor. Could NOT quantify how often family refusal still blocks donation in practice, so the practical model may behave closer to soft opt-out. INS reports 346,383 positive and 1,469 negative declarations recorded in RedData between 2006 and 30 May 2025.",
   "No breakdown found of kidney transplants by living vs deceased donor at individual centre level beyond INS Tabla 3 (which does give it); no data found on re-transplant rate, HLA-incompatible/desensitisation volumes, or dd-cfDNA / molecular surveillance use anywhere in Colombia.",
   "No pricing or reimbursement tariff found for HLA typing, PRA/single-antigen bead testing or crossmatch under the PBS/UPC; could not establish whether these are bundled into the transplant episode payment or billed separately.",
   "Cities for individual centres are NOT stated in the INS table (which reports only the six regional coordinations). Cities were matched from institution identity and then arithmetically corroborated: per-centre kidney totals reconcile exactly to the Tabla 1 regional totals for Regionals 1, 2, 3, 4 and 6. Treat the city field as high-confidence but derived, not quoted.",
   "The June 2026 transplant reform bill (creating INDTOT and the National Registry of Incompatible Donors and Highly Sensitised Patients) had passed Congress and was awaiting presidential sanction as of the latest reporting found; could NOT confirm whether it has since been signed, its final text, its commencement date, or any implementing budget."
  ]
 },
 {
  "iso3": "CHL",
  "iso2": "",
  "name": "Chile",
  "population": 18480432,
  "donorsPmp": 11,
  "donorsPmpYear": 2025,
  "donationModel": "opt_out_soft",
  "registry": "Instituto de Salud Pública de Chile (ISP) — Registro Nacional de Trasplantes / Coordinación Nacional de Procuramiento y Trasplante, MINSAL",
  "registryUrl": "https://www.ispch.gob.cl/biomedico/estadisticas-de-trasplante/",
  "priority": "tier_2",
  "entryMode": "distributor",
  "kidney": 375,
  "liver": 176,
  "heart": 47,
  "lung": 26,
  "dataYear": 2025,
  "confidence": "verified",
  "summary": "Chile runs a two-tier payer system: roughly 79% of 2025 transplants were in Fonasa (public insurance) beneficiaries and 20% in Isapre (private insurance) members, and MINSAL states about 80% of organs are transplanted in the public sector, so the volume sits in state hospitals while several high-profile private clinics in Santiago (Las Condes, Alemana, Dávila, Santa María, UC Christus) take the paying minority. The decisive structural feature for a diagnostics vendor is that histocompatibility is a state monopoly: the Instituto de Salud Pública is explicitly the country's only reference centre for HLA typing, anti-HLA antibody screening (Luminex) and flow crossmatch, and it also owns the national waiting list and the transplant statistics — so there is effectively one buyer, reached through public procurement (ChileCompra/Mercado Público), not a market of hospital labs. The same ISP is also Chile's IVD regulator and registration authority, which means your customer and your regulator are the same institution, and any novel post-transplant test (dd-cfDNA, molecular surveillance) has no established Fonasa/GES reimbursement code, making Isapre or self-pay through the private Santiago clinics the only near-term revenue route.",
  "centreCount": 24,
  "hlaLabCount": 1,
  "unknowns": [
   "deceased_donors_pmp of 11 is MY OWN CALCULATION (203 effective deceased donors 2025 / 18,480,432 census population = 10.98), not a published pmp figure. I could not retrieve an official 2025 pmp from IRODaT or GODT - the IRODaT newsletter PDFs render only chart headings, not the Chile data rows. The last officially published pmp figures I found are 8.6 (2022), 7.4 (2021), 7.2 (2020) from MINSAL, and a press reference to '10 per million' for 2024.",
   "Heart and lung counts conflict between sources: the ISP December 2025 report gives 47 heart and 26 lung, while the MINSAL/Seremi press release for the same year gives 50 heart and 27 lung. The ISP report itself warns that numbers may change because confirmatory data from transplant centres lags. I have used the ISP registry figures.",
   "The kidney figure of 375 is 294 deceased-donor plus 81 living-donor. The ISP report counts 11 combined transplants (heart-kidney, heart-liver, liver-kidney) separately, so the true number of kidneys transplanted is slightly higher than 375 by an amount I could not disaggregate.",
   "transplant_centre_count of 24 is MY COUNT of distinct institutions named on the MINSAL accredited-centres page. MINSAL does not state a total anywhere on that page, and the page carries no revision date, so it may be out of date. Treat 24 as a floor, not an audited figure.",
   "hla_lab_count of 1 reflects the Sociedad Chilena de Trasplante statement that ISP is the only reference centre for histocompatibility in solid organ transplant. I could NOT establish whether private laboratories or university hospitals run their own HLA typing for haematopoietic stem cell transplant, private/living-donor work-up, or disease-association HLA-B27 testing. The count of 1 applies to the deceased-donor solid organ pathway only.",
   "Number of procurement units / local coordination units (unidades de procuramiento) nationally - not found. MINSAL references a network but publishes no count I could retrieve.",
   "Per-centre transplant volumes - ISP publishes national aggregates only and explicitly does not attribute figures to named centres. No centre-level kidney volumes were obtainable.",
   "Cornea transplants 2025 were 229 patients (122 cadaveric, 65 pathological anatomy, 42 imported) but I did not verify a separate cornea bank structure.",
   "Whether Chile performs DCD (donation after circulatory death) at scale, and the DBD/DCD split - not established.",
   "Reimbursement detail: I confirmed the Fonasa/Isapre payer split for transplants but did NOT verify which specific GES/AUGE guarantee covers transplant or post-transplant immunosuppression, nor whether any molecular rejection-surveillance test has a Fonasa code. Treat the reimbursement comments in the summary as unreimbursed-by-default, needing local confirmation.",
   "IVD registration pathway and timeline with ISP (Chile's device regulator) not researched.",
   "GODT/WHO-ONT Chile rows for 2023/2024 could not be extracted - the report PDFs did not render country tables through the tools available."
  ]
 },
 {
  "iso3": "PER",
  "iso2": "",
  "name": "Peru",
  "population": 34600000,
  "donorsPmp": 1.47,
  "donorsPmpYear": 2024,
  "donationModel": "opt_out_soft",
  "registry": "DIGDOT — Dirección General de Donaciones, Trasplantes y Banco de Sangre (MINSA); policy body ONDT (Organismo Nacional de Donación y Trasplante)",
  "registryUrl": "https://www.gob.pe/institucion/minsa",
  "priority": "tier_3",
  "entryMode": "distributor",
  "kidney": 158,
  "liver": 48,
  "heart": 8,
  "lung": 3,
  "dataYear": 2024,
  "confidence": "derived",
  "summary": "Peru is a very low-volume, highly concentrated market: roughly 158 kidney, 48 liver, 8 heart and 3 lung transplants in 2024 against 51 deceased donors (1.47 pmp), one of the lowest rates in Latin America. EsSalud, the contributory social-security insurer, performs by its own account ~90% of national transplant activity (independent reporting puts it at ~85%) and is the ONLY institution doing heart, lung and pancreas; MINSA hospitals run a handful of kidney programmes on SIS (tax-funded) money, and the private sector is a very recent entrant (Clínica Delgado for kidney, Clínica San Pablo accredited for liver in Aug 2024, first private patient placed on the national list Oct 2025). Commercially that means one buyer that matters: EsSalud central procurement, with the Banco de Órganos y Laboratorio de Histocompatibilidad at Hospital Rebagliati as the national reference HLA laboratory and effective technical gatekeeper. Trip hazards for a foreign entrant are (a) volumes too small to support a per-test model outside a national tender, (b) 99.5% of liver activity and the large majority of all activity sitting in Lima, (c) laboratories requiring MINSA accreditation by Ministerial Resolution on a 3-year renewal cycle, and (d) DIGEMID device/IVD registration plus EsSalud's public procurement rules, which favour established distributors and reference-price benchmarking.",
  "centreCount": 12,
  "hlaLabCount": null,
  "unknowns": [
   "Total number of accredited HLA / histocompatibility laboratories: no consolidated public register found. At least six are individually documented by MINSA Ministerial Resolution or institutional source (Rebagliati BOLH, Almanzor Aguinaga Chiclayo, Carlos A. Seguín Escobedo Arequipa, Ramiro Prialé Prialé Huancayo, INEN Lima, INSN San Borja Lima). Six is a floor, not a count — hla_lab_count left null deliberately.",
   "transplant_centre_count = 12 is specifically the number of accredited KIDNEY transplant centres named by Minsa in Nov 2025 (4 MINSA + 6 EsSalud + 1 Armed Forces/Naval + 1 private). It is NOT an all-organ centre total. Liver = 3 centres, heart = 2 (Almenara, INCOR), lung = 1 (Almenara). A separate 25 hospitals are accredited for corneas. A '10 most important transplant centres' figure and an unverified '80 health establishments performing organ and tissue transplants' figure also circulate; neither was traceable to a primary register.",
   "No official ONDT/DIGDOT online statistical registry or downloadable annual report was located. All volume figures come from IRODaT (which sources from Peru) plus press reporting of Minsa/EsSalud statements. There is no Peruvian equivalent of SINTRA or ABTO with a public queryable database.",
   "2025 full-year organ-by-organ figures not confirmed. Partial 2025: 55 deceased donors, 474 people transplanted, 112 kidney transplants (Minsa, Nov 2025), and 1.8 donors pmp quoted in Jan 2026 press — note 55/34.6M = 1.59 pmp, so the 1.8 figure uses an undisclosed denominator or donor definition and was not reconciled.",
   "Consent model classified as soft opt-out with low confidence. Ley 31756 (2023) plus its regulation DS 009-2025-SA establish presumed authorisation for deceased donation unless refusal is recorded on the DNI. Whether the family retains a statutory or de facto veto where no DNI declaration exists was NOT confirmed from the regulation text (lpderecho.pe returned HTTP 403). Historically Peru operated an opt-in DNI tick-box; implementation of the new model is very recent and its practical effect on donor numbers is unproven.",
   "Kidney figure of 158 for 2024 is my sum of IRODaT's deceased (83) and living (75) components; liver 48 = 39 deceased + 9 living. IRODaT does not publish a single combined total.",
   "No data found on: dd-cfDNA, molecular biopsy or HLA-antibody test reimbursement; EsSalud tariff or tender structure for transplant diagnostics; DIGEMID IVD registration timelines; number of dialysis patients or annual dialysis spend; whether any Peruvian laboratory holds ASHI or EFI accreditation (one MINSA page references an 'internationally accredited' histocompatibility service but the accrediting body was not identified).",
   "Per-centre annual transplant volumes are not published; annual_kidney is null for every named centre."
  ]
 },
 {
  "iso3": "URY",
  "iso2": "",
  "name": "Uruguay",
  "population": 3386588,
  "donorsPmp": 19.71,
  "donorsPmpYear": 2024,
  "donationModel": "opt_out_soft",
  "registry": "Instituto Nacional de Donación y Trasplante de Células, Tejidos y Órganos (INDT), Hospital de Clínicas Dr. Manuel Quintela, Montevideo",
  "registryUrl": "https://www.indt.gub.uy/",
  "priority": "tier_3",
  "entryMode": "distributor",
  "kidney": 127,
  "liver": 21,
  "heart": 7,
  "lung": 2,
  "dataYear": 2024,
  "confidence": "verified",
  "summary": "Uruguay is a single-payer market with an unusually clean commercial funnel: the Fondo Nacional de Recursos (FNR) is a national reinsurance fund that pays for every solid-organ transplant for every resident regardless of whether they sit in the public (ASSE) or private (mutualista) sector, and it only pays providers accredited as IMAEs (Institutos de Medicina Altamente Especializada). Provision is therefore mixed public/private but the money is entirely public and centrally rationed, so a diagnostics vendor sells to two entities, not seven: the FNR, which decides what is reimbursed under each técnica's Normativa de Cobertura, and the INDT, which appears to be the sole national histocompatibility laboratory (it types, crossmatches and holds the waiting list for all centres, including the private INU programme, which explicitly sends its patients to INDT). The traps for a foreign entrant are that the whole market is one laboratory and roughly 157 transplants a year (a genuinely tiny consumable volume), that any new test has to be written into an FNR coverage normative before a centre can use it, that all activity is concentrated in Montevideo, and that the lung programme's implants are still done in Argentina at Fundación Favaloro under a bilateral INDT/INCUCAI agreement, so lung recipients are Uruguayan patients rather than Uruguayan procedures.",
  "centreCount": 7,
  "hlaLabCount": 1,
  "unknowns": [
   "Living vs deceased kidney donor split is contradictory. INDT's own parliamentary return gives 127 kidney RECIPIENTS in 2024 (all donor types; the INDT statistical bulletin states living-donor cases are included in kidney and liver counts). IRODaT's 2024 record for Uruguay gives 127 DECEASED-donor kidneys PLUS 11 living-donor kidneys (=138). These cannot both be right and I could not reconcile them. Same issue for liver: INDT 21 total; IRODaT 21 deceased + 2 living.",
   "Lung count is ambiguous and I have reported INDT's figure. INDT records 2 Uruguayan lung transplant recipients in 2024; IRODaT records 0 lung transplants performed in Uruguay in 2024. The FNR states lung implants for Uruguayan patients are performed at Fundación Favaloro in Argentina, so the 2 are almost certainly extraterritorial. A domestic lung programme was still only in training in July 2025 (agreement for Uruguayan surgeons to train at CHUAC, A Coruña, Galicia, aiming for 6-10/yr). Do not treat lung as an addressable in-country procedure volume.",
   "Donors-per-million figure differs by source: IRODaT gives 19.71 pmp for 2024 (67 actual deceased donors); Uruguay's MSP publicly quoted 19.43 pmp for 2024. I used IRODaT's. The absolute deceased donor count of 67 (2024) comes from IRODaT, not from a directly readable INDT table — the INDT bulletin's donor tables are embedded images I could not text-extract and no OCR tool was available in this environment.",
   "Soft vs hard opt-out not established from a primary legal source. Law 18.968 (in force September 2013) establishes presumed consent for adults who have not registered an objection, and I found no explicit statutory family veto. However INDT's described workflow includes a family interview, so I classified it as soft opt-out. The legal weight of the family's view at the bedside is UNVERIFIED. A 2025 bill extending tacit consent to minors passed the Senate; its final status is unconfirmed.",
   "Heart transplant centre list is the weakest of the three. The three named institutions (Círculo Católico, ICI, Sanatorio Americano) come from the FNR 'Técnica Trasplante Cardíaco' page, but I could not independently confirm that all three actively perform heart transplants rather than being cardiac-surgery IMAEs listed on that page. At 7-9 heart transplants nationally per year, three active heart programmes would be surprising. Verify before treating as three separate targets.",
   "Transplant centre count of 7 is my own count of distinct named institutions across the kidney (3, well sourced), liver (2, well sourced) and heart (3, weakly sourced) lists, with Hospital de Clínicas appearing in both kidney and liver. It is NOT a figure published by INDT or FNR. If the heart list is wrong the true count is 5.",
   "Per-centre annual volumes: none confirmed. Hospital de Clínicas' own website is quoted secondhand as '45 to 55 kidney transplants per year' but its site was unreachable (ECONNREFUSED) and I did not verify it, so I left every annual_kidney as null. No volume split at all is available for Hospital Evangélico vs INU.",
   "HLA laboratory count of 1 is an inference, a strong one but an inference. It rests on (a) INU explicitly stating it sends patients to INDT's lab, (b) all national statistics being footnoted to that lab, and (c) INDT's statement that it is 'la única Institución de esta naturaleza'. I did NOT find an explicit statement that no other HLA laboratory exists in Uruguay, and I did not check private/immunology labs doing non-transplant HLA work (HLA-B27, coeliac DQ2/DQ8, pharmacogenetic B*57:01), which may well exist and would be a separate commercial segment.",
   "INDT laboratory's actual platforms and methods are entirely unknown: whether HLA typing is SSO/SSP/SBT/NGS, whether anti-HLA antibody screening uses Luminex single antigen beads, current vendor (One Lambda vs Immucor vs GenDx), contract cycle, and annual test volumes. This is the single most commercially important gap for a diagnostics entrant and none of it is public.",
   "Reimbursement pathway for any novel molecular test (dd-cfDNA, molecular biopsy, virtual crossmatch) is unmapped: I did not establish whether FNR has any mechanism for adding a new diagnostic to a Normativa de Cobertura, who assesses it, or whether Uruguay's MSP requires separate IVD registration/import authorisation for a foreign assay.",
   "Pancreas, intestine and pancreas-kidney transplant activity: IRODaT shows 0 pancreas for 2024 and INDT's programme list covers only kidney, liver, heart, lung and cornea plus haematopoietic cells. Not separately confirmed that no pancreas programme exists.",
   "Full-year 2025 data not available. Only partial: 1 Jan to 31 May 2025 = 41 kidney, 5 liver, 5 heart, 0 lung (51 total), with a waiting list at 31 May 2025 of 700 (kidney 561, heart 83, liver 31, lung 25). INDT's live counter on 30 June 2026 showed 774 waiting, 101 transplanted, 39 real donors year-to-date. IRODaT's preliminary 2025 row (61 deceased donors, 17.94 pmp, 113 kidney, 20 liver, 17 heart, 1 lung) contains a heart figure of 17 that is irreconcilable with INDT's 5 hearts in the first five months of 2025 and 7 in all of 2024 — treat IRODaT 2025 as unreliable."
  ]
 },
 {
  "iso3": "CRI",
  "iso2": "",
  "name": "Costa Rica",
  "population": 5193000,
  "donorsPmp": 12.71,
  "donorsPmpYear": 2025,
  "donationModel": "opt_in",
  "registry": "Secretaría Ejecutiva Técnica de Donación y Trasplante de Órganos y Tejidos (SETDT), Ministerio de Salud — operational provider is the Caja Costarricense de Seguro Social (CCSS)",
  "registryUrl": "https://www.ministeriodesalud.go.cr/index.php/biblioteca-de-archivos-left/documentos-ministerio-de-salud/vigilancia-de-la-salud/analisis-de-situacion-salud/trasplante-de-organos-y-tejidos",
  "priority": "tier_3",
  "entryMode": "distributor",
  "kidney": 104,
  "liver": 53,
  "heart": 6,
  "lung": 16,
  "dataYear": 2025,
  "confidence": "verified",
  "summary": "Costa Rica is a single-payer, single-provider market: the Caja Costarricense de Seguro Social (CCSS) both funds and delivers essentially all solid organ transplantation through five Ministry-authorised public hospitals, four of them clustered in San José, while the Ministry of Health's SETDT acts as regulator, registry and the body that grants and renews establishment authorisations. Volumes are small in absolute terms (179 solid organ transplants in 2025, of which 104 kidney) but the donor rate is rising fast — deceased donors more than doubled from 29 in 2024 to 66 in 2025 (5.58 to 12.71 pmp) — and Costa Rica is now the only Central American country doing lung transplants, so the growth trajectory is far better than the headcount suggests. For a foreign diagnostics entrant the traps are structural rather than clinical: there is effectively one buying decision, not five, because the CCSS has approved a centralised national Seroteca (serum bank) to run donor-recipient compatibility testing for all five centres; sales route in through CCSS institutional tendering, which requires Ministry of Health IVD registration and in practice a Costa Rican legal representative or distributor; and the whole donation-and-transplant system was rebuilt from 2016 under AECID funding with technical cooperation from Spain's ONT, so protocols, terminology and reference practice are Spanish-derived and Spanish-language documentation is not optional.",
  "centreCount": 5,
  "hlaLabCount": null,
  "unknowns": [
   "HLA / histocompatibility laboratory count could not be established. No source names or counts Costa Rica's histocompatibility labs. What is confirmed: the CCSS has approved a national 'Seroteca' (centralised serum bank) to perform donor-recipient compatibility testing centrally for all five transplant centres, and the CCSS has incorporated flow cytometry crossmatch into its solid organ transplant laboratory protocols. Whether HLA typing sits in one national lab or in per-hospital immunology labs is unverified.",
   "Living vs deceased donor split for 2025 is not published by organ. Total 2025 solid organ transplants were 179, of which 138 were from deceased donors, implying ~41 living-donor transplants (almost certainly kidney), but the Ministry did not break this out. The 2024 IRODaT split was kidney 44 deceased / 41 living, liver 26 deceased / 1 living.",
   "Data source conflict for 2024. The Ministry's Memoria reported 40 kidney, 23 liver, 8 heart and 6 lung transplants from deceased donors in 2024; IRODaT's validated 2024 record shows 44 kidney, 26 liver, 7 heart, 8 pancreas and NO lung transplants reported. Treat 2024 organ-level figures as soft. The 2025 figures used here are Ministry/SETDT and are internally consistent (104+53+16+6=179).",
   "Pancreas transplant volume for 2025 not found. IRODaT recorded 8 pancreas transplants in 2024; the 2025 Ministry release lists only kidney, liver, lung and heart.",
   "Transplant centre count of 5 rests on a single news source (elmundo.cr) reporting the Ministry-authorised CCSS hospitals. The primary list of authorised establishments is in the Memoria de Donación y Trasplante 2024, which is published on the Ministry of Health site but sits behind a WAF that returned 403 / 'actividad sospechosa' to every retrieval attempt. Obtain that PDF directly for the definitive list.",
   "Private-sector transplant authorisations are unverified. One secondary source referred to two private hospitals authorised for liver transplantation, and an older source claimed 13% of transplants occur in private facilities, but neither could be confirmed against the Ministry's authorisation list and the 13% figure appears to date from pre-2014 transplant-tourism reporting. Assume public-only until the Memoria confirms otherwise.",
   "Current operational status of two programmes is unclear: Hospital San Juan de Dios's deceased-donor kidney programme (a closure order was reported) and any adult or paediatric heart programme outside Hospital Calderón Guardia. Six heart transplants were performed nationally in 2025 but the performing centre(s) are not named in any source found.",
   "Population figure of 5,193,000 is derived, not independently sourced: it is the denominator implied by the official 66 donors / 12.71 pmp, and matches the UNFPA-based denominator IRODaT used for 2024 (29 donors / 5.58 pmp = 5.20M). Note that IMF/Statista put Costa Rica's 2025 population at 5.37M, so pmp figures from different publishers will not reconcile exactly.",
   "Waiting list size for 2025 not found. The most recent figure located was 443 patients awaiting a kidney transplant as of December 2024, with a first-half-2024 mean wait of 1,524 days.",
   "No information found on whether dd-cfDNA, molecular biopsy or high-resolution HLA typing are reimbursed or in use anywhere in the CCSS system, nor on the Ministry of Health IVD registration pathway timelines and fees."
  ]
 },
 {
  "iso3": "ECU",
  "iso2": "",
  "name": "Ecuador",
  "population": null,
  "donorsPmp": 3.91,
  "donorsPmpYear": 2024,
  "donationModel": "opt_out_soft",
  "registry": "INDOT - Instituto Nacional de Donación y Trasplante de Órganos, Tejidos y Células (Ministerio de Salud Pública)",
  "registryUrl": "http://www.donaciontrasplante.gob.ec/indot/estadisticas-indot/",
  "priority": "tier_3",
  "entryMode": "distributor",
  "kidney": 142,
  "liver": 15,
  "heart": 13,
  "lung": 1,
  "dataYear": 2025,
  "confidence": "verified",
  "summary": "Provision is overwhelmingly public and concentrated in the social-security network: IESS hospitals (Carlos Andrade Marín in Quito, Teodoro Maldonado Carbo in Guayaquil, José Carrasco Arteaga in Cuenca) carry most solid-organ activity alongside MSP hospitals and the charitable Junta de Beneficencia de Guayaquil, so the payer is the state, via the MSP budget or IESS social insurance, not patients or private insurers. Volumes are small: 142 kidney, 15 liver, 13 heart and 1 lung transplant in 2025, against about 1,057 patients on the national kidney waiting list, and cornea makes up 61 percent of all reported transplants, so the addressable buyer set is at most six INDOT-accredited histocompatibility laboratories. The trip hazards are regulatory and financial rather than clinical: INDOT accreditation of the laboratory is a legal precondition for any transplant testing, sales go through SERCOP public procurement, and IESS payment delays plus periodic public-health budget squeezes are a known working-capital risk; the one structural positive is that Ecuador is fully USD-denominated, so there is no FX exposure.",
  "centreCount": null,
  "hlaLabCount": 6,
  "unknowns": [
   "Number of distinct transplant CENTRES (hospitals). INDOT's 2024 Rendición de Cuentas reports accredited PROGRAMMES, not unique hospitals: kidney 9 (7 adult, 1 adult/paediatric, 1 paediatric), adult liver 2 plus 1 paediatric pre/post-liver evaluation unit, heart 2, lung 1, cornea 39, HPC 4, histocompatibility labs 6, cord blood banks 3, tissue banks 2, definitive tissue storage 14, total 83 accredited programmes. I could not establish how many separate hospitals these map to, so transplant_centre_count is returned null rather than guessed.",
   "Deceased donor counts and donors-pmp for 2025 and 2026. INDOT's published statistical bulletins give transplants by organ but not donor counts, and the 2025 Rendición de Cuentas was not located.",
   "Two different pmp figures exist for 2024 and I could not reconcile the denominators: IRODaT/GODT report 72 actual deceased donors = 3.91 pmp (67 utilised = 3.64 pmp), while INDOT's own 2024 Rendición de Cuentas states 4.25 pmp. I returned the IRODaT/GODT figure as the internationally comparable one.",
   "Population. The IRODaT denominator implies roughly 18.4 million, but I did not verify an INEC/World Bank census figure, so population is returned null rather than back-calculated.",
   "Whether presumed consent operates as soft or hard opt-out in practice. Art. 29 of the Ley Orgánica de Donación y Trasplante makes every person over 18 a donor at death unless an objection is registered on the cédula, which is legally a hard opt-out, but I could not verify from a primary source whether families exercise a veto in practice. Classified opt_out_soft on the regional norm; treat as provisional.",
   "Names and locations of the 6 INDOT-accredited histocompatibility laboratories. Only two are individually confirmed by name (HTMC Guayaquil, HCAM Quito). One IESS source calls HTMC 'the only public histocompatibility laboratory of the IESS' while another states HCAM's lab is INDOT-accredited; I could not date-resolve the two claims.",
   "Per-centre transplant volumes. No centre-level breakdown is published by INDOT, so annual_kidney is null for every named centre.",
   "Which hospitals hold the 2 accredited adult heart-transplant programmes. Not established from any source.",
   "Whether any private-sector transplant activity or private-pay histocompatibility testing exists, and its size.",
   "Reimbursement mechanism and price points for molecular or HLA transplant diagnostics. No national tariff schedule equivalent was located.",
   "IRODaT's Ecuador 2024 page appeared to show 'Pancreas 17' at 0.92 pmp, identical to its liver row, whereas INDOT's own 2024 report lists 17 heart and 17 liver and no pancreas. The IRODaT pancreas row is very likely a mislabelled heart figure, but this is unresolved.",
   "Web search budget for this session was exhausted before I could confirm additional named kidney centres (Hospital Eugenio Espejo, Hospital Luis Vernaza, Hospital Baca Ortiz are plausible but UNVERIFIED and are therefore not listed)."
  ]
 },
 {
  "iso3": "PAN",
  "iso2": "",
  "name": "Panama",
  "population": 4600000,
  "donorsPmp": 3.33,
  "donorsPmpYear": 2024,
  "donationModel": "opt_in",
  "registry": "Organización Panameña de Trasplantes (OPT), Ministerio de Salud (MINSA) — created by Ley 3 de 8 de febrero de 2010; operational activity sits with the Programa Nacional de Trasplante of the Caja de Seguro Social (CSS)",
  "registryUrl": "https://www.minsa.gob.pa/destacado/organizacion-panamena-de-transplante",
  "priority": "tier_3",
  "entryMode": "distributor",
  "kidney": 48,
  "liver": 6,
  "heart": null,
  "lung": 0,
  "dataYear": 2024,
  "confidence": "derived",
  "summary": "Panama is a very small, almost entirely public transplant market: essentially all activity sits inside the Caja de Seguro Social (social security), now concentrated at Ciudad de la Salud in Panama City, with Hospital Santo Tomás on the MINSA side, and the state pays for everything including immunosuppression. Volumes are tiny and kidney-dominated (48 kidney and 6 liver transplants nationally in 2024 per IRODaT; 41 kidney transplants at Ciudad de la Salud in 2025), against 3,000–3,700 dialysis patients and roughly 250–330 people on the kidney waiting list, so the constraint is deceased donation (3.33 donors pmp) rather than surgical capacity. The commercial traps for a foreign diagnostics entrant are that there is effectively one buyer and one laboratory (the CSS Laboratorio Nacional de Trasplante, the sole histocompatibility lab for the national programme), procurement runs through CSS/MINSA public tender in balboas at USD parity with slow payment cycles that have already disrupted MINSA's private dialysis contracts, registration goes through the Dirección Nacional de Farmacia y Drogas, and the addressable volume is small enough that a distributor-led, reference-lab model makes far more sense than any direct investment.",
  "centreCount": null,
  "hlaLabCount": 1,
  "unknowns": [
   "Official count of authorised transplant centres. Ley 3 de 2010 requires MINSA authorisation of centres, but no published register or count was found. Five facilities are named in press reporting as sites where kidney transplants have been performed (Ciudad de la Salud, Complejo Hospitalario Dr. Arnulfo Arias Madrid, Hospital de Especialidades Pediátricas Vía España, Hospital Santo Tomás, Hospital Dr. Rafael Hernández in David), but reporting also says the CSS programme has been centralised at Ciudad de la Salud, so an unknown number of those are historical rather than currently active. transplant_centre_count returned null.",
   "Heart transplants in 2024 could not be resolved. IRODaT reports no heart transplants for Panama in 2024, while a Panamanian health magazine states six heart transplants were performed in 2024 and in the same article gives a cumulative national total of only four cardiac transplants since 1985. The two cannot both be true and no registry confirmation was found, so heart returned null. The true figure is somewhere in the range 0–6.",
   "Whether IRODaT's 2024 'no transplants reported' for heart and lung means zero performed or not returned to the registry. Lung was set to 0 because separate Panamanian reporting describes lung transplantation as planned rather than established; heart was not.",
   "Reconciliation of national vs institutional kidney figures. IRODaT gives 48 kidney transplants nationally in 2024 (29 deceased donor + 19 living), whereas La Prensa reported 29 kidney transplants in the CSS during 2024 and GODT reported only 20 kidney transplants for 2023. The living/deceased split in particular is not independently corroborated.",
   "No 2025 national dataset. The only 2025 figure found is centre-level (41 kidney transplants at Ciudad de la Salud). National 2025 totals for any organ, and the 2025 deceased donor rate, were not found.",
   "Exact national population figure used for the pmp calculation. IRODaT states '4.6 million'; the precise denominator and its source (INEC Panama vs UN) were not confirmed.",
   "Number of HLA/histocompatibility laboratories. The CSS Laboratorio Nacional de Trasplante is described as the sole institution performing histocompatibility studies for the national transplant programme, so hla_lab_count is given as 1. Whether any private hospital or commercial laboratory in Panama performs HLA typing or DSA testing outside that programme was not established, and the lab's actual platforms (Luminex SAB, NGS typing, vendor) could not be confirmed — the CSS press releases describe DNA extraction, amplification and typing in general terms only and css.gob.pa returned HTTP 403 to direct retrieval.",
   "Whether any private hospital (e.g. Pacífica Salud/Punta Pacífica, Hospital Nacional) runs a solid-organ transplant programme. The search budget was exhausted before this could be checked.",
   "Reimbursement detail: whether dd-cfDNA, molecular biopsy or DSA monitoring has any CSS or MINSA funding code. No Panamanian equivalent of a national test tariff or coverage list was found.",
   "Legislative status. Ley 3 de 2010 is in force and operates on express consent (opt-in) with strong de facto family veto (~50% family refusal reported). A replacement law has been drafted repeatedly (MINSA anteproyecto 2017; Proyecto de Ley 1044 debated Jan 2024) and presumed consent has been discussed, but whether any of it has been enacted as of August 2026 was not confirmed. Note that at least one secondary source describes Panama as already having presumed consent; that appears to be wrong but was not definitively disproved against the statute text.",
   "Waiting list figures are from undated press reporting (kidney 326 / liver 4 / bone marrow 25 / cornea 85 in one source; kidney 256 in another) and no official OPT registry publication was located.",
   "The registry named in the task brief as 'ONTT' does not appear to exist under that name. Panama's registry body is the Organización Panameña de Trasplantes (OPT) under MINSA, with the CSS Coordinación Nacional de Trasplante operating alongside it. No OPT statistical publication or data portal was found — all activity data comes from press releases, IRODaT and GODT."
  ]
 },
 {
  "iso3": "DOM",
  "iso2": "",
  "name": "Dominican Republic",
  "population": 11500000,
  "donorsPmp": 2.11,
  "donorsPmpYear": 2024,
  "donationModel": "opt_in",
  "registry": "INCORT (Instituto Nacional de Coordinación de Trasplantes), Ministerio de Salud Pública",
  "registryUrl": "https://incortrd.com/",
  "priority": "tier_3",
  "entryMode": "distributor",
  "kidney": 102,
  "liver": 2,
  "heart": null,
  "lung": null,
  "dataYear": 2024,
  "confidence": "derived",
  "summary": "Very small, kidney-dominated market: roughly 100 kidney transplants a year across five centres, with liver in low single digits, three heart transplants in national history and no lung programme found. Payment is the binding constraint: only kidney transplant is covered by the social security system (an annual package of about RD$3.5M per approved patient covering the procedure, donor workup and post-transplant medication, through contributory SENASA/ARS or the subsidised regime), while liver, heart, lung, pancreas and bone marrow have no PDSS cover and are paid out of pocket at over RD$2M, which INCORT's own director says is unreachable for more than 90% of the population. A foreign diagnostics entrant should expect the true addressable volume to be about 100 kidney recipients a year plus a waiting list of roughly 550-570, HLA/crossmatch capacity concentrated in only two or three labs (HOMS in Santiago is described as the only one in the north), and no reimbursement line for any novel post-transplant monitoring assay, so any dd-cfDNA or molecular surveillance product would have to be sold privately or bundled into a centre's existing per-patient package until INCORT and the Consejo Nacional de Seguridad Social create a code for it.",
  "centreCount": 5,
  "hlaLabCount": null,
  "unknowns": [
   "Heart transplant volume for 2024: IRODaT shows no data (dash), not zero. Nationally only 3 heart transplants have ever been performed (1972-2024, INCORT/El Caribe), so annual volume is 0 or near 0, but I will not state a number that no source publishes.",
   "Lung transplants: no lung transplant programme and no lung transplant volume found in any source. Not reported by IRODaT, not listed in INCORT historical data. Returned as null rather than 0 because absence of reporting is not the same as a published zero.",
   "Number of HLA/histocompatibility laboratories nationally: NOT ESTABLISHED. Only one is directly confirmed and named (HOMS, Santiago, described as the only one in the northern region). INCORT historical data records an HLA/crossmatch facility set up at Hospital Salvador B. Gautier in 1989 and a general reference exists to a public histocompatibility laboratory and tissue bank, but I found no register, no count, and no confirmation of which labs are currently operating. hla_lab_count returned null.",
   "Whether any Dominican laboratory performs molecular (SSO/SSP/NGS) HLA typing as opposed to serological typing. The only lab description found (HOMS) explicitly describes serological phenotype typing plus crossmatch. No evidence found of NGS-based HLA typing, single-antigen bead / Luminex DSA testing, or dd-cfDNA testing anywhere in the country.",
   "INCORT does not publish a machine-readable or downloadable register of accredited transplant centres. The count of 5 (3 accredited for deceased + living donors, 2 for living donors only) comes from press reporting that cites INCORT, not from a primary INCORT document. Treat the centre count as press-sourced, not registry-verified.",
   "Organ-by-organ volumes for full-year 2025: not published. Only H1 2025 (37 renal, 1 hepatic) and H1 2026 (27 renal) are available from press. The IRODaT 2025 entry is internally inconsistent with that press reporting (IRODaT shows 0 deceased-donor kidney transplants in 2025, while INCORT reported 12 deceased-donor kidney transplants in H1 2025 alone), so I used 2024 as the data year.",
   "Deceased donor counts for 2024 and 2025 differ between sources: IRODaT gives 24 actual / 22 utilised for 2024 and 13 actual for 2025; INCORT press statements give 22 for 2024 and 12 for 2025. The pmp figure of 2.11 is IRODaT's 'actual donor' basis. The discrepancy is unresolved.",
   "Pancreas and bone marrow annual volumes for 2024 not found (only cumulative historical totals).",
   "Consent model classified as opt_in on the basis of Ley 329-98 requiring express, free and informed consent plus consistent reporting that the family always has the final word. I could not retrieve the operative articles of the law verbatim — the published text was unavailable at the sources I reached — and there are references to Ley 329-98 having been amended or superseded that I could not resolve. The classification is well supported but not verified against primary statute text.",
   "Waiting list composition: total 570 (H1 2026) and 548 for kidney reported separately (2025). Not broken down by organ in a single consistent source.",
   "Reimbursement: no evidence of any tariff, code or CNSS/PDSS listing for HLA typing, DSA monitoring, protocol biopsy or any post-transplant molecular surveillance test. Whether HLA typing is billed inside the RD$3.5M kidney package or separately is unknown.",
   "IVD regulatory route: the requirements of DIGEMAPS (Dirección General de Medicamentos, Alimentos y Productos Sanitarios) for importing and registering an in vitro diagnostic device in the Dominican Republic were not researched and are not verified here.",
   "Whether the historic centres in INCORT's own history page (Hospital Cabral y Báez Santiago, Hospital Dr. Luis E. Aybar, Hospital Infantil Dr. Robert Reid Cabral, Hospital Padre Billini, Hospital Salvador B. Gautier) still run active solid-organ transplant programmes, or whether their activity has been consolidated into CECANOT within the Ciudad Sanitaria Dr. Luis Eduardo Aybar complex."
  ]
 }
] as unknown as A.Country[];

export const AMERICAS_SITES = [
 {
  "id": "bra-hospital-do-rim-funda-o-oswaldo-ramos-unifesp-listed",
  "name": "Hospital do Rim (Fundação Oswaldo Ramos / UNIFESP) - listed in RBT as 'Hospital do Rim - Medina'",
  "short": "Hospital do Rim (Fundação Oswaldo Ramo…",
  "city": "São Paulo",
  "region": "SP (Sudeste)",
  "iso3": "BRA",
  "lat": -23.551,
  "lon": -46.633,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "pancreas"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 977,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": "ABTO RBT 2024 (Ano XXXI Nº4), centre-level table 'RIM', p.90 - 771 deceased-donor + 206 living-donor kidney transplants in 2024; also 16 pancreas-kidney. https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-irmandade-santa-casa-de-miseric-rdia-de-porto-alegre",
  "name": "Irmandade Santa Casa de Misericórdia de Porto Alegre (ISCMPA / ISCMPOA)",
  "short": "Irmandade Santa Casa de Misericórdia d…",
  "city": "Porto Alegre",
  "region": "RS (Sul)",
  "iso3": "BRA",
  "lat": -30.034,
  "lon": -51.217,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "heart",
   "lung"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 315,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": "ABTO RBT 2024 centre tables: kidney 312 (Valter Duro Garcia) + 3 (Maria Lucia Zanotelli); heart 11 (Fernando Antônio Lucchese); lung 25 (José de Jesus Peixoto Camargo). HLA lab confirmed in RBT 2024/2025 'Laboratórios de Imunobiologia' list: 'Laboratório de Imunologia de Transplantes - Irmandade da Santa Casa de Misericórdia', Jorge Neumann. https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-hsfa-abto-centre-code-rio-de-janeiro-full-institutio",
  "name": "HSFA (ABTO centre code), Rio de Janeiro - full institution name not expanded in the registry",
  "short": "HSFA (ABTO centre code), Rio de Janeir…",
  "city": "Rio de Janeiro",
  "region": "RJ (Sudeste)",
  "iso3": "BRA",
  "lat": -22.907,
  "lon": -43.173,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 269,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": "ABTO RBT 2024 centre-level table 'RIM': 'HSFA - Deise Rosa de Boni Monteiro de Carvalho', 265 deceased + 4 living. https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-santa-casa-de-juiz-de-fora-scjf",
  "name": "Santa Casa de Juiz de Fora (SCJF)",
  "short": "Santa Casa de Juiz de Fora (SCJF)",
  "city": "Juiz de Fora",
  "region": "MG (Sudeste)",
  "iso3": "BRA",
  "lat": -21.764,
  "lon": -43.35,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 236,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": "ABTO RBT 2024 centre-level table 'RIM': 'SCJF - Gustavo Fernandes Ferreira', 198 deceased + 38 living. https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-imip-instituto-de-medicina-integral-prof-fernando-fi",
  "name": "IMIP - Instituto de Medicina Integral Prof. Fernando Figueira",
  "short": "IMIP - Instituto de Medicina Integral …",
  "city": "Recife",
  "region": "PE (Nordeste)",
  "iso3": "BRA",
  "lat": -8.048,
  "lon": -34.877,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 201,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": "ABTO RBT 2024 centre-level table 'RIM': three IMIP teams, 188 (Luis Gonzaga de Negreiros Filho) + 12 (Cassio Tamara Ribeiro) + 1 (Cláudio Moura Lacerda de Lima). https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-hsi-hospital-santa-isabel-per-abto-centre-code-hsi",
  "name": "HSI (Hospital Santa Isabel, per ABTO centre code HSI)",
  "short": "HSI (Hospital Santa Isabel, per ABTO c…",
  "city": "Blumenau",
  "region": "SC (Sul)",
  "iso3": "BRA",
  "lat": -26.919,
  "lon": -49.066,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "heart"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 177,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": "ABTO RBT 2024 centre tables: kidney 162 deceased + 15 living (Denise Rodrigues Pedroso); heart 5 (Frederico José di Giovanni). https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-hnsr-abto-centre-code-campo-largo-full-institution-n",
  "name": "HNSR (ABTO centre code), Campo Largo - full institution name not expanded in the registry",
  "short": "HNSR (ABTO centre code), Campo Largo -…",
  "city": "Campo Largo",
  "region": "PR (Sul)",
  "iso3": "BRA",
  "lat": -25.459,
  "lon": -49.528,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 160,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": "ABTO RBT 2024 centre-level table 'RIM': three HNSR teams, 108 + 2 + 50. https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-hospital-de-cl-nicas-de-porto-alegre-hcpa",
  "name": "Hospital de Clínicas de Porto Alegre (HCPA)",
  "short": "Hospital de Clínicas de Porto Alegre (…",
  "city": "Porto Alegre",
  "region": "RS (Sul)",
  "iso3": "BRA",
  "lat": -30.034,
  "lon": -51.217,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "heart",
   "lung"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 147,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "ABTO RBT 2024 centre tables: kidney 141 deceased + 6 living (Roberto Ceratti Manfro); heart 11 (Livia Adams Goldraich); lung 10 (Cristiano Feijó Andrade). HLA lab confirmed in RBT 'Laboratórios de Imunobiologia' list: 'Serviço de Imunologia - Hospital de Clinicas de Porto Alegre', Luiz Fernando Job Jobim. https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-real-hospital-portugu-s-de-benefic-ncia-em-pernambuc",
  "name": "Real Hospital Português de Beneficência em Pernambuco (RHP)",
  "short": "Real Hospital Português de Beneficênci…",
  "city": "Recife",
  "region": "PE (Nordeste)",
  "iso3": "BRA",
  "lat": -8.048,
  "lon": -34.877,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 145,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "ABTO RBT 2024 centre-level table 'RIM': 'RHP - Frederico Castelo Branco Cavalcante', 134 deceased + 11 living. https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-hospital-das-cl-nicas-da-faculdade-de-medicina-de-bo",
  "name": "Hospital das Clínicas da Faculdade de Medicina de Botucatu, UNESP",
  "short": "Hospital das Clínicas da Faculdade de …",
  "city": "Botucatu",
  "region": "SP (Sudeste)",
  "iso3": "BRA",
  "lat": -22.887,
  "lon": -48.445,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "heart"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 142,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "ABTO RBT 2024 centre tables: kidney 127 deceased + 15 living; heart 9 (Marcello Laneza Felicio). https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-hospital-das-cl-nicas-da-faculdade-de-medicina-da-us",
  "name": "Hospital das Clínicas da Faculdade de Medicina da USP (HCFMUSP), including InCor",
  "short": "Hospital das Clínicas da Faculdade de …",
  "city": "São Paulo",
  "region": "SP (Sudeste)",
  "iso3": "BRA",
  "lat": -23.551,
  "lon": -46.633,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "lung"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 135,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "ABTO RBT 2024 centre tables: kidney 95 deceased + 40 living ('HCFMUSP - William Carlos Nahas'); heart 39 ('HC - Fabio Biscegli Jatene') + 11 ('HC - Marcelo Jatene'); lung 35 ('HC - Paulo Pêgo'); adult liver programme listed ('HC - Fígado adulto'). Note: the RBT immunobiology list includes 'Lab. de Imunologia / HLA - FUNDACAO ZERBINI' (Jorge Kalil) in São Paulo, associated with InCor, but the registry does not explicitly attribute it to HCFMUSP, so has_hla_lab left null. https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-hfbs-abto-centre-code-rio-de-janeiro-full-institutio",
  "name": "HFBS (ABTO centre code), Rio de Janeiro - full institution name not expanded in the registry",
  "short": "HFBS (ABTO centre code), Rio de Janeir…",
  "city": "Rio de Janeiro",
  "region": "RJ (Sudeste)",
  "iso3": "BRA",
  "lat": -22.907,
  "lon": -43.173,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 134,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "ABTO RBT 2024 centre-level table 'RIM': 'HFBS - Patricia Elizabeth de Sá Finni', 133 deceased + 1 living. https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-hospital-de-cl-nicas-da-unicamp",
  "name": "Hospital de Clínicas da UNICAMP",
  "short": "Hospital de Clínicas da UNICAMP",
  "city": "Campinas",
  "region": "SP (Sudeste)",
  "iso3": "BRA",
  "lat": -22.906,
  "lon": -47.061,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "heart"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 131,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "ABTO RBT 2024 centre tables: kidney 127 deceased + 4 living (Marilda Mazzali); heart 3 (O. Petrucci). HLA lab confirmed in RBT 'Laboratórios de Imunobiologia' list: 'Lab. de Imunogenética e Transplantes - UNICAMP', Maria Helena Stangler Kraemer (a second Campinas lab, 'Lab. de HLA - Fund de Desenvolvimento da UNICAMP', is also listed). https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-hmac-abto-centre-code-campina-grande-do-sul-full-ins",
  "name": "HMAC (ABTO centre code), Campina Grande do Sul - full institution name not expanded in the registry",
  "short": "HMAC (ABTO centre code), Campina Grand…",
  "city": "Campina Grande do Sul",
  "region": "PR (Sul)",
  "iso3": "BRA",
  "lat": -25.305,
  "lon": -49.055,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 119,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "ABTO RBT 2024 centre-level table 'RIM': 118 (Carlos Gustavo W. C. Marmanillo) + 1 (Mauro Roberto Duarte Monteiro). https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-hospital-de-base-de-s-o-jos-do-rio-preto",
  "name": "Hospital de Base de São José do Rio Preto",
  "short": "Hospital de Base de São José do Rio Pr…",
  "city": "São José do Rio Preto",
  "region": "SP (Sudeste)",
  "iso3": "BRA",
  "lat": -20.812,
  "lon": -49.376,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "heart"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 102,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "ABTO RBT 2024 centre tables: kidney 99 deceased + 3 living ('S.J.Rio Preto - H.Base (RIM)'); heart 1 (Ulisses A. Croti). Two HLA labs are listed in São José do Rio Preto in the RBT immunobiology list ('Instituto de Urologia e Nefrologia', Mário Abbud Filho; 'Lab. de Imunogenética Molecular - Fund. Fac. Reg. Medicina') but neither is explicitly attributed to Hospital de Base. https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "bra-hospital-israelita-albert-einstein",
  "name": "Hospital Israelita Albert Einstein",
  "short": "Hospital Israelita Albert Einstein",
  "city": "São Paulo",
  "region": "SP (Sudeste)",
  "iso3": "BRA",
  "lat": -23.551,
  "lon": -46.633,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "lung"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 59,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "ABTO RBT 2024 centre tables: kidney 57 (Marcelino Souza Durão Junior) + 2 (Fernando Bacal); liver 41 (Marcelo Bruno de Rezende); heart 33 (Fernando Bacal); lung 10 (Marcos Samano). HLA lab confirmed in RBT 'Laboratórios de Imunobiologia' list: 'Lab. de Técnicas Especiais - Hospital Albert Einstein', Margareth Torres. https://site.abto.org.br/wp-content/uploads/2025/05/rbt-n4-2024-associados.pdf"
 },
 {
  "id": "can-university-of-alberta-hospital-transplant-services",
  "name": "University of Alberta Hospital Transplant Services",
  "short": "University of Alberta Hospital Transpl…",
  "city": "Edmonton",
  "region": "Alberta",
  "iso3": "CAN",
  "lat": 53.546,
  "lon": -113.494,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "lung",
   "pancreas",
   "intestine"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory - Transplant Programs in Canada (Dec 2024), Table 1; organ scope from University of Alberta Department of Surgery, Division of Transplantation (states it provides all heart, lung, liver, intestinal and islet transplants for Alberta and the Prairie provinces). HLA: Alberta Public Laboratories Histocompatibility Laboratory, Edmonton (ASHI directory 2025, 02-9-AB-02-1)"
 },
 {
  "id": "can-foothills-medical-centre-southern-alberta-transplant",
  "name": "Foothills Medical Centre (Southern Alberta Transplant Program)",
  "short": "Foothills Medical Centre (Southern Alb…",
  "city": "Calgary",
  "region": "Alberta",
  "iso3": "CAN",
  "lat": 51.045,
  "lon": -114.058,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 1. Kidney-only inferred from University of Alberta statement that UAH performs all Alberta heart/lung/liver/intestinal/islet transplants - not independently confirmed on a Calgary source. HLA: Alberta Precision Laboratories Transplant Laboratory South, Calgary (ASHI 2025, 11-9-AB-01-1)"
 },
 {
  "id": "can-alberta-children-s-hospital-southern-alberta-transpl",
  "name": "Alberta Children's Hospital (Southern Alberta Transplant Program)",
  "short": "Alberta Children's Hospital (Southern …",
  "city": "Calgary",
  "region": "Alberta",
  "iso3": "CAN",
  "lat": 51.045,
  "lon": -114.058,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 1. Listed as a participating transplant facility; organ scope not established in this session"
 },
 {
  "id": "can-vancouver-general-hospital",
  "name": "Vancouver General Hospital",
  "short": "Vancouver General Hospital",
  "city": "Vancouver",
  "region": "British Columbia",
  "iso3": "CAN",
  "lat": 49.283,
  "lon": -123.121,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "liver",
   "lung",
   "pancreas"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 2; organ scope from BC Transplant 'Refer a Patient for Transplant' (transplant.bc.ca). HLA: Vancouver General Hospital Immunology Laboratory (ASHI 2025, 10-9-BC-02-1)"
 },
 {
  "id": "can-providence-health-care-st-paul-s-hospital",
  "name": "Providence Health Care - St. Paul's Hospital",
  "short": "Providence Health Care - St. Paul's Ho…",
  "city": "Vancouver",
  "region": "British Columbia",
  "iso3": "CAN",
  "lat": 49.283,
  "lon": -123.121,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart",
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 2; organ scope from BC Transplant referral pages (transplant.bc.ca / providencehealthcare.org)"
 },
 {
  "id": "can-bc-children-s-hospital",
  "name": "BC Children's Hospital",
  "short": "BC Children's Hospital",
  "city": "Vancouver",
  "region": "British Columbia",
  "iso3": "CAN",
  "lat": 49.283,
  "lon": -123.121,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart",
   "kidney",
   "liver",
   "lung"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 2; paediatric organ scope from BC Transplant"
 },
 {
  "id": "can-health-sciences-centre-transplant-manitoba-gift-of-l",
  "name": "Health Sciences Centre (Transplant Manitoba - Gift of Life Program)",
  "short": "Health Sciences Centre (Transplant Man…",
  "city": "Winnipeg",
  "region": "Manitoba",
  "iso3": "CAN",
  "lat": 49.895,
  "lon": -97.138,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 74,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 3. Kidney-only confirmed by CIHI 2024 data tables Table 5 (Manitoba total transplants 74, all kidney). annual_kidney is the Manitoba provincial total, not a centre-level published figure"
 },
 {
  "id": "can-children-s-hospital-of-winnipeg-transplant-manitoba",
  "name": "Children's Hospital of Winnipeg (Transplant Manitoba)",
  "short": "Children's Hospital of Winnipeg (Trans…",
  "city": "Winnipeg",
  "region": "Manitoba",
  "iso3": "CAN",
  "lat": 49.895,
  "lon": -97.138,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 3; organ scope not established"
 },
 {
  "id": "can-queen-elizabeth-ii-health-sciences-centre-multi-orga",
  "name": "Queen Elizabeth II Health Sciences Centre (Multi-Organ Transplant Program of Atlantic Canada)",
  "short": "Queen Elizabeth II Health Sciences Cen…",
  "city": "Halifax",
  "region": "Nova Scotia",
  "iso3": "CAN",
  "lat": 44.649,
  "lon": -63.576,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "pancreas"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 141,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 4; organ scope from MOTP Atlantic Canada (motpatlantic.ca). annual_kidney is the Nova Scotia provincial total from CIHI 2024 data tables Table 5 (NS: 141 kidney, 41 liver, 6 heart, 0 lung), which covers all four Atlantic provinces' patients. HLA: NSHA HLA Laboratory, QEII (ASHI 2025, 09-9-NS-01-1); MOTP also advertises a Tissue Typing (HLA) Service"
 },
 {
  "id": "can-iwk-health-centre-multi-organ-transplant-program-of-",
  "name": "IWK Health Centre (Multi-Organ Transplant Program of Atlantic Canada)",
  "short": "IWK Health Centre (Multi-Organ Transpl…",
  "city": "Halifax",
  "region": "Nova Scotia",
  "iso3": "CAN",
  "lat": 44.649,
  "lon": -63.576,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 4; paediatric site, organ scope not established"
 },
 {
  "id": "can-university-health-network-toronto-general-hospital-a",
  "name": "University Health Network - Toronto General Hospital (Ajmera Transplant Centre)",
  "short": "University Health Network - Toronto Ge…",
  "city": "Toronto",
  "region": "Ontario",
  "iso3": "CAN",
  "lat": 43.653,
  "lon": -79.383,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "lung",
   "pancreas"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 5; UHN describes the largest kidney transplant programme in Canada (uhn.ca). HLA: UHN Regional Histocompatibility Laboratory (ASHI 2025, 06-9-ON-03-1, NGS-capable)"
 },
 {
  "id": "can-st-michael-s-hospital-unity-health-toronto",
  "name": "St. Michael's Hospital (Unity Health Toronto)",
  "short": "St. Michael's Hospital (Unity Health T…",
  "city": "Toronto",
  "region": "Ontario",
  "iso3": "CAN",
  "lat": 43.653,
  "lon": -79.383,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 5; Unity Health Toronto Kidney Transplant Program; one of Ontario's 6 adult kidney transplant hospitals (Ontario Renal Network)"
 },
 {
  "id": "can-hospital-for-sick-children-sickkids",
  "name": "Hospital for Sick Children (SickKids)",
  "short": "Hospital for Sick Children (SickKids)",
  "city": "Toronto",
  "region": "Ontario",
  "iso3": "CAN",
  "lat": 43.653,
  "lon": -79.383,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 5; SickKids Kidney Transplant Program described as one of Canada's largest paediatric kidney programmes. Other paediatric organ programmes at SickKids not verified in this session"
 },
 {
  "id": "can-london-health-sciences-centre-university-hospital-mu",
  "name": "London Health Sciences Centre - University Hospital (Multi-Organ Transplant Program)",
  "short": "London Health Sciences Centre - Univer…",
  "city": "London",
  "region": "Ontario",
  "iso3": "CAN",
  "lat": 42.984,
  "lon": -81.245,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "lung",
   "pancreas"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 5; LHSC Multi-Organ Transplant Program (lhsc.on.ca). HLA: LHSC Transplantation Immunology Laboratory (ASHI 2025, 12-9-ON-02-1)"
 },
 {
  "id": "can-st-joseph-s-healthcare-hamilton",
  "name": "St. Joseph's Healthcare Hamilton",
  "short": "St. Joseph's Healthcare Hamilton",
  "city": "Hamilton",
  "region": "Ontario",
  "iso3": "CAN",
  "lat": 43.256,
  "lon": -79.871,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 5; one of Ontario's 6 adult kidney transplant hospitals. HLA: St Joseph's Tissue Typing and Histocompatibility Laboratory (ASHI 2025, 09-9-ON-05-1)"
 },
 {
  "id": "can-kingston-general-hospital-kingston-health-sciences-c",
  "name": "Kingston General Hospital (Kingston Health Sciences Centre)",
  "short": "Kingston General Hospital (Kingston He…",
  "city": "Kingston",
  "region": "Ontario",
  "iso3": "CAN",
  "lat": 44.231,
  "lon": -76.486,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 5; one of Ontario's 6 adult kidney transplant hospitals (Ontario Renal Network / Kidney Foundation of Canada donor programme list)"
 },
 {
  "id": "can-the-ottawa-hospital",
  "name": "The Ottawa Hospital",
  "short": "The Ottawa Hospital",
  "city": "Ottawa",
  "region": "Ontario",
  "iso3": "CAN",
  "lat": 45.421,
  "lon": -75.697,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 5; one of Ontario's 6 adult kidney transplant hospitals. HLA: The Ottawa Hospital General Campus Tissue Typing, DNA Diagnostics and Flow Cytometry (ASHI 2025, 10-9-ON-04-1)"
 },
 {
  "id": "can-university-of-ottawa-heart-institute",
  "name": "University of Ottawa Heart Institute",
  "short": "University of Ottawa Heart Institute",
  "city": "Ottawa",
  "region": "Ontario",
  "iso3": "CAN",
  "lat": 45.421,
  "lon": -75.697,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 5 (listed as a transplant programme facility); cardiac-only scope inferred from the institution's remit, not separately sourced"
 },
 {
  "id": "can-centre-hospitalier-de-l-universite-de-montreal-chum",
  "name": "Centre hospitalier de l'Universite de Montreal (CHUM)",
  "short": "Centre hospitalier de l'Universite de …",
  "city": "Montreal",
  "region": "Quebec",
  "iso3": "CAN",
  "lat": 45.502,
  "lon": -73.567,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "lung",
   "pancreas"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 6 (appears three times: facility codes 40120 Notre-Dame, 40130 Saint-Luc, 48122 consolidated CHUM); organ scope from Transplant Quebec resource directory"
 },
 {
  "id": "can-centre-universitaire-de-sante-mcgill-site-glen-muhc",
  "name": "Centre universitaire de sante McGill - Site Glen (MUHC)",
  "short": "Centre universitaire de sante McGill -…",
  "city": "Montreal",
  "region": "Quebec",
  "iso3": "CAN",
  "lat": 45.502,
  "lon": -73.567,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "pancreas"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 6; organ scope from Transplant Quebec resource directory and MUHC Multi-organ Transplant Program. HLA: MUHC Histocompatibility and Immunogenetics Laboratory (ASHI 2025, 03-9-QU-05-1, NGS-capable)"
 },
 {
  "id": "can-hopital-de-montreal-pour-enfants-montreal-children-s",
  "name": "Hopital de Montreal pour enfants (Montreal Children's Hospital, MUHC)",
  "short": "Hopital de Montreal pour enfants (Mont…",
  "city": "Montreal",
  "region": "Quebec",
  "iso3": "CAN",
  "lat": 45.502,
  "lon": -73.567,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart",
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 6; paediatric organ scope from Transplant Quebec resource directory"
 },
 {
  "id": "can-hopital-maisonneuve-rosemont",
  "name": "Hopital Maisonneuve-Rosemont",
  "short": "Hopital Maisonneuve-Rosemont",
  "city": "Montreal",
  "region": "Quebec",
  "iso3": "CAN",
  "lat": 45.502,
  "lon": -73.567,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 6; organ scope from Transplant Quebec resource directory. HLA: Maisonneuve-Rosemont Molecular Biology Laboratory / HLA (ASHI 2025, 05-9-QU-05-1) - note its ASHI accreditation covers HSC/BM transplantation only, not solid organ"
 },
 {
  "id": "can-institut-de-cardiologie-de-montreal-montreal-heart-i",
  "name": "Institut de Cardiologie de Montreal (Montreal Heart Institute)",
  "short": "Institut de Cardiologie de Montreal (M…",
  "city": "Montreal",
  "region": "Quebec",
  "iso3": "CAN",
  "lat": 45.502,
  "lon": -73.567,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 6; organ scope from Transplant Quebec resource directory and Canadian Society of Transplantation programme list"
 },
 {
  "id": "can-chu-sainte-justine",
  "name": "CHU Sainte-Justine",
  "short": "CHU Sainte-Justine",
  "city": "Montreal",
  "region": "Quebec",
  "iso3": "CAN",
  "lat": 45.502,
  "lon": -73.567,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart",
   "liver",
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 6; paediatric organ scope from Transplant Quebec resource directory"
 },
 {
  "id": "can-chu-de-quebec-universite-laval-hotel-dieu-de-quebec",
  "name": "CHU de Quebec-Universite Laval (Hotel-Dieu de Quebec)",
  "short": "CHU de Quebec-Universite Laval (Hotel-…",
  "city": "Quebec City",
  "region": "Quebec",
  "iso3": "CAN",
  "lat": 46.814,
  "lon": -71.208,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 6; kidney scope from Canadian Society of Transplantation programme list. HLA: CHU de Quebec Immunology and Histocompatibility Laboratory (ASHI 2025, 09-9-QU-03-1)"
 },
 {
  "id": "can-institut-universitaire-de-cardiologie-et-de-pneumolo",
  "name": "Institut universitaire de cardiologie et de pneumologie de Quebec (IUCPQ - Hopital Laval)",
  "short": "Institut universitaire de cardiologie …",
  "city": "Quebec City",
  "region": "Quebec",
  "iso3": "CAN",
  "lat": 46.814,
  "lon": -71.208,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 6; heart programme per Canadian Society of Transplantation list. A lung transplant programme at IUCPQ is widely assumed but was NOT verified on a primary source in this session"
 },
 {
  "id": "can-chu-de-sherbrooke-hopital-fleurimont",
  "name": "CHU de Sherbrooke - Hopital Fleurimont",
  "short": "CHU de Sherbrooke - Hopital Fleurimont",
  "city": "Sherbrooke",
  "region": "Quebec",
  "iso3": "CAN",
  "lat": 45.404,
  "lon": -71.889,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 6; kidney scope from Canadian Society of Transplantation programme list"
 },
 {
  "id": "can-st-paul-s-hospital-saskatchewan-transplant-program",
  "name": "St. Paul's Hospital (Saskatchewan Transplant Program)",
  "short": "St. Paul's Hospital (Saskatchewan Tran…",
  "city": "Saskatoon",
  "region": "Saskatchewan",
  "iso3": "CAN",
  "lat": 52.134,
  "lon": -106.647,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 28,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "CIHI CORR Directory (Dec 2024), Table 7. Kidney-only confirmed by CIHI 2024 data tables Table 5 (Saskatchewan total 28, all kidney). annual_kidney is the provincial total. HLA: Dr. Marc Baltzan HLA Laboratory, St Paul's Hospital (ASHI 2025, 05-9-SK-01-1)"
 },
 {
  "id": "mex-umae-hospital-de-especialidades-centro-m-dico-nacion",
  "name": "UMAE Hospital de Especialidades, Centro Médico Nacional de Occidente \"Lic. Ignacio García Téllez\" (IMSS)",
  "short": "UMAE Hospital de Especialidades, Centr…",
  "city": "Guadalajara",
  "region": "Jalisco",
  "iso3": "MEX",
  "lat": 20.677,
  "lon": -103.347,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 257,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": "CENATRA SIRNT open data, 2024 four quarters aggregated (datos.gob.mx/dataset/trasplantes_organos_tejidos); city verified via IMSS/CMNO sources"
 },
 {
  "id": "mex-umae-hospital-de-especialidades-dr-bernardo-sep-lved",
  "name": "UMAE Hospital de Especialidades \"Dr. Bernardo Sepúlveda\", Centro Médico Nacional Siglo XXI (IMSS) [registry string: U.M.A.E. Hospitales de Especialidades del Centro Medico Nacional]",
  "short": "UMAE Hospital de Especialidades \"Dr. B…",
  "city": "Ciudad de México",
  "region": "Ciudad de México",
  "iso3": "MEX",
  "lat": 19.433,
  "lon": -99.133,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 197,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": "CENATRA SIRNT open data 2024; registry records the establishment name without the Siglo XXI suffix"
 },
 {
  "id": "mex-umae-hospital-general-dr-gaudencio-gonz-lez-garza-ce",
  "name": "UMAE Hospital General \"Dr. Gaudencio González Garza\", Centro Médico Nacional La Raza (IMSS)",
  "short": "UMAE Hospital General \"Dr. Gaudencio G…",
  "city": "Ciudad de México",
  "region": "Ciudad de México",
  "iso3": "MEX",
  "lat": 19.433,
  "lon": -99.133,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 146,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "CENATRA SIRNT open data 2024"
 },
 {
  "id": "mex-umae-hospital-de-especialidades-no-71-imss",
  "name": "UMAE Hospital de Especialidades No. 71 (IMSS)",
  "short": "UMAE Hospital de Especialidades No. 71…",
  "city": "Torreón",
  "region": "Coahuila",
  "iso3": "MEX",
  "lat": 25.543,
  "lon": -103.407,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 141,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "CENATRA SIRNT open data 2024; city verified (Blvd. Revolución 2650 Ote., Torreón)"
 },
 {
  "id": "mex-hospital-puerta-de-hierro-sur-private",
  "name": "Hospital Puerta de Hierro Sur (private)",
  "short": "Hospital Puerta de Hierro Sur (private)",
  "city": "Tlajomulco de Zúñiga",
  "region": "Jalisco",
  "iso3": "MEX",
  "lat": 20.474,
  "lon": -103.446,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "heart"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 81,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "CENATRA SIRNT open data 2024; city verified from hospitalespuertadehierro.com"
 },
 {
  "id": "mex-umae-hospital-de-especialidades-dr-antonio-fraga-mou",
  "name": "UMAE Hospital de Especialidades \"Dr. Antonio Fraga Mouret\", Centro Médico Nacional La Raza (IMSS)",
  "short": "UMAE Hospital de Especialidades \"Dr. A…",
  "city": "Ciudad de México",
  "region": "Ciudad de México",
  "iso3": "MEX",
  "lat": 19.433,
  "lon": -99.133,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 72,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "CENATRA SIRNT open data 2024"
 },
 {
  "id": "mex-instituto-nacional-de-ciencias-m-dicas-y-nutrici-n-s",
  "name": "Instituto Nacional de Ciencias Médicas y Nutrición \"Salvador Zubirán\" (SSA)",
  "short": "Instituto Nacional de Ciencias Médicas…",
  "city": "Ciudad de México",
  "region": "Ciudad de México",
  "iso3": "MEX",
  "lat": 19.433,
  "lon": -99.133,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "liver"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 59,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "CENATRA SIRNT open data 2024; INCMNSZ operates a named Laboratorio de Histocompatibilidad, Departamento de Trasplantes (SciELO/Rev Invest Clin)"
 },
 {
  "id": "mex-hospital-civil-de-guadalajara-fray-antonio-alcalde-s",
  "name": "Hospital Civil de Guadalajara \"Fray Antonio Alcalde\" (state health service)",
  "short": "Hospital Civil de Guadalajara \"Fray An…",
  "city": "Guadalajara",
  "region": "Jalisco",
  "iso3": "MEX",
  "lat": 20.677,
  "lon": -103.347,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 52,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "CENATRA SIRNT open data 2024; city in establishment name"
 },
 {
  "id": "mex-umae-hospital-de-especialidades-no-2-lic-luis-donald",
  "name": "UMAE Hospital de Especialidades No. 2 \"Lic. Luis Donaldo Colosio Murrieta\", CMN del Noroeste (IMSS)",
  "short": "UMAE Hospital de Especialidades No. 2 …",
  "city": "Ciudad Obregón",
  "region": "Sonora",
  "iso3": "MEX",
  "lat": 27.483,
  "lon": -109.94,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 48,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "CENATRA SIRNT open data 2024; city verified via gob.mx/IMSS"
 },
 {
  "id": "mex-centro-m-dico-nacional-20-de-noviembre-issste",
  "name": "Centro Médico Nacional \"20 de Noviembre\" (ISSSTE)",
  "short": "Centro Médico Nacional \"20 de Noviembr…",
  "city": "Ciudad de México",
  "region": "Ciudad de México",
  "iso3": "MEX",
  "lat": 19.433,
  "lon": -99.133,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 44,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "CENATRA SIRNT open data 2024"
 },
 {
  "id": "mex-hospital-general-de-m-xico-dr-eduardo-liceaga-ssa",
  "name": "Hospital General de México \"Dr. Eduardo Liceaga\" (SSA)",
  "short": "Hospital General de México \"Dr. Eduard…",
  "city": "Ciudad de México",
  "region": "Ciudad de México",
  "iso3": "MEX",
  "lat": 19.433,
  "lon": -99.133,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "liver",
   "kidney",
   "heart"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 27,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "CENATRA SIRNT open data 2024; largest single liver programme in Mexico (51 liver transplants 2024)"
 },
 {
  "id": "mex-instituto-nacional-de-cardiolog-a-ignacio-ch-vez-ssa",
  "name": "Instituto Nacional de Cardiología \"Ignacio Chávez\" (SSA)",
  "short": "Instituto Nacional de Cardiología \"Ign…",
  "city": "Ciudad de México",
  "region": "Ciudad de México",
  "iso3": "MEX",
  "lat": 19.433,
  "lon": -99.133,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart",
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 19,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "CENATRA SIRNT open data 2024; 12 heart transplants in 2024"
 },
 {
  "id": "mex-umae-hospital-de-cardiolog-a-centro-m-dico-nacional-",
  "name": "UMAE Hospital de Cardiología, Centro Médico Nacional Siglo XXI (IMSS)",
  "short": "UMAE Hospital de Cardiología, Centro M…",
  "city": "Ciudad de México",
  "region": "Ciudad de México",
  "iso3": "MEX",
  "lat": 19.433,
  "lon": -99.133,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CENATRA SIRNT open data 2024; 6 heart transplants in 2024"
 },
 {
  "id": "mex-umae-hospital-de-especialidades-no-25-imss",
  "name": "UMAE Hospital de Especialidades No. 25 (IMSS)",
  "short": "UMAE Hospital de Especialidades No. 25…",
  "city": "Nuevo León",
  "region": "Nuevo León",
  "iso3": "MEX",
  "lat": 23.63,
  "lon": -102.55,
  "geo": "approx",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 86,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "CENATRA SIRNT open data 2024; registry publishes state, not municipality"
 },
 {
  "id": "mex-umae-hospital-de-cardiolog-a-no-34-imss",
  "name": "UMAE Hospital de Cardiología No. 34 (IMSS)",
  "short": "UMAE Hospital de Cardiología No. 34 (I…",
  "city": "Nuevo León",
  "region": "Nuevo León",
  "iso3": "MEX",
  "lat": 23.63,
  "lon": -102.55,
  "geo": "approx",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "lung",
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CENATRA SIRNT open data 2024; 3 lung and 2 heart transplants in 2024 — one of only three lung-active establishments nationally"
 },
 {
  "id": "mex-christus-muguerza-hospital-alta-especialidad-private",
  "name": "Christus Muguerza Hospital Alta Especialidad (private)",
  "short": "Christus Muguerza Hospital Alta Especi…",
  "city": "Nuevo León",
  "region": "Nuevo León",
  "iso3": "MEX",
  "lat": 23.63,
  "lon": -102.55,
  "geo": "approx",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "lung",
   "liver",
   "kidney",
   "heart"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 7,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "CENATRA SIRNT open data 2024; 3 lung transplants in 2024 — one of only three lung-active establishments nationally"
 },
 {
  "id": "mex-centenario-hospital-miguel-hidalgo-state-health-serv",
  "name": "Centenario Hospital Miguel Hidalgo (state health service)",
  "short": "Centenario Hospital Miguel Hidalgo (st…",
  "city": "Aguascalientes",
  "region": "Aguascalientes",
  "iso3": "MEX",
  "lat": 23.63,
  "lon": -102.55,
  "geo": "approx",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 59,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "CENATRA SIRNT open data 2024"
 },
 {
  "id": "mex-umae-hospital-de-especialidades-cmn-gral-de-div-manu",
  "name": "UMAE Hospital de Especialidades, CMN \"Gral. de Div. Manuel Ávila Camacho\" (IMSS)",
  "short": "UMAE Hospital de Especialidades, CMN \"…",
  "city": "Puebla",
  "region": "Puebla",
  "iso3": "MEX",
  "lat": 23.63,
  "lon": -102.55,
  "geo": "approx",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 95,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "CENATRA SIRNT open data 2024"
 },
 {
  "id": "mex-umae-no-14-centro-m-dico-nacional-adolfo-ruiz-cortin",
  "name": "UMAE No. 14, Centro Médico Nacional \"Adolfo Ruiz Cortines\" (IMSS)",
  "short": "UMAE No. 14, Centro Médico Nacional \"A…",
  "city": "Veracruz",
  "region": "Veracruz",
  "iso3": "MEX",
  "lat": 19.174,
  "lon": -96.134,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 61,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "CENATRA SIRNT open data 2024; registry establishment string reads \"Veracruz, Ver.\""
 },
 {
  "id": "mex-hospital-regional-de-alta-especialidad-del-baj-o-ssa",
  "name": "Hospital Regional de Alta Especialidad del Bajío (SSA)",
  "short": "Hospital Regional de Alta Especialidad…",
  "city": "Guanajuato",
  "region": "Guanajuato",
  "iso3": "MEX",
  "lat": 23.63,
  "lon": -102.55,
  "geo": "approx",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 48,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "CENATRA SIRNT open data 2024"
 },
 {
  "id": "mex-hospital-de-especialidades-no-1-centro-m-dico-nacion",
  "name": "Hospital de Especialidades No. 1, Centro Médico Nacional del Bajío (IMSS)",
  "short": "Hospital de Especialidades No. 1, Cent…",
  "city": "Guanajuato",
  "region": "Guanajuato",
  "iso3": "MEX",
  "lat": 23.63,
  "lon": -102.55,
  "geo": "approx",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 48,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "CENATRA SIRNT open data 2024"
 },
 {
  "id": "mex-instituto-mexicano-de-trasplantes-s-c-private",
  "name": "Instituto Mexicano de Trasplantes S.C. (private)",
  "short": "Instituto Mexicano de Trasplantes S.C.…",
  "city": "Morelos",
  "region": "Morelos",
  "iso3": "MEX",
  "lat": 23.63,
  "lon": -102.55,
  "geo": "approx",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 41,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "CENATRA SIRNT open data 2024; highest-volume standalone private kidney unit outside Jalisco"
 },
 {
  "id": "arg-hospital-de-pediatria-prof-dr-juan-p-garrahan",
  "name": "Hospital de Pediatria Prof. Dr. Juan P. Garrahan",
  "short": "Hospital de Pediatria Prof. Dr. Juan P…",
  "city": "Buenos Aires (CABA)",
  "region": "Ciudad Autonoma de Buenos Aires",
  "iso3": "ARG",
  "lat": -34.604,
  "lon": -58.382,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 45,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "https://www.garrahan.gov.ar/prensa/02-01-2026-record-trasplantes (145 transplants in 2025: 60 liver, 45 kidney, 9 heart, plus lung and bone marrow; performs about half of Argentina's paediatric heart transplants)"
 },
 {
  "id": "arg-hospital-italiano-de-buenos-aires",
  "name": "Hospital Italiano de Buenos Aires",
  "short": "Hospital Italiano de Buenos Aires",
  "city": "Buenos Aires (CABA)",
  "region": "Ciudad Autonoma de Buenos Aires",
  "iso3": "ARG",
  "lat": -34.604,
  "lon": -58.382,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "lung"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 65,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "https://www.hospitalitaliano.org.ar/hiba/es/sitio/unidad-trasplante (>650 transplants/yr total; >65 kidney, >60 liver, >90 bone marrow, >55 cornea; >500 cumulative heart transplants)"
 },
 {
  "id": "arg-hospital-de-alta-complejidad-en-red-el-cruce-dr-nest",
  "name": "Hospital de Alta Complejidad en Red El Cruce Dr. Nestor Carlos Kirchner",
  "short": "Hospital de Alta Complejidad en Red El…",
  "city": "Florencio Varela",
  "region": "Provincia de Buenos Aires",
  "iso3": "ARG",
  "lat": -34.826,
  "lon": -58.276,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "lung"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.cucaiba.gba.gov.ar/?page_id=115"
 },
 {
  "id": "arg-hospital-interzonal-general-de-agudos-general-san-ma",
  "name": "Hospital Interzonal General de Agudos General San Martin (CUCAIBA CRAI Sur)",
  "short": "Hospital Interzonal General de Agudos …",
  "city": "La Plata",
  "region": "Provincia de Buenos Aires",
  "iso3": "ARG",
  "lat": -34.921,
  "lon": -57.955,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "pancreas"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.cucaiba.gba.gov.ar/?page_id=115"
 },
 {
  "id": "arg-cucaiba-crai-norte",
  "name": "CUCAIBA CRAI Norte",
  "short": "CUCAIBA CRAI Norte",
  "city": "General San Martin",
  "region": "Provincia de Buenos Aires",
  "iso3": "ARG",
  "lat": -34.573,
  "lon": -58.538,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "pancreas",
   "liver"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.cucaiba.gba.gov.ar/?page_id=115"
 },
 {
  "id": "arg-hospital-interzonal-de-agudos-especializado-en-pedia",
  "name": "Hospital Interzonal de Agudos Especializado en Pediatria Superiora Sor Maria Ludovica",
  "short": "Hospital Interzonal de Agudos Especial…",
  "city": "La Plata",
  "region": "Provincia de Buenos Aires",
  "iso3": "ARG",
  "lat": -34.921,
  "lon": -57.955,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.cucaiba.gba.gov.ar/?page_id=115 and CUCAIBA authorised-establishments list (undated) http://www.cucaiba.gba.gov.ar/wp-content/uploads/2014/08/Establecimientos-Habilitados-para-Trasplante-de-organos-y-tejidos.pdf"
 },
 {
  "id": "arg-hospital-interzonal-general-dr-jose-penna",
  "name": "Hospital Interzonal General Dr. Jose Penna",
  "short": "Hospital Interzonal General Dr. Jose P…",
  "city": "Bahia Blanca",
  "region": "Provincia de Buenos Aires",
  "iso3": "ARG",
  "lat": -38.716,
  "lon": -62.273,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.cucaiba.gba.gov.ar/?page_id=115"
 },
 {
  "id": "arg-hospital-universitario-austral",
  "name": "Hospital Universitario Austral",
  "short": "Hospital Universitario Austral",
  "city": "Pilar",
  "region": "Provincia de Buenos Aires",
  "iso3": "ARG",
  "lat": -34.458,
  "lon": -58.914,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "liver",
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CUCAIBA authorised-establishments list (undated, hosted since 2014) http://www.cucaiba.gba.gov.ar/wp-content/uploads/2014/08/Establecimientos-Habilitados-para-Trasplante-de-organos-y-tejidos.pdf"
 },
 {
  "id": "arg-hospital-privado-del-sur-fumeba",
  "name": "Hospital Privado del Sur (FUMEBA)",
  "short": "Hospital Privado del Sur (FUMEBA)",
  "city": "Bahia Blanca",
  "region": "Provincia de Buenos Aires",
  "iso3": "ARG",
  "lat": -38.716,
  "lon": -62.273,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart",
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "CUCAIBA authorised-establishments list (undated) http://www.cucaiba.gba.gov.ar/wp-content/uploads/2014/08/Establecimientos-Habilitados-para-Trasplante-de-organos-y-tejidos.pdf"
 },
 {
  "id": "arg-hospital-general-de-agudos-dr-juan-a-fernandez",
  "name": "Hospital General de Agudos Dr. Juan A. Fernandez",
  "short": "Hospital General de Agudos Dr. Juan A.…",
  "city": "Buenos Aires (CABA)",
  "region": "Ciudad Autonoma de Buenos Aires",
  "iso3": "ARG",
  "lat": -34.604,
  "lon": -58.382,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://buenosaires.gob.ar/gcaba_historico/noticias/la-ciudad-de-buenos-aires-lidera-los-trasplantes-de-organos-en-argentina (Centro de Trasplante Renal newly inaugurated, first two procedures done)"
 },
 {
  "id": "arg-hospital-de-ninos-dr-ricardo-gutierrez",
  "name": "Hospital de Ninos Dr. Ricardo Gutierrez",
  "short": "Hospital de Ninos Dr. Ricardo Gutierrez",
  "city": "Buenos Aires (CABA)",
  "region": "Ciudad Autonoma de Buenos Aires",
  "iso3": "ARG",
  "lat": -34.604,
  "lon": -58.382,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://buenosaires.gob.ar/gcaba_historico/noticias/la-ciudad-de-buenos-aires-lidera-los-trasplantes-de-organos-en-argentina (authorised by INCUCAI for paediatric kidney transplant, May 2026)"
 },
 {
  "id": "arg-hospital-general-de-agudos-dr-cosme-argerich",
  "name": "Hospital General de Agudos Dr. Cosme Argerich",
  "short": "Hospital General de Agudos Dr. Cosme A…",
  "city": "Buenos Aires (CABA)",
  "region": "Ciudad Autonoma de Buenos Aires",
  "iso3": "ARG",
  "lat": -34.604,
  "lon": -58.382,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "liver"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.perfil.com/noticias/salud/la-ciudad-de-buenos-aires-concentra-casi-la-mitad-de-los-trasplantes-del-pais-y-amplia-su-red-de-centros-especializados.phtml"
 },
 {
  "id": "arg-hospital-universitario-fundacion-favaloro",
  "name": "Hospital Universitario Fundacion Favaloro",
  "short": "Hospital Universitario Fundacion Faval…",
  "city": "Buenos Aires (CABA)",
  "region": "Ciudad Autonoma de Buenos Aires",
  "iso3": "ARG",
  "lat": -34.604,
  "lon": -58.382,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "liver",
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.fundacionfavaloro.org/trasplante-hepatico-2/ (liver, incl. deceased-donor, living-related and split); heart programme cited in Gondolesi et al, Transplantation 2018;102(6):883-886"
 },
 {
  "id": "arg-hospital-general-de-agudos-dr-carlos-g-durand-centro",
  "name": "Hospital General de Agudos Dr. Carlos G. Durand (Centro de Estudios Inmunologicos y HLA)",
  "short": "Hospital General de Agudos Dr. Carlos …",
  "city": "Buenos Aires (CABA)",
  "region": "Ciudad Autonoma de Buenos Aires",
  "iso3": "ARG",
  "lat": -34.604,
  "lon": -58.382,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.perfil.com/noticias/salud/la-ciudad-de-buenos-aires-concentra-casi-la-mitad-de-los-trasplantes-del-pais-y-amplia-su-red-de-centros-especializados.phtml"
 },
 {
  "id": "arg-incucai-laboratorio-nacional-de-inmunogenetica-lni",
  "name": "INCUCAI Laboratorio Nacional de Inmunogenetica (LNI)",
  "short": "INCUCAI Laboratorio Nacional de Inmuno…",
  "city": "Buenos Aires (CABA)",
  "region": "Ciudad Autonoma de Buenos Aires",
  "iso3": "ARG",
  "lat": -34.604,
  "lon": -58.382,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.argentina.gob.ar/registro-nacional-de-donantes-de-cph/laboratorio-nacional-de-inmunogenetica (inaugurated June 2023)"
 },
 {
  "id": "arg-cudaio-laboratorio-de-inmunogenetica",
  "name": "CUDAIO Laboratorio de Inmunogenetica",
  "short": "CUDAIO Laboratorio de Inmunogenetica",
  "city": "Santa Fe",
  "region": "Santa Fe",
  "iso3": "ARG",
  "lat": -31.633,
  "lon": -60.7,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "INCUCAI Memoria 2022, p.27 https://www.argentina.gob.ar/sites/default/files/bancos/2023-12/memoria-2022.pdf (project to bring lab up to INCUCAI Resolution 406/15 quality standards)"
 },
 {
  "id": "arg-cucai-salta-laboratorio-de-histocompatibilidad",
  "name": "CUCAI Salta laboratorio de histocompatibilidad",
  "short": "CUCAI Salta laboratorio de histocompat…",
  "city": "Salta",
  "region": "Salta",
  "iso3": "ARG",
  "lat": -24.783,
  "lon": -65.412,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "INCUCAI Memoria 2022, p.26-27 https://www.argentina.gob.ar/sites/default/files/bancos/2023-12/memoria-2022.pdf (flow cytometer purchase)"
 },
 {
  "id": "arg-hospital-julio-c-perrando-laboratorio-de-hla",
  "name": "Hospital Julio C. Perrando laboratorio de HLA",
  "short": "Hospital Julio C. Perrando laboratorio…",
  "city": "Resistencia",
  "region": "Chaco",
  "iso3": "ARG",
  "lat": -27.451,
  "lon": -58.987,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "INCUCAI Memoria 2022, p.26 https://www.argentina.gob.ar/sites/default/files/bancos/2023-12/memoria-2022.pdf"
 },
 {
  "id": "arg-laboratorios-iaca-departamento-de-histocompatibilida",
  "name": "Laboratorios IACA - Departamento de Histocompatibilidad",
  "short": "Laboratorios IACA - Departamento de Hi…",
  "city": "Bahia Blanca",
  "region": "Provincia de Buenos Aires",
  "iso3": "ARG",
  "lat": -38.716,
  "lon": -62.273,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://iaca.com.ar/departamento-de-histocompatibilidad/ (INCUCAI-authorised under Resolution 406/15)"
 },
 {
  "id": "col-fundaci-n-cardioinfantil-lacardio",
  "name": "Fundación Cardioinfantil - LaCardio",
  "short": "Fundación Cardioinfantil - LaCardio",
  "city": "Bogotá",
  "region": "Regional 1 - Secretaría Distrital de Salud de Bogotá",
  "iso3": "COL",
  "lat": 4.711,
  "lon": -74.072,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "lung",
   "pancreas"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 82,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "INS Informe Ejecutivo Red Nacional de Donación y Trasplantes 2024, Tabla 3 (202 organ transplants, largest programme in Colombia)"
 },
 {
  "id": "col-hospital-pablo-tob-n-uribe",
  "name": "Hospital Pablo Tobón Uribe",
  "short": "Hospital Pablo Tobón Uribe",
  "city": "Medellín",
  "region": "Regional 2 - Antioquia",
  "iso3": "COL",
  "lat": 6.244,
  "lon": -75.581,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 81,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (113 organ transplants)"
 },
 {
  "id": "col-corporaci-n-hospitalaria-juan-ciudad-m-deri",
  "name": "Corporación Hospitalaria Juan Ciudad - Méderi",
  "short": "Corporación Hospitalaria Juan Ciudad -…",
  "city": "Bogotá",
  "region": "Regional 1",
  "iso3": "COL",
  "lat": 4.711,
  "lon": -74.072,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 103,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 - highest single-centre kidney volume in Colombia (103)"
 },
 {
  "id": "col-fundaci-n-valle-del-lili-sede-limonar",
  "name": "Fundación Valle del Lili - Sede Limonar",
  "short": "Fundación Valle del Lili - Sede Limonar",
  "city": "Cali",
  "region": "Regional 3 - Valle del Cauca",
  "iso3": "COL",
  "lat": 3.452,
  "lon": -76.532,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "pancreas"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 79,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (89 organ transplants incl. 9 kidney-pancreas)"
 },
 {
  "id": "col-cl-nica-imbanaco-sas",
  "name": "Clínica Imbanaco SAS",
  "short": "Clínica Imbanaco SAS",
  "city": "Cali",
  "region": "Regional 3",
  "iso3": "COL",
  "lat": 3.452,
  "lon": -76.532,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 60,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (87 organ transplants)"
 },
 {
  "id": "col-fundaci-n-cardiovascular-de-colombia-hospital-intern",
  "name": "Fundación Cardiovascular de Colombia (Hospital Internacional de Colombia)",
  "short": "Fundación Cardiovascular de Colombia (…",
  "city": "Floridablanca",
  "region": "Regional 4 - Santander",
  "iso3": "COL",
  "lat": 7.062,
  "lon": -73.087,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "lung",
   "pancreas"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 36,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (87 organ transplants); HLA lab confirmed at hic.fcv.org - Laboratorio de Histocompatibilidad e Inmunogenética"
 },
 {
  "id": "col-fundaci-n-valle-del-lili",
  "name": "Fundación Valle del Lili",
  "short": "Fundación Valle del Lili",
  "city": "Cali",
  "region": "Regional 3",
  "iso3": "COL",
  "lat": 3.452,
  "lon": -76.532,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "lung",
   "intestine",
   "pancreas"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 19,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (85 organ transplants; only centre reporting intestine and liver-intestine-pancreas); EFI-accredited immunogenetics lab per valledellili.org"
 },
 {
  "id": "col-fundaci-n-hospital-san-vicente-de-pa-l-rionegro",
  "name": "Fundación Hospital San Vicente de Paúl Rionegro",
  "short": "Fundación Hospital San Vicente de Paúl…",
  "city": "Rionegro",
  "region": "Regional 2 - Antioquia",
  "iso3": "COL",
  "lat": 6.155,
  "lon": -75.374,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "pancreas"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 48,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (72 organ transplants)"
 },
 {
  "id": "col-fundaci-n-santa-fe-de-bogot",
  "name": "Fundación Santa Fe de Bogotá",
  "short": "Fundación Santa Fe de Bogotá",
  "city": "Bogotá",
  "region": "Regional 1",
  "iso3": "COL",
  "lat": 4.711,
  "lon": -74.072,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "lung",
   "pancreas"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 23,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (64 organ transplants)"
 },
 {
  "id": "col-fundaci-n-oftalmol-gica-de-santander-foscal",
  "name": "Fundación Oftalmológica de Santander - FOSCAL",
  "short": "Fundación Oftalmológica de Santander -…",
  "city": "Floridablanca",
  "region": "Regional 4 - Santander",
  "iso3": "COL",
  "lat": 7.062,
  "lon": -73.087,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 53,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (53 kidney, all deceased donor)"
 },
 {
  "id": "col-cl-nica-colsanitas-s-a-cl-nica-universitaria-colombi",
  "name": "Clínica Colsanitas S.A. - Clínica Universitaria Colombia",
  "short": "Clínica Colsanitas S.A. - Clínica Univ…",
  "city": "Bogotá",
  "region": "Regional 1",
  "iso3": "COL",
  "lat": 4.711,
  "lon": -74.072,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "heart"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 35,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (42 organ transplants)"
 },
 {
  "id": "col-cl-nica-cardio-vid",
  "name": "Clínica Cardio VID",
  "short": "Clínica Cardio VID",
  "city": "Medellín",
  "region": "Regional 2 - Antioquia",
  "iso3": "COL",
  "lat": 6.244,
  "lon": -75.581,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart",
   "lung"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 - thoracic-only centre (25 heart, 14 lung, 1 kidney-heart)"
 },
 {
  "id": "col-administradora-country-s-a-s-cl-nica-del-country-ips",
  "name": "Administradora Country S.A.S - Clínica del Country IPS",
  "short": "Administradora Country S.A.S - Clínica…",
  "city": "Bogotá",
  "region": "Regional 1",
  "iso3": "COL",
  "lat": 4.711,
  "lon": -74.072,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 39,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3"
 },
 {
  "id": "col-hospital-alma-m-ter-de-antioquia",
  "name": "Hospital Alma Máter de Antioquia",
  "short": "Hospital Alma Máter de Antioquia",
  "city": "Medellín",
  "region": "Regional 2",
  "iso3": "COL",
  "lat": 6.244,
  "lon": -75.581,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 31,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (38 organ transplants)"
 },
 {
  "id": "col-fundaci-n-abood-shaio",
  "name": "Fundación Abood Shaio",
  "short": "Fundación Abood Shaio",
  "city": "Bogotá",
  "region": "Regional 1",
  "iso3": "COL",
  "lat": 4.711,
  "lon": -74.072,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "pancreas"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 14,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (38 organ transplants)"
 },
 {
  "id": "col-cl-nica-portoazul-s-a",
  "name": "Clínica Portoazul S.A.",
  "short": "Clínica Portoazul S.A.",
  "city": "Barranquilla",
  "region": "Regional 5 - Atlántico",
  "iso3": "COL",
  "lat": 10.968,
  "lon": -74.781,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 34,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 - largest kidney programme on the Caribbean coast"
 },
 {
  "id": "col-sociedad-m-dica-rionegro-somer-s-a",
  "name": "Sociedad Médica Rionegro - SOMER S.A.",
  "short": "Sociedad Médica Rionegro - SOMER S.A.",
  "city": "Rionegro",
  "region": "Regional 2 - Antioquia",
  "iso3": "COL",
  "lat": 6.155,
  "lon": -75.374,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 31,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (34 organ transplants)"
 },
 {
  "id": "col-hospital-cardiovascular-de-cundinamarca-s-a",
  "name": "Hospital Cardiovascular de Cundinamarca S.A.",
  "short": "Hospital Cardiovascular de Cundinamarc…",
  "city": "Soacha (Cundinamarca)",
  "region": "Regional 1",
  "iso3": "COL",
  "lat": 4.579,
  "lon": -74.216,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 23,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3"
 },
 {
  "id": "col-hospital-universitario-san-ignacio",
  "name": "Hospital Universitario San Ignacio",
  "short": "Hospital Universitario San Ignacio",
  "city": "Bogotá",
  "region": "Regional 1",
  "iso3": "COL",
  "lat": 4.711,
  "lon": -74.072,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "heart"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 20,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (23 organ transplants)"
 },
 {
  "id": "col-cl-nica-de-la-costa-ltda",
  "name": "Clínica de la Costa Ltda",
  "short": "Clínica de la Costa Ltda",
  "city": "Barranquilla",
  "region": "Regional 5 - Atlántico",
  "iso3": "COL",
  "lat": 10.968,
  "lon": -74.781,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 19,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3"
 },
 {
  "id": "col-e-s-e-hospital-universitario-hernando-moncaleano-per",
  "name": "E.S.E. Hospital Universitario Hernando Moncaleano Perdomo",
  "short": "E.S.E. Hospital Universitario Hernando…",
  "city": "Neiva",
  "region": "Regional 6 - Huila",
  "iso3": "COL",
  "lat": 2.928,
  "lon": -75.281,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 18,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 - the ONLY organ transplant centre in Regional 6 (Huila)"
 },
 {
  "id": "col-hospital-universitario-del-valle-evaristo-garc-a-e-s",
  "name": "Hospital Universitario del Valle - Evaristo García E.S.E.",
  "short": "Hospital Universitario del Valle - Eva…",
  "city": "Cali",
  "region": "Regional 3 - Valle del Cauca",
  "iso3": "COL",
  "lat": 3.452,
  "lon": -76.532,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 16,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 - main public-sector transplant centre in Cali"
 },
 {
  "id": "col-fundaci-n-hospitalaria-san-vicente-de-paul",
  "name": "Fundación Hospitalaria San Vicente de Paul",
  "short": "Fundación Hospitalaria San Vicente de …",
  "city": "Medellín",
  "region": "Regional 2 - Antioquia",
  "iso3": "COL",
  "lat": 6.244,
  "lon": -75.581,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 11,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3"
 },
 {
  "id": "col-sociedad-de-cirug-a-de-bogot-hospital-de-san-jos",
  "name": "Sociedad de Cirugía de Bogotá - Hospital de San José",
  "short": "Sociedad de Cirugía de Bogotá - Hospit…",
  "city": "Bogotá",
  "region": "Regional 1",
  "iso3": "COL",
  "lat": 4.711,
  "lon": -74.072,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 7,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3"
 },
 {
  "id": "col-organizaci-n-cl-nica-general-del-norte",
  "name": "Organización Clínica General del Norte",
  "short": "Organización Clínica General del Norte",
  "city": "Barranquilla",
  "region": "Regional 5 - Atlántico",
  "iso3": "COL",
  "lat": 10.968,
  "lon": -74.781,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 5,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3"
 },
 {
  "id": "col-cl-nica-colsanitas-s-a-cl-nica-reina-sof-a",
  "name": "Clínica Colsanitas S.A. - Clínica Reina Sofía",
  "short": "Clínica Colsanitas S.A. - Clínica Rein…",
  "city": "Bogotá",
  "region": "Regional 1",
  "iso3": "COL",
  "lat": 4.711,
  "lon": -74.072,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 5,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3"
 },
 {
  "id": "col-dime-cl-nica-neurocardiovascular-s-a",
  "name": "DIME Clínica Neurocardiovascular S.A.",
  "short": "DIME Clínica Neurocardiovascular S.A.",
  "city": "Cali",
  "region": "Regional 3",
  "iso3": "COL",
  "lat": 3.452,
  "lon": -76.532,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (4 heart transplants)"
 },
 {
  "id": "col-cl-nica-centro",
  "name": "Clínica Centro",
  "short": "Clínica Centro",
  "city": "Barranquilla",
  "region": "Regional 5 - Atlántico",
  "iso3": "COL",
  "lat": 10.968,
  "lon": -74.781,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "lung"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (3 lung transplants; only lung programme on the Caribbean coast)"
 },
 {
  "id": "col-centro-cardiovascular-somer-incare-s-a",
  "name": "Centro Cardiovascular Somer Incare S.A.",
  "short": "Centro Cardiovascular Somer Incare S.A.",
  "city": "Rionegro",
  "region": "Regional 2 - Antioquia",
  "iso3": "COL",
  "lat": 6.155,
  "lon": -75.374,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (2 heart transplants)"
 },
 {
  "id": "col-medical-duarte-zf-sas",
  "name": "Medical Duarte ZF SAS",
  "short": "Medical Duarte ZF SAS",
  "city": "Cúcuta",
  "region": "Regional 4 - Santander",
  "iso3": "COL",
  "lat": 7.894,
  "lon": -72.508,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 1,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (1 kidney); city inferred from institution identity and corroborated by Regional 4 kidney total reconciling to 90"
 },
 {
  "id": "col-fundaci-n-hospital-san-pedro",
  "name": "Fundación Hospital San Pedro",
  "short": "Fundación Hospital San Pedro",
  "city": "Pasto",
  "region": "Regional 3 - Valle del Cauca (covers Nariño)",
  "iso3": "COL",
  "lat": 1.214,
  "lon": -77.281,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 1,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 (1 living-donor kidney); city inferred from institution identity and corroborated by Regional 3 kidney total reconciling to 175"
 },
 {
  "id": "col-avidanti-ibagu",
  "name": "Avidanti Ibagué",
  "short": "Avidanti Ibagué",
  "city": "Ibagué",
  "region": "",
  "iso3": "COL",
  "lat": 4.439,
  "lon": -75.232,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 - listed as a transplant IPS but reported ZERO organ transplants in 2024"
 },
 {
  "id": "col-hospital-general-de-medell-n",
  "name": "Hospital General de Medellín",
  "short": "Hospital General de Medellín",
  "city": "Medellín",
  "region": "Regional 2 - Antioquia",
  "iso3": "COL",
  "lat": 6.244,
  "lon": -75.581,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 - listed as a transplant IPS but reported ZERO organ transplants in 2024"
 },
 {
  "id": "col-hospital-universitario-de-san-jos-popay-n",
  "name": "Hospital Universitario de San José - Popayán",
  "short": "Hospital Universitario de San José - P…",
  "city": "Popayán",
  "region": "",
  "iso3": "COL",
  "lat": 2.444,
  "lon": -76.614,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "INS Informe Ejecutivo 2024, Tabla 3 - listed as a transplant IPS but reported ZERO organ transplants in 2024"
 },
 {
  "id": "chl-hospital-carlos-van-buren",
  "name": "Hospital Carlos Van Buren",
  "short": "Hospital Carlos Van Buren",
  "city": "Valparaíso",
  "region": "Valparaíso",
  "iso3": "CHL",
  "lat": -33.047,
  "lon": -71.613,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-dr-c-sar-garavagno-burotto",
  "name": "Hospital Dr. César Garavagno Burotto",
  "short": "Hospital Dr. César Garavagno Burotto",
  "city": "Talca",
  "region": "Maule",
  "iso3": "CHL",
  "lat": -35.427,
  "lon": -71.666,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-dr-guillermo-grant-benavente",
  "name": "Hospital Dr. Guillermo Grant Benavente",
  "short": "Hospital Dr. Guillermo Grant Benavente",
  "city": "Concepción",
  "region": "Biobío",
  "iso3": "CHL",
  "lat": -36.827,
  "lon": -73.05,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-las-higueras",
  "name": "Hospital Las Higueras",
  "short": "Hospital Las Higueras",
  "city": "Talcahuano",
  "region": "Biobío",
  "iso3": "CHL",
  "lat": -36.716,
  "lon": -73.117,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-dr-hern-n-henr-quez-aravena",
  "name": "Hospital Dr. Hernán Henríquez Aravena",
  "short": "Hospital Dr. Hernán Henríquez Aravena",
  "city": "Temuco",
  "region": "La Araucanía",
  "iso3": "CHL",
  "lat": -38.736,
  "lon": -72.59,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-regional-de-valdivia-hospital-base-valdivia",
  "name": "Hospital Regional de Valdivia (Hospital Base Valdivia)",
  "short": "Hospital Regional de Valdivia (Hospita…",
  "city": "Valdivia",
  "region": "Los Ríos",
  "iso3": "CHL",
  "lat": -39.814,
  "lon": -73.246,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-del-salvador",
  "name": "Hospital del Salvador",
  "short": "Hospital del Salvador",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-dr-luis-calvo-mackenna-paediatric",
  "name": "Hospital Dr. Luis Calvo Mackenna (paediatric)",
  "short": "Hospital Dr. Luis Calvo Mackenna (paed…",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-dr-s-tero-del-r-o",
  "name": "Hospital Dr. Sótero del Río",
  "short": "Hospital Dr. Sótero del Río",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-san-juan-de-dios",
  "name": "Hospital San Juan de Dios",
  "short": "Hospital San Juan de Dios",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-barros-luco-trudeau",
  "name": "Hospital Barros Luco Trudeau",
  "short": "Hospital Barros Luco Trudeau",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-dr-exequiel-gonz-lez-cort-s-paediatric",
  "name": "Hospital Dr. Exequiel González Cortés (paediatric)",
  "short": "Hospital Dr. Exequiel González Cortés …",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-instituto-nacional-del-t-rax",
  "name": "Instituto Nacional del Tórax",
  "short": "Instituto Nacional del Tórax",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart",
   "lung"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-dr-gustavo-fricke",
  "name": "Hospital Dr. Gustavo Fricke",
  "short": "Hospital Dr. Gustavo Fricke",
  "city": "Viña del Mar",
  "region": "Valparaíso",
  "iso3": "CHL",
  "lat": -33.024,
  "lon": -71.552,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-cl-nica-las-condes",
  "name": "Clínica Las Condes",
  "short": "Clínica Las Condes",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "lung",
   "pancreas"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-cl-nico-universidad-cat-lica-uc-christus",
  "name": "Hospital Clínico Universidad Católica (UC Christus)",
  "short": "Hospital Clínico Universidad Católica …",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "pancreas"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-cl-nico-universidad-de-chile",
  "name": "Hospital Clínico Universidad de Chile",
  "short": "Hospital Clínico Universidad de Chile",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-cl-nica-alemana-de-santiago",
  "name": "Clínica Alemana de Santiago",
  "short": "Clínica Alemana de Santiago",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "lung"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-cl-nica-d-vila",
  "name": "Clínica Dávila",
  "short": "Clínica Dávila",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "lung",
   "pancreas"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-cl-nica-santa-mar-a",
  "name": "Clínica Santa María",
  "short": "Clínica Santa María",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "lung",
   "pancreas"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-militar-de-santiago",
  "name": "Hospital Militar de Santiago",
  "short": "Hospital Militar de Santiago",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-dipreca",
  "name": "Hospital Dipreca",
  "short": "Hospital Dipreca",
  "city": "Santiago",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -33.449,
  "lon": -70.669,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-hospital-naval-almirante-nef",
  "name": "Hospital Naval Almirante Nef",
  "short": "Hospital Naval Almirante Nef",
  "city": "Viña del Mar",
  "region": "Valparaíso",
  "iso3": "CHL",
  "lat": -33.024,
  "lon": -71.552,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-sanatorio-alem-n",
  "name": "Sanatorio Alemán",
  "short": "Sanatorio Alemán",
  "city": "Concepción",
  "region": "Biobío",
  "iso3": "CHL",
  "lat": -36.827,
  "lon": -73.05,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "liver"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.minsal.cl/centros-de-procuramiento-y-trasplante/"
 },
 {
  "id": "chl-instituto-de-salud-p-blica-de-chile-isp-laboratorio-",
  "name": "Instituto de Salud Pública de Chile (ISP) — Laboratorio de Histocompatibilidad",
  "short": "Instituto de Salud Pública de Chile (I…",
  "city": "Santiago (Ñuñoa)",
  "region": "Metropolitana",
  "iso3": "CHL",
  "lat": -35.68,
  "lon": -71.54,
  "geo": "approx",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.ispch.gob.cl/biomedico/gestion-de-trasplante/examenes-de-histocompatibilidad/"
 },
 {
  "id": "per-hospital-nacional-guillermo-almenara-irigoyen-essalu",
  "name": "Hospital Nacional Guillermo Almenara Irigoyen (EsSalud)",
  "short": "Hospital Nacional Guillermo Almenara I…",
  "city": "Lima",
  "region": "Lima",
  "iso3": "PER",
  "lat": -12.046,
  "lon": -77.043,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart",
   "lung"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.infobae.com/peru/2025/11/07/el-organo-mas-trasplantado-en-peru-segun-el-minsa-hasta-112-veces-este-2025/ ; https://www.cmp.org.pe/medicos-del-hospital-guillermo-almenara-realizan-primer-trasplante-bipulmonar-a-paciente-adulto-mayor/ ; https://larepublica.pe/sociedad/2025/04/18/essalud-hospital-almenara-realiza-su-primer-trasplante-de-corazon-tras-26-anos-donacion-de-organos-hnews-239850 — national liver reference centre and the only lung transplant centre in Peru"
 },
 {
  "id": "per-hospital-nacional-edgardo-rebagliati-martins-essalud",
  "name": "Hospital Nacional Edgardo Rebagliati Martins (EsSalud)",
  "short": "Hospital Nacional Edgardo Rebagliati M…",
  "city": "Lima",
  "region": "Lima",
  "iso3": "PER",
  "lat": -12.046,
  "lon": -77.043,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "liver"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.infobae.com/peru/2025/11/07/el-organo-mas-trasplantado-en-peru-segun-el-minsa-hasta-112-veces-este-2025/ ; http://www.essalud.gob.pe/banco-de-organos-del-hospital-rebagliati-de-essalud-es-acreditado-como-laboratorio-especializado-en-pruebas-de-trasplantes/ — hosts the Banco de Órganos y Laboratorio de Histocompatibilidad, MINSA-accredited national public reference laboratory for transplant testing (RM 444-2013/MINSA), ~100,000 histocompatibility tests/year"
 },
 {
  "id": "per-instituto-nacional-cardiovascular-incor-essalud",
  "name": "Instituto Nacional Cardiovascular INCOR (EsSalud)",
  "short": "Instituto Nacional Cardiovascular INCO…",
  "city": "Lima",
  "region": "Lima",
  "iso3": "PER",
  "lat": -12.046,
  "lon": -77.043,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://larepublica.pe/sociedad/2025/04/18/essalud-hospital-almenara-realiza-su-primer-trasplante-de-corazon-tras-26-anos-donacion-de-organos-hnews-239850 — one of two authorised heart transplant centres in the EsSalud network"
 },
 {
  "id": "per-hospital-nacional-alberto-sabogal-sologuren-essalud",
  "name": "Hospital Nacional Alberto Sabogal Sologuren (EsSalud)",
  "short": "Hospital Nacional Alberto Sabogal Solo…",
  "city": "Callao",
  "region": "Callao",
  "iso3": "PER",
  "lat": -12.055,
  "lon": -77.126,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.infobae.com/peru/2025/11/07/el-organo-mas-trasplantado-en-peru-segun-el-minsa-hasta-112-veces-este-2025/"
 },
 {
  "id": "per-hospital-nacional-carlos-alberto-segu-n-escobedo-ess",
  "name": "Hospital Nacional Carlos Alberto Seguín Escobedo (EsSalud)",
  "short": "Hospital Nacional Carlos Alberto Seguí…",
  "city": "Arequipa",
  "region": "Arequipa",
  "iso3": "PER",
  "lat": -16.409,
  "lon": -71.537,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.infobae.com/peru/2025/11/07/el-organo-mas-trasplantado-en-peru-segun-el-minsa-hasta-112-veces-este-2025/ ; MINSA accreditation of its histocompatibility laboratory reported via gob.pe/El Peruano normas legales"
 },
 {
  "id": "per-hospital-nacional-almanzor-aguinaga-asenjo-essalud",
  "name": "Hospital Nacional Almanzor Aguinaga Asenjo (EsSalud)",
  "short": "Hospital Nacional Almanzor Aguinaga As…",
  "city": "Chiclayo",
  "region": "Lambayeque",
  "iso3": "PER",
  "lat": -6.772,
  "lon": -79.841,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.infobae.com/peru/2025/11/07/el-organo-mas-trasplantado-en-peru-segun-el-minsa-hasta-112-veces-este-2025/ ; https://www.gob.pe/institucion/essalud/noticias/1388243-hospital-almanzor-aguinaga-recibe-acreditacion-clave-para-salvar-vidas-a-traves-de-trasplantes — histocompatibility laboratory accredited by RM 438-2026/MINSA for 3 years"
 },
 {
  "id": "per-hospital-v-ctor-lazarte-echegaray-essalud",
  "name": "Hospital Víctor Lazarte Echegaray (EsSalud)",
  "short": "Hospital Víctor Lazarte Echegaray (EsS…",
  "city": "Trujillo",
  "region": "La Libertad",
  "iso3": "PER",
  "lat": -8.112,
  "lon": -79.029,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.infobae.com/peru/2025/11/07/el-organo-mas-trasplantado-en-peru-segun-el-minsa-hasta-112-veces-este-2025/"
 },
 {
  "id": "per-hospital-nacional-ramiro-prial-prial-essalud",
  "name": "Hospital Nacional Ramiro Prialé Prialé (EsSalud)",
  "short": "Hospital Nacional Ramiro Prialé Prialé…",
  "city": "Huancayo",
  "region": "Junín",
  "iso3": "PER",
  "lat": -12.068,
  "lon": -75.21,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://busquedas.elperuano.pe/normaslegales/acreditan-al-laboratorio-de-histocompatibilidad-de-soporte-a-resolucion-ministerial-n-968-2019minsa-1817321-3 — HLA laboratory accredited by RM 968-2019/MINSA; solid-organ transplant programme not confirmed"
 },
 {
  "id": "per-hospital-nacional-dos-de-mayo-minsa",
  "name": "Hospital Nacional Dos de Mayo (MINSA)",
  "short": "Hospital Nacional Dos de Mayo (MINSA)",
  "city": "Lima",
  "region": "Lima",
  "iso3": "PER",
  "lat": -12.046,
  "lon": -77.043,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.infobae.com/peru/2025/11/07/el-organo-mas-trasplantado-en-peru-segun-el-minsa-hasta-112-veces-este-2025/"
 },
 {
  "id": "per-hospital-nacional-arzobispo-loayza-minsa",
  "name": "Hospital Nacional Arzobispo Loayza (MINSA)",
  "short": "Hospital Nacional Arzobispo Loayza (MI…",
  "city": "Lima",
  "region": "Lima",
  "iso3": "PER",
  "lat": -12.046,
  "lon": -77.043,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.infobae.com/peru/2025/11/07/el-organo-mas-trasplantado-en-peru-segun-el-minsa-hasta-112-veces-este-2025/"
 },
 {
  "id": "per-hospital-nacional-cayetano-heredia-minsa",
  "name": "Hospital Nacional Cayetano Heredia (MINSA)",
  "short": "Hospital Nacional Cayetano Heredia (MI…",
  "city": "Lima",
  "region": "Lima",
  "iso3": "PER",
  "lat": -12.046,
  "lon": -77.043,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.infobae.com/peru/2025/11/07/el-organo-mas-trasplantado-en-peru-segun-el-minsa-hasta-112-veces-este-2025/"
 },
 {
  "id": "per-instituto-nacional-de-salud-del-ni-o-san-borja-minsa",
  "name": "Instituto Nacional de Salud del Niño San Borja (MINSA)",
  "short": "Instituto Nacional de Salud del Niño S…",
  "city": "Lima",
  "region": "Lima",
  "iso3": "PER",
  "lat": -12.046,
  "lon": -77.043,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.infobae.com/peru/2025/11/07/el-organo-mas-trasplantado-en-peru-segun-el-minsa-hasta-112-veces-este-2025/ ; https://portal.insnsb.gob.pe/investigacion/wp-content/uploads/2018/12/Poster_Estudio_de_Anticuerpos_Anti-HLA.pdf — Laboratorio de Histocompatibilidad y Biología Molecular, anti-HLA antibody testing"
 },
 {
  "id": "per-centro-m-dico-naval-itot-sanidad-de-las-fuerzas-arma",
  "name": "Centro Médico Naval (ITOT, Sanidad de las Fuerzas Armadas y PNP)",
  "short": "Centro Médico Naval (ITOT, Sanidad de …",
  "city": "Callao",
  "region": "Callao",
  "iso3": "PER",
  "lat": -12.055,
  "lon": -77.126,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.infobae.com/peru/2025/11/07/el-organo-mas-trasplantado-en-peru-segun-el-minsa-hasta-112-veces-este-2025/ ; https://www.disamar.mil.pe/2025/04/03/centro-medico-naval-da-de-alta-a-dos-pacientes-tras-exitosos-trasplantes-renales/"
 },
 {
  "id": "per-cl-nica-delgado-auna-private",
  "name": "Clínica Delgado (Auna) — private",
  "short": "Clínica Delgado (Auna) — private",
  "city": "Lima",
  "region": "Lima",
  "iso3": "PER",
  "lat": -12.046,
  "lon": -77.043,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.infobae.com/peru/2025/11/07/el-organo-mas-trasplantado-en-peru-segun-el-minsa-hasta-112-veces-este-2025/ — the only private clinic listed by Minsa as an accredited kidney transplant centre"
 },
 {
  "id": "per-cl-nica-san-pablo-private",
  "name": "Clínica San Pablo — private",
  "short": "Clínica San Pablo — private",
  "city": "Lima",
  "region": "Lima",
  "iso3": "PER",
  "lat": -12.046,
  "lon": -77.043,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "liver"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.infobae.com/peru/2025/10/28/clinicas-privadas-ingresan-al-sistema-de-trasplantes-en-peru-primer-paciente-de-higado-ingresa-a-lista-de-espera-nacional/ — accredited August 2024; first private-sector patient entered the national liver waiting list October 2025"
 },
 {
  "id": "per-hospital-regional-docente-cl-nico-quir-rgico-daniel-",
  "name": "Hospital Regional Docente Clínico Quirúrgico Daniel Alcides Carrión",
  "short": "Hospital Regional Docente Clínico Quir…",
  "city": "Huancayo",
  "region": "Junín",
  "iso3": "PER",
  "lat": -12.068,
  "lon": -75.21,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "liver"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.sciencedirect.com/science/article/pii/S1665268125002984 — the only liver transplant centre outside Lima; had performed only 2 liver transplants as of the 2016–2024 study period"
 },
 {
  "id": "per-instituto-nacional-de-enfermedades-neopl-sicas-inen",
  "name": "Instituto Nacional de Enfermedades Neoplásicas (INEN)",
  "short": "Instituto Nacional de Enfermedades Neo…",
  "city": "Lima",
  "region": "Lima",
  "iso3": "PER",
  "lat": -12.046,
  "lon": -77.043,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.gob.pe/institucion/inen/noticias/1390199-inen-logra-renovacion-de-acreditacion-minsa-para-su-laboratorio-esencial-en-trasplantes-oncologicos-de-alta-complejidad — MINSA-accredited Histocompatibility and Cryopreservation Laboratory"
 },
 {
  "id": "ury-hospital-de-cl-nicas-dr-manuel-quintela-universidad-",
  "name": "Hospital de Clínicas Dr. Manuel Quintela (Universidad de la República) — IMAE Trasplante Renal + Unidad Bi-Institucional de Trasplante Hepático",
  "short": "Hospital de Clínicas Dr. Manuel Quinte…",
  "city": "Montevideo",
  "region": "Montevideo",
  "iso3": "URY",
  "lat": -34.902,
  "lon": -56.164,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "liver"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.fnr.gub.uy/vistas_imae/imae-12/ (FNR IMAE kidney list, Av. Italia S/N); http://www.scielo.edu.uy/scielo.php?script=sci_arttext&pid=S1688-03902020000400004 (bi-institutional liver unit). Note: the INDT Laboratorio de Inmunogenética e Histocompatibilidad is physically located in this hospital, per https://trasplanteinu.com.uy/servicios/ — the lab is INDT's, not the hospital's own."
 },
 {
  "id": "ury-hospital-evang-lico-imae-trasplante-renal",
  "name": "Hospital Evangélico — IMAE Trasplante Renal",
  "short": "Hospital Evangélico — IMAE Trasplante …",
  "city": "Montevideo",
  "region": "Montevideo",
  "iso3": "URY",
  "lat": -34.902,
  "lon": -56.164,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.fnr.gub.uy/vistas_imae/imae-12/ (Br. Batlle y Ordóñez 2759)"
 },
 {
  "id": "ury-servicio-de-trasplante-renal-inu-instituto-de-nefrol",
  "name": "Servicio de Trasplante Renal – INU (Instituto de Nefrología y Urología), sited at Hospital Italiano — IMAE Trasplante Renal",
  "short": "Servicio de Trasplante Renal – INU (In…",
  "city": "Montevideo",
  "region": "Montevideo",
  "iso3": "URY",
  "lat": -34.902,
  "lon": -56.164,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.fnr.gub.uy/vistas_imae/imae-12/ (Bvar Gral. Artigas 1632); https://trasplanteinu.com.uy/servicios/ — explicitly states its patients are typed and crossmatched at the INDT histocompatibility lab in Hospital de Clínicas, i.e. it has no in-house HLA lab"
 },
 {
  "id": "ury-hospital-central-de-las-fuerzas-armadas-hcffaa-hospi",
  "name": "Hospital Central de las Fuerzas Armadas (HCFFAA / Hospital Militar) — Unidad Bi-Institucional de Trasplante Hepático with Hospital de Clínicas",
  "short": "Hospital Central de las Fuerzas Armada…",
  "city": "Montevideo",
  "region": "Montevideo",
  "iso3": "URY",
  "lat": -34.902,
  "lon": -56.164,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "liver"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "http://www.scielo.edu.uy/scielo.php?script=sci_arttext&pid=S1688-03902020000400004 — adult liver transplant performed by the HCFFAA + Hospital de Clínicas bi-institutional unit since July 2009; https://www.fnr.gub.uy/agenda_imae/hospital-militar-2/"
 },
 {
  "id": "ury-c-rculo-cat-lico-imae-listed-under-t-cnica-trasplant",
  "name": "Círculo Católico — IMAE listed under Técnica Trasplante Cardíaco",
  "short": "Círculo Católico — IMAE listed under T…",
  "city": "Montevideo",
  "region": "Montevideo",
  "iso3": "URY",
  "lat": -34.902,
  "lon": -56.164,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.fnr.gub.uy/pagina_de_presentaci/tecnica-trasplante-cardiaco/ (Av. Millán 4480). CAVEAT: listed on the FNR heart-transplant technique page; not separately confirmed that it performs heart transplants as opposed to cardiac surgery."
 },
 {
  "id": "ury-instituto-de-cardiolog-a-integral-ici-imae-listed-un",
  "name": "Instituto de Cardiología Integral (ICI) — IMAE listed under Técnica Trasplante Cardíaco",
  "short": "Instituto de Cardiología Integral (ICI…",
  "city": "Montevideo",
  "region": "Montevideo",
  "iso3": "URY",
  "lat": -34.902,
  "lon": -56.164,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.fnr.gub.uy/pagina_de_presentaci/tecnica-trasplante-cardiaco/ (Av. 8 de Octubre 2519 bis). Same caveat as above."
 },
 {
  "id": "ury-sanatorio-americano-centro-cardiol-gico-imae-listed-",
  "name": "Sanatorio Americano (Centro Cardiológico) — IMAE listed under Técnica Trasplante Cardíaco",
  "short": "Sanatorio Americano (Centro Cardiológi…",
  "city": "Montevideo",
  "region": "Montevideo",
  "iso3": "URY",
  "lat": -34.902,
  "lon": -56.164,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.fnr.gub.uy/pagina_de_presentaci/tecnica-trasplante-cardiaco/ (Dr. Isabelino Bosch 2466). Same caveat as above."
 },
 {
  "id": "ury-laboratorio-de-inmunogen-tica-e-histocompatibilidad-",
  "name": "Laboratorio de Inmunogenética e Histocompatibilidad, INDT (national histocompatibility laboratory, not a transplanting centre)",
  "short": "Laboratorio de Inmunogenética e Histoc…",
  "city": "Montevideo",
  "region": "Montevideo",
  "iso3": "URY",
  "lat": -34.902,
  "lon": -56.164,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://documentos.diputados.gub.uy/docs/L50/Original/01352.pdf — every national transplant statistic in the INDT's parliamentary return is footnoted 'Datos suministrados por sector Registros Médicos del Lab. de Inmunogenética e Histocompatibilidad del INDT'; same document states INDT is 'la única organización nacional rectora' and 'la única Institución de esta naturaleza', located at Hospital de Clínicas, Avda. Italia s/n, 4to piso, Ala Este"
 },
 {
  "id": "cri-hospital-dr-rafael-ngel-calder-n-guardia",
  "name": "Hospital Dr. Rafael Ángel Calderón Guardia",
  "short": "Hospital Dr. Rafael Ángel Calderón Gua…",
  "city": "San José",
  "region": "San José",
  "iso3": "CRI",
  "lat": 9.928,
  "lon": -84.091,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver",
   "lung",
   "heart"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.infobae.com/costa-rica/2026/07/11/hospital-calderon-guardia-en-costa-rica-alcanza-los-900-trasplantes-de-rinon-tras-mas-de-cuatro-decadas-de-historia/ ; https://www.teletica.com/nacional/hospital-calderon-guardia-realizo-primer-trasplante-de-dos-pulmones-en-costa-rica_96617 ; https://observador.cr/hospital-calderon-guardia-realizo-el-primer-trasplante-simultaneo-de-corazon-y-pulmones ; https://elmundo.cr/costa-rica/ccss-aprueba-creacion-seroteca-apoyar-transplante-organos/ — reached its 900th kidney transplant July 2026 (cumulative, >40 years); performed Costa Rica's first single lung transplant 2013, first double lung 2015, first simultaneous heart-lung 2022; first successful adult liver transplant in Central America 1993. Sole national lung programme identified."
 },
 {
  "id": "cri-hospital-m-xico",
  "name": "Hospital México",
  "short": "Hospital México",
  "city": "San José",
  "region": "San José",
  "iso3": "CRI",
  "lat": 9.928,
  "lon": -84.091,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 37,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "https://www.monumental.co.cr/2019/12/02/hospital-mexico-alcanza-un-97-de-exito-en-trasplante-renal/ ; https://elmundo.cr/costa-rica/ccss-aprueba-creacion-seroteca-apoyar-transplante-organos/ — annual_kidney figure is 2019 (37 transplants: 28 living donor, 9 deceased donor); 1,449 kidney transplants cumulative over 40 years; highest-volume kidney centre in the country. Site of the first heart transplant in Central America (1991); current heart programme status not confirmed."
 },
 {
  "id": "cri-hospital-san-juan-de-dios",
  "name": "Hospital San Juan de Dios",
  "short": "Hospital San Juan de Dios",
  "city": "San José",
  "region": "San José",
  "iso3": "CRI",
  "lat": 9.928,
  "lon": -84.091,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://elmundo.cr/costa-rica/ccss-aprueba-creacion-seroteca-apoyar-transplante-organos/ ; https://www.medigraphic.com/pdfs/revmedcoscen/rmc-2019/rmc19628a.pdf — listed among the five Ministry-authorised CCSS transplant hospitals. CAUTION: a closure order (orden de cierre) was reported against its deceased-donor kidney programme; current operational status not confirmed."
 },
 {
  "id": "cri-hospital-nacional-de-ni-os-dr-carlos-s-enz-herrera",
  "name": "Hospital Nacional de Niños Dr. Carlos Sáenz Herrera",
  "short": "Hospital Nacional de Niños Dr. Carlos …",
  "city": "San José",
  "region": "San José",
  "iso3": "CRI",
  "lat": 9.928,
  "lon": -84.091,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "liver"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://elmundo.cr/costa-rica/ccss-aprueba-creacion-seroteca-apoyar-transplante-organos/ ; https://www.medigraphic.com/pdfs/revmedcoscen/rmc-2019/rmc19628a.pdf — the only centre in Costa Rica providing paediatric liver transplantation, continuously since 2015; accredited as a transplant establishment for living and deceased donor organs/tissues in 2017. Site of the first paediatric heart and heart-lung transplants in Central America (1993); current paediatric cardiac programme status not confirmed."
 },
 {
  "id": "cri-hospital-dr-max-peralta-jim-nez",
  "name": "Hospital Dr. Max Peralta Jiménez",
  "short": "Hospital Dr. Max Peralta Jiménez",
  "city": "Cartago",
  "region": "Cartago",
  "iso3": "CRI",
  "lat": 9.864,
  "lon": -83.919,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://elmundo.cr/costa-rica/ccss-aprueba-creacion-seroteca-apoyar-transplante-organos/ ; https://es.wikipedia.org/wiki/Hospital_Dr._Max_Peralta_Jim%C3%A9nez — the only authorised transplant centre outside San José; performed its first living-donor kidney transplant on 31 August 2005."
 },
 {
  "id": "ecu-hospital-de-especialidades-carlos-andrade-mar-n-hcam",
  "name": "Hospital de Especialidades Carlos Andrade Marín (HCAM), IESS",
  "short": "Hospital de Especialidades Carlos Andr…",
  "city": "Quito",
  "region": "Pichincha",
  "iso3": "ECU",
  "lat": -0.181,
  "lon": -78.468,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "liver",
   "lung"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "MSP (salud.gob.ec) lung-transplant accreditation notice; IESS newsroom (first bilateral lung transplant in Ecuador; renal transplant workup at HCAM); IESS note that the HCAM histocompatibility/immunogenetics lab is INDOT-accredited"
 },
 {
  "id": "ecu-hospital-de-especialidades-teodoro-maldonado-carbo-h",
  "name": "Hospital de Especialidades Teodoro Maldonado Carbo (HTMC), IESS",
  "short": "Hospital de Especialidades Teodoro Mal…",
  "city": "Guayaquil",
  "region": "Guayas",
  "iso3": "ECU",
  "lat": -2.17,
  "lon": -79.922,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "IESS newsroom 'Hospitales especializados del IESS están acreditados por el Indot'; IESS/EdiciónMédica 'Laboratorio de Histocompatibilidad e Inmunogenética del HTMC acreditado' by INDOT"
 },
 {
  "id": "ecu-hospital-jos-carrasco-arteaga-hjca-iess",
  "name": "Hospital José Carrasco Arteaga (HJCA), IESS",
  "short": "Hospital José Carrasco Arteaga (HJCA),…",
  "city": "Cuenca",
  "region": "Azuay",
  "iso3": "ECU",
  "lat": -2.9,
  "lon": -79.005,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney",
   "liver"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "IESS newsroom 'Hospitales especializados del IESS están acreditados por el Indot' - HJCA accredited for cornea, liver and kidney; catchment Azuay, Cañar, Morona Santiago, El Oro, Loja"
 },
 {
  "id": "ecu-hospital-de-especialidades-alfredo-paulson-heap-junt",
  "name": "Hospital de Especialidades Alfredo Paulson (HEAP), Junta de Beneficencia de Guayaquil",
  "short": "Hospital de Especialidades Alfredo Pau…",
  "city": "Guayaquil",
  "region": "Guayas",
  "iso3": "ECU",
  "lat": -2.17,
  "lon": -79.922,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "lung"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "Vistazo, 1 Jul 2026, 'Ecuador avanza en cirugías de alta complejidad' - first lung transplant in Guayaquil late 2025, paediatric liver transplant 2026"
 },
 {
  "id": "pan-ciudad-de-la-salud-cidelas-caja-de-seguro-social",
  "name": "Ciudad de la Salud (CIDELAS), Caja de Seguro Social",
  "short": "Ciudad de la Salud (CIDELAS), Caja de …",
  "city": "Panama City",
  "region": "Panamá",
  "iso3": "PAN",
  "lat": 8.984,
  "lon": -79.518,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney",
   "liver",
   "heart"
  ],
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 41,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": "https://www.tvn-2.com/nacionales/rinon-encabeza-trasplantes-panama-caja-de-seguro-social_1_2229734.html ; https://prensa.css.gob.pa/2025/02/12/panama-es-el-unico-pais-de-latinoamerica-con-la-mas-moderna-tecnologia-para-realizar-trasplantes/ (annual_kidney = 41 in calendar year 2025: 17 living donor, 24 deceased donor; this is the centre that now concentrates the CSS national programme and hosts the Laboratorio Nacional de Trasplante)"
 },
 {
  "id": "pan-complejo-hospitalario-dr-arnulfo-arias-madrid-caja-d",
  "name": "Complejo Hospitalario Dr. Arnulfo Arias Madrid, Caja de Seguro Social",
  "short": "Complejo Hospitalario Dr. Arnulfo Aria…",
  "city": "Panama City",
  "region": "Panamá",
  "iso3": "PAN",
  "lat": 8.984,
  "lon": -79.518,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.prensa.com/sociedad/panama-35-pacientes-recibieron-trasplantes-de-organos-durante-este-2024-en-la-css/ (listed as a site where kidney transplants have been performed; the transplant laboratory was historically sited here before moving to Ciudad de la Salud)"
 },
 {
  "id": "pan-hospital-de-especialidades-pedi-tricas-v-a-espa-a-ca",
  "name": "Hospital de Especialidades Pediátricas (Vía España), Caja de Seguro Social",
  "short": "Hospital de Especialidades Pediátricas…",
  "city": "Panama City",
  "region": "Panamá",
  "iso3": "PAN",
  "lat": 8.984,
  "lon": -79.518,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.prensa.com/sociedad/panama-35-pacientes-recibieron-trasplantes-de-organos-durante-este-2024-en-la-css/ (named exactly as reported; full official name not confirmed in source)"
 },
 {
  "id": "pan-hospital-santo-tom-s-minsa",
  "name": "Hospital Santo Tomás (MINSA)",
  "short": "Hospital Santo Tomás (MINSA)",
  "city": "Panama City",
  "region": "Panamá",
  "iso3": "PAN",
  "lat": 8.984,
  "lon": -79.518,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.prensa.com/sociedad/panama-35-pacientes-recibieron-trasplantes-de-organos-durante-este-2024-en-la-css/ (the main MINSA public hospital; also the principal MINSA dialysis site)"
 },
 {
  "id": "pan-hospital-dr-rafael-hern-ndez-caja-de-seguro-social",
  "name": "Hospital Dr. Rafael Hernández, Caja de Seguro Social",
  "short": "Hospital Dr. Rafael Hernández, Caja de…",
  "city": "David",
  "region": "Chiriquí",
  "iso3": "PAN",
  "lat": 8.427,
  "lon": -82.432,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://www.prensa.com/sociedad/panama-35-pacientes-recibieron-trasplantes-de-organos-durante-este-2024-en-la-css/ (only named centre outside Panama City; current activity status unverified)"
 },
 {
  "id": "dom-hospital-general-de-la-plaza-de-la-salud-hgps",
  "name": "Hospital General de la Plaza de la Salud (HGPS)",
  "short": "Hospital General de la Plaza de la Sal…",
  "city": "Santo Domingo",
  "region": "Distrito Nacional",
  "iso3": "DOM",
  "lat": 18.486,
  "lon": -69.931,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://revistacontactord.com/hgpspioneros-en-trasplante-en-rd/ ; https://elnacional.com.do/nacionales/solo-trasplante-de-rinon-tiene-cobertura-en-rd_539109.html"
 },
 {
  "id": "dom-centro-cardio-neuro-oftalmol-gico-y-trasplante-cecan",
  "name": "Centro Cardio-Neuro-Oftalmológico y Trasplante (CECANOT)",
  "short": "Centro Cardio-Neuro-Oftalmológico y Tr…",
  "city": "Santo Domingo",
  "region": "Distrito Nacional",
  "iso3": "DOM",
  "lat": 18.486,
  "lon": -69.931,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "liver"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://cecanot.gob.do/todos-los-servicios/transplante-renal/ ; https://acento.com.do/actualidad/dia-mundial-del-paciente-trasplantado-una-fecha-para-mirar-los-avances-y-retos-de-republica-dominicana-9692904.html"
 },
 {
  "id": "dom-hospital-metropolitano-de-santiago-homs",
  "name": "Hospital Metropolitano de Santiago (HOMS)",
  "short": "Hospital Metropolitano de Santiago (HO…",
  "city": "Santiago de los Caballeros",
  "region": "Cibao / North",
  "iso3": "DOM",
  "lat": 19.451,
  "lon": -70.697,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://homs.com.do/homs-cuenta-con-laboratorio-de-histocompatibilidad/ ; https://homs.com.do/centros-de-servicios/centro-renal/"
 },
 {
  "id": "dom-cl-nica-corazones-unidos",
  "name": "Clínica Corazones Unidos",
  "short": "Clínica Corazones Unidos",
  "city": "Santo Domingo",
  "region": "Distrito Nacional",
  "iso3": "DOM",
  "lat": 18.486,
  "lon": -69.931,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://eldinero.com.do/172609/trasplante-de-organos-en-republica-dominicana-costoso-e-inalcanzable-para-la-mayoria/ (press citing INCORT)"
 },
 {
  "id": "dom-centro-de-diagn-stico-medicina-avanzada-y-telemedici",
  "name": "Centro de Diagnóstico, Medicina Avanzada y Telemedicina (CEDIMAT)",
  "short": "Centro de Diagnóstico, Medicina Avanza…",
  "city": "Santo Domingo",
  "region": "Distrito Nacional",
  "iso3": "DOM",
  "lat": 18.486,
  "lon": -69.931,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://eldinero.com.do/172609/trasplante-de-organos-en-republica-dominicana-costoso-e-inalcanzable-para-la-mayoria/ (press citing INCORT)"
 },
 {
  "id": "dom-hospital-docente-salvador-b-gautier-idss",
  "name": "Hospital Docente Salvador B. Gautier (IDSS)",
  "short": "Hospital Docente Salvador B. Gautier (…",
  "city": "Santo Domingo",
  "region": "Distrito Nacional",
  "iso3": "DOM",
  "lat": 18.486,
  "lon": -69.931,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://incortrd.com/sobre-nosotros/datos-historicos/ — NOTE: current active transplant status not confirmed; this centre is not on the current INCORT accredited list reported in the press"
 },
 {
  "id": "dom-hospital-traumatol-gico-dr-ney-arias-lora",
  "name": "Hospital Traumatológico Dr. Ney Arias Lora",
  "short": "Hospital Traumatológico Dr. Ney Arias …",
  "city": "Santo Domingo Norte",
  "region": "Santo Domingo province",
  "iso3": "DOM",
  "lat": 18.552,
  "lon": -69.905,
  "geo": "city",
  "source": "americas",
  "kinds": [
   "transplant_centre"
  ],
  "programmes": [
   "kidney"
  ],
  "volumes": [],
  "tier": 3,
  "labNote": "https://acento.com.do/actualidad/dia-mundial-del-paciente-trasplantado-una-fecha-para-mirar-los-avances-y-retos-de-republica-dominicana-9692904.html"
 }
] as unknown as A.Site[];

export const AMERICAS_PATHWAYS = [
 {
  "id": "bra-anvisa-registration-of-the-ivd-rdc-830-2023-gate-not",
  "iso3": "BRA",
  "assayClass": "All assays",
  "routeName": "ANVISA registration of the IVD (RDC 830/2023) - gate, not a payment route",
  "routeType": "regulatory_gate",
  "decisionBody": "ANVISA (Agência Nacional de Vigilância Sanitária), Gerência-Geral de Tecnologia de Produtos para Saúde",
  "howItWorks": "Not a reimbursement route, but listed here because it dominates the critical path and because every downstream payment route is legally conditional on it. The registration is held by a Brazilian legal entity (Brazil Registration Holder / detentor) holding an ANVISA Autorização de Funcionamento; the foreign manufacturer cannot hold it. Risk-class-based: low-risk products go through notificação/cadastro, higher-risk products (where a transplant rejection assay would sit) through full registro with a technical dossier, analytical and clinical performance evidence, Portuguese-language labelling and IFU, and Brazilian GMP certification (CBPF, obtainable via MDSAP report to avoid an on-site ANVISA audit). Sworn translation required for non-Portuguese/English/Spanish documents; corporate documents need ICP-Brasil digital certification. Decreto 7.646/2011 Art. 15 §1º II makes the ANVISA registration number and its validity a mandatory field in any CONITEC incorporation submission, so this is a strict prerequisite to public reimbursement.",
  "submissionWindow": "Rolling, no window. File as soon as the dossier and a BRH are in place.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "BRL",
  "precedent": "Yes - molecular IVDs are routinely registered with ANVISA (HIV and HCV viral load assays, HPV DNA assays, Xpert MTB/RIF, NGS-based oncology panels). No transplant donor-derived cfDNA assay is known to hold a Brazilian registration; this appears to be virgin territory."
 },
 {
  "id": "bra-conitec-incorporation-into-the-sus-the-real-national",
  "iso3": "BRA",
  "assayClass": "All assays",
  "routeName": "CONITEC incorporation into the SUS - the real national gatekeeper",
  "routeType": "hta_appraisal",
  "decisionBody": "CONITEC (Comissão Nacional de Incorporação de Tecnologias no SUS); final decision signed by the Secretaria de Ciência, Tecnologia e Inovação e do Complexo Econômico-Industrial da Saúde (SECTICS, formerly SCTIE) of the Ministério da Saúde and published in the Diário Oficial da União",
  "howItWorks": "Statutory HTA process under Lei 12.401/2011 and Decreto 7.646/2011. Submissions are made through the e-GITS electronic system and split into demandas internas (from public bodies, state/municipal health secretariats, federal administration) and demandas externas (companies, NGOs, individuals). A company filing an external demand must supply: a signed covering letter to DGITS/SECTICS/MS; corporate constitutive documents and power of attorney, both ICP-Brasil digitally certified; the completed e-GITS submission form; a main dossier of evidence; the full text of every study cited; and sworn Portuguese translations of any non-English/Spanish article. Decreto 7.646/2011 Art. 15 §1º II requires the ANVISA registration number and validity. The dossier must carry a comparative economic evaluation against the current SUS standard of care and a budget impact analysis for the SUS. Process flow: eligibility check, technical assessment, CONITEC plenary deliberation producing a preliminary opinion, then mandatory public consultation of 20 days (reducible to 10 in urgent cases, Art. 19), then the plenary reconsiders in light of the contributions and issues a final report, which goes to the Secretary for decision (Art. 20) and publication in the DOU (Art. 23). STATUTORY CLOCK: Art. 24 requires the administrative process to conclude within 180 days, extendable by a further 90 days where circumstances require - so 270 days maximum from a valid filing. Art. 25 then gives the Ministry's technical areas up to 180 days after publication of the incorporation to actually effect the offer in the SUS, which is where SIGTAP coding and funding mechanics get resolved. Note the statutory clock only starts on a submission accepted as complete; dossier preparation, evidence generation in a Brazilian population, and pre-submission dialogue are the long pole and are not counted. Realistic total elapsed time for a foreign molecular test from a standing start, including ANVISA: 3-5 years. Difficulty is very high for a high-unit-cost genomic test because budget impact across a 6,697-transplant-a-year national programme is scrutinised hard and the comparator (protocol biopsy plus serum creatinine) is cheap within SUS tariffs.",
  "submissionWindow": "Continuous / rolling via e-GITS. No annual window. The 180-day statutory clock runs from acceptance of a complete submission.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "BRL",
  "precedent": "YES, AND IT IS RECENT AND DIRECTLY ON POINT. Next-generation sequencing (Sequenciamento de Nova Geração, NGS) for identification of BRCA1/2 mutations in women with cancer was INCORPORATED into the SUS by Portaria SCTIE/MS nº 25/2026, published 13 May 2026, on CONITEC Relatório Técnico nº 1.097. That is a high-cost NGS-based genomic test accepted into the SUS three months ago and is the single most useful precedent for a sequencing-based transplant assay. Longer-standing molecular precedents include Xpert MTB/RIF for tuberculosis, HIV and HCV viral load and genotyping, and molecular HPV testing for cervical screening. CONITEC also incorporates in vitro diagnostics at a steady cadence - verified 2025-2026 examples include ELISA for MPO-ANCA and PR3-ANCA in ANCA-associated vasculitis (Portaria SCTIE/MS nº 02/2026, 12 Jan 2026, Relatório 1.081), enzyme immunoassay for invasive aspergillosis (Portaria SCTIE/MS nº 24/2026, 7 Apr 2026, Relatório 1.094), anti-aquaporin-4 antibody IIF for NMOSD (Portaria SECTICS/MS nº 44/2025, 23 Jun 2025, Relatório 1.008), Histoplasma galactomannan antigen EIA (Portaria SECTICS/MS nº 78/2025, 1 Oct 2025, Relatório 1.044) and faecal elastase-1 (Portaria SECTICS/MS nº 25/2025, 15 May 2025, Relatório 987). No transplant rejection molecular test has been through this process."
 },
 {
  "id": "bra-sigtap-tabela-de-procedimentos-do-sus-the-national-f",
  "iso3": "BRA",
  "assayClass": "All assays",
  "routeName": "SIGTAP / Tabela de Procedimentos do SUS - the national fee schedule that actually pays",
  "routeType": "fee_schedule",
  "decisionBody": "Ministério da Saúde - Secretaria de Atenção Especializada à Saúde (SAES) and DATASUS maintain the table; the tariff value is set administratively by Ministerial portaria, not negotiated with the supplier",
  "howItWorks": "This is the payment mechanism that follows a CONITEC incorporation and is the only way a laboratory test generates recurring revenue at national scale in the SUS. Every reimbursable act has a SIGTAP code with a fixed national tariff in BRL; providers bill it through the outpatient (SIA/APAC) or inpatient (SIH/AIH) systems. There is no negotiation, no per-provider price, and no premium for a branded assay - a new test either gets its own code with its own tariff, or gets absorbed into an existing procedure's tariff with no incremental payment, which is commercially fatal. Securing a dedicated code with an adequate tariff is a distinct piece of work AFTER the CONITEC decision and is resolved during the Art. 25 180-day implementation window. Tariffs are historically set low and are revised only sporadically by portaria, so a test whose true cost sits well above the tariff will simply not be performed however formally 'covered' it is. STRUCTURAL POINT SPECIFIC TO TRANSPLANT: solid organ transplant procedures in Brazil are financed through the FAEC (Fundo de Ações Estratégicas e Compensação), a ring-fenced federal stream that sits outside the state/municipal MAC (Média e Alta Complexidade) ceiling. If a transplant-monitoring diagnostic can be coded under FAEC financing rather than MAC, it does not compete against a state's capped budget and adoption incentives are far better aligned - this is the most important single piece of funding architecture to establish early with SAES. Flag: the FAEC point is stated from background knowledge of SUS transplant financing (Portaria de Consolidação nº 6/2017 lineage) and was not re-verified against primary sources in this session - treat as medium confidence and confirm with SAES or a Brazilian market access adviser. NO PRICES ARE GIVEN because no SIGTAP tariff exists for any transplant molecular monitoring test, and the SIGTAP web service was unreachable during this session; any figure would be invented.",
  "submissionWindow": "Not separately submissible. Follows automatically from a CONITEC incorporation decision, within the Art. 25 180-day implementation deadline.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "BRL",
  "precedent": "Yes for molecular tests generally - HIV/HCV viral load, HPV DNA and molecular TB testing all carry SIGTAP codes and are billed nationally, and HLA typing for transplantation is reimbursed through SIGTAP procedure codes performed by the network of immunobiology laboratories. No SIGTAP code exists for donor-derived cfDNA or any transplant molecular rejection assay. The exact HLA code numbers and tariff values could not be verified this session (SIGTAP unreachable) and are deliberately not quoted."
 },
 {
  "id": "bra-ans-rol-de-procedimentos-e-eventos-em-sa-de-mandator",
  "iso3": "BRA",
  "assayClass": "All assays",
  "routeName": "ANS Rol de Procedimentos e Eventos em Saúde - mandatory coverage in saúde suplementar (private insurance)",
  "routeType": "national_catalogue",
  "decisionBody": "ANS (Agência Nacional de Saúde Suplementar); technical assessment by the responsible ANS unit, deliberation by COSAÚDE (Comissão de Atualização do Rol de Procedimentos e Eventos em Saúde na Saúde Suplementar, drawn from CAMSS membership), final approval by the Diretoria Colegiada (DICOL), published as a Resolução Normativa",
  "howItWorks": "The Rol is the list of consultations, exams and treatments that ANS-regulated health plans are OBLIGED to cover; it binds every plan contracted after 2 January 1999 and coverage scope varies by plan segment (ambulatorial, hospitalar with or without obstetrics, referência, odontológico). Many listed items carry a Diretriz de Utilização (DUT) - a clinical eligibility rule that restricts who qualifies - so getting listed with a workable DUT matters as much as getting listed at all. This is the route to the ~50 million Brazilians in private plans and the Albert Einstein / Sírio-Libanês / Real Hospital Português tier, and it is a genuinely separate commercial market from the SUS. THREE ENTRY ROUTES, verified from ANS: (1) external proposal submitted by anyone via the FormRol system as a PAR (Proposta de Atualização do Rol); (2) an internal ANS demand; (3) AUTOMATIC CARRY-OVER - a technology positively recommended by CONITEC and incorporated into the SUS must be included in the Rol within up to 60 days of publication of the SUS incorporation, subject to an ANS conformity analysis. Route (3) is the cheapest path and is a strong argument for prioritising CONITEC even if private volume is the near-term commercial target. PAR process: proposal and eligibility analysis with electronic notification to the proposer; technical analysis of scientific evidence on efficacy, accuracy, effectiveness, efficiency, usability and safety, plus economic comparison and financial impact assessment; COSAÚDE technical meetings producing a preliminary report; preliminary recommendation to DICOL and publication for public participation - a public consultation for favourable or unfavourable recommendations, escalating to a public hearing where the recommendation is unfavourable or where one third of COSAÚDE members request it; COSAÚDE reconvenes to consider the contributions; final recommendation; DICOL approval; Resolução Normativa published. TIMING: ANS moved from fixed two-yearly cycles to a continuous update flow, so submissions are accepted year-round. ANS states PARs are analysed in order of creation, that each proposal has its own independent lifecycle, and that elapsed time varies with complexity 'respecting the maximum statutory deadlines'. The specific statutory deadline (understood to be 180 days extendable by 90 under the Lei 14.307/2022 amendments to Lei 9.656/1998) could not be verified from primary text this session - treat the day count as unverified, but treat the continuous-flow, order-of-creation queueing as verified. Practical implication: budget 12-24 months from PAR filing, longer if the queue is deep.",
  "submissionWindow": "Continuous / year-round via FormRol. No fixed window since the move to the fluxo de atualização contínua. Analysed in order of creation.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "BRL",
  "precedent": "Yes for genetic and molecular testing generally - the Rol contains genetic and molecular diagnostic procedures, and BRCA1/2 testing is the best-known genomic example. No transplant rejection molecular assay is listed. Note that the automatic 60-day carry-over means the May 2026 SUS incorporation of NGS BRCA1/2 should have flowed into the Rol - worth confirming as the cleanest worked example of the CONITEC-to-ANS pipeline for a sequencing test."
 },
 {
  "id": "bra-coverage-outside-the-rol-under-lei-14-454-2022-and-j",
  "iso3": "BRA",
  "assayClass": "All assays",
  "routeName": "Coverage outside the Rol under Lei 14.454/2022 and judicialização da saúde",
  "routeType": "none",
  "decisionBody": "Individual courts (state and federal judiciary); no administrative decision body. NAT-JUS / e-NatJus technical notes inform judges",
  "howItWorks": "Listed for completeness and as a risk-and-reality note, NOT as a commercial route to build a plan on. Lei 14.454/2022 reversed the Superior Tribunal de Justiça's 2022 position that the Rol was exhaustive (taxativo), amending Lei 9.656/1998 so that a plan can be obliged to cover a prescribed exam or treatment not in the Rol where certain conditions are met - broadly, proof of efficacy from scientific evidence and a therapeutic plan, or a recommendation from CONITEC, or a recommendation from at least one internationally renowned health technology assessment body. CAVEAT: the exact statutory wording could not be verified this session (Planalto endpoints unreachable) and should be confirmed with Brazilian counsel before being relied on in any commercial document. Brazil has an exceptionally high volume of health litigation and individual patients do obtain court orders compelling plans, and sometimes the SUS, to fund non-listed high-cost technologies. In practice this produces sporadic, unpredictable, single-patient revenue at full list price; it is not forecastable, it generates hostile relationships with payers, and it is not a substitute for incorporation. It also cuts the other way - a company should assume that if its test becomes clinically desirable and stays unlisted, litigation volume rather than a commercial agreement will be the first form of access, with all the reputational and pricing-anchor problems that brings.",
  "submissionWindow": null,
  "difficulty": "high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "BRL",
  "precedent": "Yes in general - high-cost non-listed technologies including genomic tests and gene therapies are routinely funded through court orders in Brazil. Nothing specific to transplant molecular diagnostics identified."
 },
 {
  "id": "bra-public-procurement-by-hospitals-state-health-secreta",
  "iso3": "BRA",
  "assayClass": "All assays",
  "routeName": "Public procurement by hospitals, state health secretariats and hemocentro/immunobiology laboratories (licitação under Lei 14.133/2021)",
  "routeType": "tender",
  "decisionBody": "Individual contracting authorities: federal university hospitals (many under EBSERH), Santas Casas and philanthropic hospitals, the 27 state Secretarias Estaduais de Saúde and their CNCDOs, and the ~49 immunobiology laboratories (public hemocentros, university labs and private contractors), each procuring separately",
  "howItWorks": "The realistic pre-incorporation revenue route inside the public system. Brazilian public bodies buy goods and services through licitação under the new procurement law Lei 14.133/2021 (which superseded Lei 8.666/1993), most commonly by pregão eletrônico - a reverse electronic auction where, once technical qualification is passed, the award goes to the lowest price. Consequences for a novel differentiated test: (a) the buyer must be able to write a technical specification that only your product meets, otherwise you are auctioned against commodity alternatives; (b) sole-source purchase (inexigibilidade de licitação, for products with a single supplier, or dispensa for low values and research) is legally available but must be formally justified and is audited by the Tribunal de Contas, so it works for pilots and research volumes rather than routine service; (c) an ANVISA registration number is a standard qualification requirement in the edital, so this route still cannot precede ANVISA. Money comes from the hospital's or state's own budget, not from a national tariff, so volumes are small, lumpy and politically dependent. States can also incorporate technologies beyond the national list through their own state HTA commissions and CIB (Comissão Intergestores Bipartite) resolutions - a genuine but highly fragmented route, and with 27 CNCDOs and 49 immunobiology laboratories each procuring independently, a national footprint by this route means 20-plus separate sales cycles. Best used to generate Brazilian clinical and economic data for the eventual CONITEC dossier, not as the destination.",
  "submissionWindow": "Continuous, but driven by each buyer's own budget cycle; editais are published individually on the Portal Nacional de Contratações Públicas and state portals.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "BRL",
  "precedent": "Yes - HLA typing reagents, NGS instruments and consumables and molecular assays are routinely bought by Brazilian public hospitals and hemocentros through pregão eletrônico. No verified public-tender precedent for a transplant rejection molecular monitoring test."
 },
 {
  "id": "bra-private-pay-out-of-pocket-and-private-reference-labo",
  "iso3": "BRA",
  "assayClass": "All assays",
  "routeName": "Private pay - out-of-pocket and private reference laboratory channel",
  "routeType": "private_pay",
  "decisionBody": "No payer decision body. Commercial agreement with the laboratory or hospital; price set by the seller and the lab",
  "howItWorks": "The fastest route to first Brazilian revenue and, before CONITEC incorporation and Rol listing, effectively the only self-directed one. Two forms: (1) direct out-of-pocket payment by the patient at a private hospital or reference laboratory; (2) supply into the large private reference laboratory groups - Grupo Fleury, DASA, Hermes Pardini, Sabin - and the hospital laboratories at Albert Einstein, Sírio-Libanês and Real Hospital Português, which can list a test on their own private menu without any ANS listing, and which have the volume, courier logistics and brand to make a send-out or in-country service model work. These groups already run NGS and molecular oncology menus and are the natural first partners for an in-country laboratory-developed service. Constraints: still requires ANVISA registration for a commercially distributed kit (an in-house service performed within one accredited laboratory sits in a different and murkier regulatory space that needs Brazilian counsel); addressable population is a fraction of the 6,697 annual kidney transplants because most transplant activity, even at the private centres, is billed to the SUS; price sensitivity is real given BRL/USD exchange rates; and a high private price set early becomes the anchor that CONITEC will later measure budget impact against, which argues for thinking about the private price as a strategic decision rather than a revenue-maximising one. NO PRICE GIVEN - there is no published Brazilian private price for any transplant molecular rejection test because none is sold there, and quoting a converted US or European figure would be fabrication.",
  "submissionWindow": null,
  "difficulty": "low",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "BRL",
  "precedent": "Yes - high-cost genomic tests including comprehensive tumour genomic profiling, hereditary cancer panels and non-invasive prenatal testing are all sold privately in Brazil through Fleury, DASA and the private hospital laboratories, in most cases years ahead of any SUS incorporation or Rol listing. NIPT is the clearest example of a high-cost molecular test sustaining a substantial Brazilian private market with no public funding."
 },
 {
  "id": "can-reimbursement-is-provincial-not-national-framing",
  "iso3": "CAN",
  "assayClass": "All assays",
  "routeName": "REIMBURSEMENT IS PROVINCIAL, NOT NATIONAL (framing)",
  "routeType": "none",
  "decisionBody": "10 provincial and 3 territorial ministries of health; no federal payer",
  "howItWorks": "Canada has NO national fee schedule, no national insurer and no national reimbursement body for laboratory tests. The Canada Health Act sets conditions for federal transfer payments but does not define a benefit list. Each province decides independently what its public system pays for and how. Canada's Drug Agency (CDA-AMC, formerly CADTH) can publish health technology assessments on diagnostics, but its output is advisory only and confers no funding anywhere. There is therefore no single 'Canadian reimbursement' to win. A vendor must win 7 to 10 separate provincial decisions, each with a different mechanism, and for transplant the realistic target set is Ontario, Quebec, British Columbia, Alberta, Manitoba, Saskatchewan and Nova Scotia. Ontario and Quebec together are roughly half the national transplant volume and must both be won for a viable Canadian business.",
  "submissionWindow": null,
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CAD",
  "precedent": "No molecular transplant test has national funding because no national funding mechanism exists."
 },
 {
  "id": "can-ontario-ohip-schedule-of-benefits-for-laboratory-ser",
  "iso3": "CAN",
  "assayClass": "All assays",
  "routeName": "ONTARIO: OHIP Schedule of Benefits for Laboratory Services (SOB-LS) L-code",
  "routeType": "fee_schedule",
  "decisionBody": "Ontario Ministry of Health, Laboratories and Diagnostics Branch, advised by Ontario Health (Quality) HTA programme and the Ontario Genetics Advisory Committee (OGAC), a standing sub-committee of OHTAC",
  "howItWorks": "The SOB-LS is the fee-for-service list that pays COMMUNITY (non-hospital) laboratories per test. Each test has an L-code and a dollar fee. The schedule is republished annually effective 1 April, announced by an OHIP INFOBulletin in March. Existing transplant-relevant codes are verified in the 1 April 2026 schedule: L580 Tissue typing CAD 103.40; L582 Antibody screening per panel of 15 antigens CAD 77.55; L581 Crossmatch CAD 25.85; L583 HLA-B27 typing CAD 25.85. These are serology-era prices and there is NO molecular HLA, NGS, chimerism or cell-free DNA code anywhere in the schedule. Critically, the single highest fee in the entire community schedule is CAD 245.58 (L703 karyotype of skin or amnion cells), so the whole instrument is calibrated an order of magnitude below the price point of an NGS transplant assay. Getting a new molecular code added requires an Ontario Health HTA and/or OGAC review of clinical validity, clinical utility and value for money; published commentary puts these reviews at 12+ months and notes they do not keep pace with technology. A vendor cannot self-refer; requests come through clinicians, laboratories and the Ministry. Note also SOB-LS rule 7: specimens sent outside Ontario are not an insured benefit without prior Ministry approval, and the Ministry provides no funding to laboratories to develop or validate new tests.",
  "submissionWindow": "Annual schedule update effective 1 April, bulletin issued in March; HTA/OGAC review itself is rolling but takes 12+ months",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": 25.85,
  "priceHigh": 103.4,
  "currency": "CAD",
  "precedent": "No molecular transplant test. Nearest precedents: the HPV Screen L698 was added for the Ontario Cervical Screening Program effective 1 April 2026 but listed at CAD 0.00 and paid instead through a special laboratory agreement, and 10 tests from the Community Access Pilot were transitioned into the SOB-LS on 1 April 2026 with 9 new fee codes at fees between CAD 1.50 and CAD 53.00. The pattern is that genuinely new/expensive molecular testing gets a special agreement or global funding, not an L-code with a real fee."
 },
 {
  "id": "can-ontario-hospital-global-budget-special-laboratory-ag",
  "iso3": "CAN",
  "assayClass": "All assays",
  "routeName": "ONTARIO: hospital global budget / special laboratory agreement (the realistic route)",
  "routeType": "block_contract",
  "decisionBody": "Individual hospital laboratory and its transplant programme, within the hospital's Ontario Health global budget; special agreements negotiated with the Ministry of Health Laboratories and Diagnostics Branch",
  "howItWorks": "All Ontario histocompatibility laboratories are hospital-based, and hospital laboratory work is paid out of the hospital's global budget, not the SOB-LS. The SOB-LS itself carries the explanatory code 'I2 - Service is globally funded' for exactly this situation, and the HPV screen was funded through a special laboratory agreement rather than a real fee. In practice this means a new transplant molecular test enters Ontario by persuading one or two hospital transplant laboratories (realistically the large Toronto centre plus one other) to absorb the cost inside their existing operating budget, or by negotiating a ring-fenced special agreement with the Ministry for a defined programme. This is a laboratory-director and hospital-CFO sale, not a payer submission. It is much faster than an L-code (a budget-year decision rather than a 12+ month HTA) but the money must be found from an existing envelope, so the cost per test must be defensible against something being displaced, and volumes are capped by the individual hospital's budget. Published literature notes explicitly that Ontario provides no ministry funding for laboratories to develop or validate new tests, so validation cost falls on the hospital, on grants or on the vendor.",
  "submissionWindow": "Hospital budget cycle, Ontario fiscal year beginning 1 April",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CAD",
  "precedent": "Molecular oncology and genomic testing in Ontario is largely delivered this way, absorbed into hospital laboratory global budgets. No published precedent of a molecular transplant surveillance test funded this way in Ontario."
 },
 {
  "id": "can-ontario-out-of-country-out-of-province-prior-approva",
  "iso3": "CAN",
  "assayClass": "All assays",
  "routeName": "ONTARIO: Out-of-Country / out-of-province prior approval for tests not available in Ontario",
  "routeType": "innovation_list",
  "decisionBody": "Ontario Ministry of Health, Out-of-Country (OOC) Health Services Program (per-patient prior authorisation, not a tariff)",
  "howItWorks": "Where a genetic or genomic test is not available in Ontario, the Ministry can fund it case by case through the Out-of-Country Health Services Program. The ordering clinician applies for prior approval before the specimen is shipped; SOB-LS rule 7 states that specimens sent outside Ontario are not an insured benefit unless prior Ministry approval is obtained. This is how novel US-lab genetic testing has historically been paid for in Ontario. IMPORTANT CAVEAT: Ontario's published out-of-province coverage rules state that diagnostic and laboratory services outside Ontario are covered only when provided in a PUBLIC HOSPITAL, and explicitly exclude diagnostic or laboratory services at private facilities. A US commercial reference laboratory (the CareDx/Natera model) is a private facility, so this route is a poor fit for a centralised commercial send-out test even though it has worked for academic and hospital-based genetics. Volume is per-patient, unpredictable, and it is a bridge at best, never a business.",
  "submissionWindow": "Rolling, per patient, must be approved BEFORE the specimen leaves Ontario",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CAD",
  "precedent": "Out-of-country genetic testing not available in Ontario is routinely funded through this programme; no documented use for a molecular transplant surveillance test."
 },
 {
  "id": "can-quebec-repertoire-quebecois-et-systeme-de-mesure-des",
  "iso3": "CAN",
  "assayClass": "All assays",
  "routeName": "QUEBEC: Repertoire quebecois et systeme de mesure des procedures de biologie medicale",
  "routeType": "national_catalogue",
  "decisionBody": "Minister of Health and Social Services (MSSS) decides; INESSS evaluates and recommends; requests routed through the Direction des laboratoires et de l'imagerie medicale (DLIM) / Direction de la biovigilance et de la biologie medicale (DBBM) at MSSS",
  "howItWorks": "Quebec is a separate system with its own catalogue. The Repertoire lists roughly 1,700 medical biology procedures and is the definitive list of what Quebec public laboratories may perform and be measured/funded on. The process, established in 2012 and revised in 2018, has two mandatory phases: Phase I evaluates CLINICAL RELEVANCE (diagnostic, prognostic or therapeutic value, budget impact, ethical/social/organisational considerations), assessed by INESSS scientists with external clinicians and the Comite deliberatif permanent - Remboursement et acces; Phase II evaluates ANALYTICAL VALIDITY against standardised validation data. Both phases must complete before listing. INESSS then recommends to the Minister either to introduce or to refuse the analysis, and the Minister both decides and DESIGNATES which establishment will perform it, so listing and single-site designation happen together. THE CRITICAL BARRIER FOR A VENDOR: a request must originate from an establishment in the Quebec health and social services network. A manufacturer cannot apply. You must recruit a Quebec hospital laboratory (realistically CHUM or MUHC for transplant) to sponsor the submission. Submissions are accepted continuously with no deadline. INESSS publishes its avis in periodic batches. Add French-language labelling and documentation obligations, and note Quebec has its own OPO (Transplant Quebec) and blood operator (Hema-Quebec) outside the Canadian Blood Services structure.",
  "submissionWindow": "Continuous, no submission deadline ('s'effectue en continu, sans date limite de depot')",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CAD",
  "precedent": "INESSS has repeatedly evaluated batches of new analyses for the Repertoire, including genomic tests, and has a standing 'biologie medicale et genomique' work stream. No published INESSS avis identified for a molecular transplant surveillance assay."
 },
 {
  "id": "can-bc-and-alberta-provincial-laboratory-agency-in-house",
  "iso3": "CAN",
  "assayClass": "All assays",
  "routeName": "BC AND ALBERTA: provincial laboratory agency in-house implementation, seeded by a genomics grant",
  "routeType": "block_contract",
  "decisionBody": "BC Transplant / Provincial Health Services Authority (PHSA) and BC Ministry of Health; Alberta Precision Laboratories within Alberta Health Services and Alberta Health",
  "howItWorks": "BC and Alberta each run a single consolidated public laboratory organisation, so there is one account per province and the decision is a laboratory-agency budget and capacity decision rather than a tariff listing. The live and highly instructive precedent is the Genome Canada / Genome Alberta 'Healthy Outcomes through Genomic Innovations' project, 'Overcoming Barriers for Rapid Adoption of Donor-Derived Cell-Free DNA for Surveillance of Kidney Allograft Injury in Canada', CAD 994,632, running 1 April 2025 to 30 September 2026, co-led by James Lan (UBC / Vancouver Coastal Health Research Institute), Paul Keown (UBC / Vancouver General Hospital) and Michael Mengel (Alberta Precision Laboratories). Its stated rationale is that dd-cfDNA is currently performed only by central US laboratories, making it too costly and inaccessible to Canadian patients. Its three activities are to bring BC and Alberta transplant laboratories to the same test performance as the US central labs, launch local clinical testing and measure turnaround, access and clinical impact, and run an economic analysis to optimise cost-efficiency. READ THIS TWO WAYS: it is the strongest evidence anywhere in Canada that dd-cfDNA will get provincially funded, and the health-economic output is precisely what a provincial funding case needs; but it is also an explicit build-not-buy programme by the two provinces most likely to be your early adopters, with the country's most credible transplant HLA and pathology leadership behind it. Entering BC/Alberta means partnering with or being displaced by this consortium.",
  "submissionWindow": "Provincial fiscal year from 1 April; grant-funded implementation window ends 30 September 2026",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CAD",
  "precedent": "YES, and it is the single best precedent in Canada: dd-cfDNA for kidney allograft surveillance is being implemented in BC and Alberta public laboratories under a CAD 994,632 Genome Alberta grant, with an explicit economic analysis intended to support ongoing funding."
 },
 {
  "id": "can-all-provinces-public-tender-sole-source-procurement-",
  "iso3": "CAN",
  "assayClass": "All assays",
  "routeName": "ALL PROVINCES: public tender / sole-source procurement of reagents and instruments",
  "routeType": "tender",
  "decisionBody": "Provincial laboratory organisations and their procurement arms (PHSA Supply Chain in BC, Alberta Health Services / Alberta Precision Laboratories procurement, Ontario hospital group purchasing organisations such as Mohawk Medbuy and HealthPRO, Groupes d'approvisionnement en commun in Quebec)",
  "howItWorks": "This is how a kit or instrument vendor actually gets paid in Canada, and it is a completely separate transaction from getting a 'test' reimbursed. Once a public laboratory has decided to offer the assay and has budget for it, the consumables and analyser are bought through provincial tender or sole-source justification against the lab's operating budget. Because the buyers are consolidated public monopolies, one win covers an entire province, but cycles are long, contracts are multi-year, incumbency is sticky, and sole-source requires a defensible technical justification (typically patent-protected or uniquely validated methodology). Trade-agreement thresholds (CFTA, CETA, CPTPP) force open competition above modest values. Bilingual documentation is required, and Quebec requires French. A foreign manufacturer normally needs a Canadian importer/distributor holding an MDEL to transact.",
  "submissionWindow": "Tender-specific; typically multi-year contracts with defined re-competition dates",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CAD",
  "precedent": "Standard route for HLA typing reagents and NGS platforms already installed in Canadian ASHI-accredited laboratories."
 },
 {
  "id": "can-national-gatekeeper-canadian-blood-services-canadian",
  "iso3": "CAN",
  "assayClass": "All assays",
  "routeName": "NATIONAL GATEKEEPER: Canadian Blood Services (Canadian Transplant Registry, cPRA, HSP, KPD)",
  "routeType": "regulatory_gate",
  "decisionBody": "Canadian Blood Services, governed and funded by the provincial and territorial ministries of health (all provinces except Quebec)",
  "howItWorks": "Not a payment route, but a gate that can veto or unlock everything. Canadian Blood Services operates the Canadian Transplant Registry and the national Highly Sensitised Patient and Kidney Paired Donation programmes, and defines the cPRA calculation and the HLA data standards that feed national allocation. Any assay that changes how unacceptable antigens, cPRA or virtual crossmatch are determined must be accepted by CBS and its professional advisory committees before provinces will adopt it, because a lab cannot unilaterally change what it reports into a national allocation system. Conversely, CBS endorsement creates simultaneous pull across nine provinces. Quebec sits outside this for its own OPO but participates in interprovincial sharing. Budget for a long scientific-committee engagement, not a commercial negotiation. Timelines and process are not publicly documented in detail; treat this as directionally correct rather than precisely mapped.",
  "submissionWindow": null,
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": null,
  "precedent": "Adoption of molecular HLA typing resolution standards and the national cPRA calculator across Canadian laboratories is the closest analogue; no commercial molecular test identified as having been adopted this way."
 },
 {
  "id": "can-private-pay-patient-self-pay-for-a-non-insured-test",
  "iso3": "CAN",
  "assayClass": "All assays",
  "routeName": "PRIVATE PAY (patient self-pay for a non-insured test)",
  "routeType": "private_pay",
  "decisionBody": "None; direct contract between laboratory and patient",
  "howItWorks": "There is effectively no private transplant insurance market in Canada and the Canada Health Act prohibits charging insured persons for insured services. However, a test that is NOT an insured service can lawfully be billed to the patient, and the Ontario SOB-LS makes this explicit: physicians must write 'uninsured' beside the test name, and 'the patient will be responsible for payment', with a duty on the clinician to inform the patient. Some genomic testing is sold in Canada on exactly this basis. For transplant surveillance this is a marginal channel: the population is small, the tests are recurrent (so annualised out-of-pocket cost is high), transplant clinicians are institutionally uncomfortable ordering self-pay surveillance, and it generates no durable revenue. Useful only for early access, key-opinion-leader familiarisation and generating Canadian utilisation data ahead of a provincial submission. No credible Canadian list price exists for a transplant molecular test, so no price is given here.",
  "submissionWindow": null,
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CAD",
  "precedent": "Self-pay genomic and hereditary cancer panels are sold in Canada this way. No documented self-pay market for molecular transplant surveillance."
 },
 {
  "id": "mex-compendio-nacional-de-insumos-para-la-salud-cnis-for",
  "iso3": "MEX",
  "assayClass": "All assays",
  "routeName": "Compendio Nacional de Insumos para la Salud (CNIS) — formerly Cuadro Básico y Catálogo de Insumos del Sector Salud, group 'auxiliares de diagnóstico'",
  "routeType": "national_catalogue",
  "decisionBody": "Consejo de Salubridad General (CSG), through the Comisión Interinstitucional del Cuadro Básico y Catálogo de Insumos del Sector Salud (CICBCISS) and its specialist sub-committees, with IMSS, ISSSTE, SEDENA, SEMAR, PEMEX and the Secretaría de Salud sitting on it",
  "howItWorks": "This is the national listing that makes an item procurable across the whole public sector. Public institutions are expected to buy only items in the Compendio, or to justify an exception. Critically for planning: LISTING IS NOT REIMBURSEMENT. Inclusion attaches no price, no code and no obligation on anyone to buy; it is permission to be bought, and nothing more. A separate budget line and a separate procurement act are still required afterwards. Submission requires a prior COFEPRIS registro sanitario, a ficha técnica in the CSG format, and an evidence dossier covering safety, efficacy and an economic evaluation to the CSG methodological guideline. Applications are received and heard in periodic sessions of the Comisión. For a molecular transplant-surveillance assay the realistic sequence is: registro sanitario, then Mexican clinical evidence, then a Guía de Práctica Clínica mention, then CNIS submission — not the other way round.",
  "submissionWindow": "Periodic sessions of the Comisión Interinstitucional; historically continuous reception with scheduled hearings through the year. The exact 2026 calendar and whether the CNIS has fully absorbed the old Cuadro Básico process after the 2023-2025 sector reforms MUST be verified live with the CSG before planning around it.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "MXN",
  "precedent": "Yes in kind. Molecular diagnostics have reached public-sector use in Mexico at scale — HPV DNA testing as the primary cervical screen, HIV viral load and resistance genotyping through CENSIDA and IMSS, HCV RNA PCR under the national hepatitis C elimination programme, and mass SARS-CoV-2 RT-PCR through the InDRE/LESP network. So the machinery demonstrably can list and fund molecular tests. No molecular TRANSPLANT test (dd-cfDNA, molecular biopsy, transcriptomic rejection classifier) has any listing."
 },
 {
  "id": "mex-consolidated-national-tender-compra-consolidada-unde",
  "iso3": "MEX",
  "assayClass": "All assays",
  "routeName": "Consolidated national tender (compra consolidada) under the LAASSP",
  "routeType": "tender",
  "decisionBody": "Coordinated centrally — the coordinating body has moved repeatedly since 2019 (UNOPS, then Secretaría de Hacienda/Oficialía Mayor, then INSABI, then IMSS as consolidating agency). IMSS has been the dominant coordinator in recent cycles. Legal basis: Ley de Adquisiciones, Arrendamientos y Servicios del Sector Público (LAASSP).",
  "howItWorks": "This is where the money actually is, and it is close to closed to a novel unbudgeted test. Institutions aggregate their requirements into a single national purchase, publish through CompraNet, and award overwhelmingly on price against a pre-defined catalogue key (clave). The process is backward-looking: you cannot bid for something that is not already a requirement someone has budgeted. Getting into a consolidated purchase therefore requires the clave to exist first (CNIS listing) AND at least one institution to have written the volume into its requirement. Award is to lowest compliant price, so a premium-priced novel assay competes badly unless it is the sole compliant offer. Foreign bidders need a Mexican legal entity, RFC, and often prior supplier registration. Also note the political-risk overlay: Mexican public health procurement has been restructured three times in six years, and delivery failures and litigation have been persistent features.",
  "submissionWindow": "Annual fiscal cycle tied to the calendar year. Requirement-gathering typically runs in the first half of the year for the following year; tenders publish mid-year and award ahead of 1 January. The federal budget (Presupuesto de Egresos de la Federación) must be approved by the Cámara de Diputados by 15 November for the following year, which is the hard anchor — anything not in a requirement by roughly Q2 cannot be funded the following year.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "MXN",
  "precedent": "Yes for commodity molecular assays — HPV DNA, HIV viral load, HCV RNA and COVID PCR reagents have all been bought through consolidated or institutional tender. No precedent for a premium single-source transplant surveillance assay."
 },
 {
  "id": "mex-integrated-laboratory-service-contract-servicio-inte",
  "iso3": "MEX",
  "assayClass": "All assays",
  "routeName": "Integrated laboratory service contract (servicio integral de laboratorio clínico)",
  "routeType": "block_contract",
  "decisionBody": "Individual IMSS UMAEs, ISSSTE hospitals, federal national institutes and state health services, contracting under LAASSP; commonly with the incumbent integrator (Roche, Abbott, Siemens Healthineers, Beckman, or a Mexican integrator)",
  "howItWorks": "This is the single most realistic near-term route into a Mexican public hospital and is badly under-appreciated by foreign entrants. Mexican public labs very largely do not buy reagents line by line; they contract a bundled service in which the winner installs analysers and supplies all consumables, paid per determination against a guaranteed volume. A new assay does not need its own budget line if it can be folded into an existing integrator's contract as an additional determination. Commercially this means the entry play is a partnership or OEM arrangement with whoever already holds the lab-service contract at the target transplant centre, not a direct sale to the hospital. It also means margin is shared and the integrator controls the customer relationship. The volume concentration works in your favour here: with the top ten kidney units doing roughly 43% of national activity, and heart and lung effectively 10 and 3 centres, a very small number of contracts covers most of the addressable market.",
  "submissionWindow": "Follows each institution's own contract renewal cycle, typically multi-year; the practical window is when the integrated service contract is retendered",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "MXN",
  "precedent": "Yes — this is how essentially all routine molecular and immunoassay testing is delivered in Mexican public hospitals. Not documented for transplant surveillance assays specifically."
 },
 {
  "id": "mex-individual-hospital-national-institute-own-budget-ad",
  "iso3": "MEX",
  "assayClass": "All assays",
  "routeName": "Individual hospital / national institute own budget (adjudicación directa or invitación a cuando menos tres personas)",
  "routeType": "block_contract",
  "decisionBody": "The director and finance/procurement committee of the individual unit — IMSS UMAEs, ISSSTE regional hospitals, and the federal national institutes (INCMNSZ 'Salvador Zubirán', Instituto Nacional de Cardiología, Hospital General de México, Instituto Nacional de Pediatría)",
  "howItWorks": "Below LAASSP value thresholds an institution may buy directly or by restricted invitation from its own budget, without a national tender and without a CNIS clave in some circumstances. This is where genuinely novel tests first land in Mexico, at low volume, usually driven by a champion clinician and often framed as research or as a pilot. The federal national institutes are the highest-value target because they combine academic autonomy, some capacity to recover fees from patients ('cuotas de recuperación'), international collaboration, and the concentration of complex transplant activity. Realistic first-revenue route: a paid pilot at one or two national institutes generating Mexican clinical data, which is then the evidence base for everything else. Constraint: budgets are annual, small, and were squeezed hard by the 2019-2024 sector restructuring.",
  "submissionWindow": "Annual budget cycle, calendar year; approach in Q3 of the preceding year for inclusion in the following year's programme",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "MXN",
  "precedent": "Yes — molecular HLA typing (SSO/SSP and some NGS) is performed and funded out of institutional budgets at Mexican transplant centres and the national blood centre. That is the closest direct precedent to the Scira portfolio and it is a real one."
 },
 {
  "id": "mex-private-pay-and-private-health-insurance-gastos-m-di",
  "iso3": "MEX",
  "assayClass": "All assays",
  "routeName": "Private pay and private health insurance (gastos médicos mayores)",
  "routeType": "private_pay",
  "decisionBody": "Individual private insurers (GNP, AXA, MetLife, Mapfre and others) contract by contract, and ultimately the patient. There is NO mandatory benefits list — Mexico has no equivalent of Brazil's ANS ROL de Procedimentos. CNSF and CONDUSEF regulate insurer conduct and dispute resolution, not benefit content.",
  "howItWorks": "The private sector took 24.8% of Mexican kidney transplant volume and 25.7% of liver, on self-pay or private insurance, which makes this a materially larger share than in most public-dominated systems. Because there is no compulsory coverage list, an insurer can pay for a novel assay tomorrow if persuaded, and can equally refuse forever — there is no appeal route that compels coverage. In practice most novel molecular testing in the Mexican private sector is patient self-pay at the point of use, often out of pocket even for insured patients, and is ordered through private laboratory chains (Salud Digna, Chopo, Olarte y Akle, Biomédica de Referencia, Médica Sur, ABC). Advantage: no listing, no tender, no submission window, immediate revenue possible once registro sanitario is in hand. Disadvantage: small absolute volume, price sensitivity, and heavy dependence on individual transplant physicians.",
  "submissionWindow": null,
  "difficulty": "low",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "MXN",
  "precedent": "Yes — oncology molecular profiling, non-invasive prenatal testing and hereditary cancer panels are all routinely sold self-pay or partially insured through Mexican private laboratories, including US send-outs."
 },
 {
  "id": "mex-send-out-to-a-foreign-reference-laboratory-referenci",
  "iso3": "MEX",
  "assayClass": "All assays",
  "routeName": "Send-out to a foreign reference laboratory (referencia al extranjero)",
  "routeType": "private_pay",
  "decisionBody": "The ordering clinician and the paying patient or insurer; no Mexican payer body involved",
  "howItWorks": "Sample is collected in Mexico and shipped to a foreign (usually US CLIA) laboratory, which performs and reports the test. This is how US molecular transplant tests already reach Mexican patients today, and it is the fastest route to any Mexican revenue at all. Because no device is placed on the Mexican market, this has historically sat outside COFEPRIS registro sanitario — but treat that as a grey zone requiring Mexican counsel sign-off, not a settled position, and note that promotional activity inside Mexico for an unregistered product carries its own risk. Practical requirements: an IATA-compliant cold chain, customs/biological-material export handling, and LFPDPPP-compliant express written consent for cross-border transfer of sensitive genetic data. Strategic use: prove clinical demand and generate Mexican outcome data via send-out while the registro sanitario and CNIS process run in parallel.",
  "submissionWindow": null,
  "difficulty": "low",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "USD",
  "precedent": "Yes — this is the established channel for US-based genomic and transplant tests into Mexico and the wider region."
 },
 {
  "id": "mex-manufacturer-sponsored-or-pharma-sponsored-testing-p",
  "iso3": "MEX",
  "assayClass": "All assays",
  "routeName": "Manufacturer-sponsored or pharma-sponsored testing programme",
  "routeType": "block_contract",
  "decisionBody": "Commercial agreement between the test provider (or a pharmaceutical sponsor) and the hospital or a private laboratory; no public payer involved",
  "howItWorks": "The dominant real-world funding model for molecular testing in Mexican oncology, and directly transferable. A sponsor pays a laboratory to run a defined volume of tests free at the point of care, in exchange for access, data, or downstream therapeutic pull-through. For transplant this maps onto immunosuppression manufacturers whose products' value is demonstrated by rejection surveillance — the same logic that has driven sponsored EGFR/ALK testing. It creates real clinical familiarity and Mexican data without touching the CNIS or a tender. Risks: it is not a market, it ends when the sponsor stops, and it can anchor clinicians to a zero price, making later paid conversion harder. Use it deliberately as an evidence-generation and adoption mechanism with a pre-agreed conversion plan, not as a revenue model.",
  "submissionWindow": null,
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": null,
  "precedent": "Yes and strongly so — sponsored companion-diagnostic testing programmes are how most molecular oncology testing is actually paid for in Mexico. No transplant example known."
 },
 {
  "id": "mex-health-technology-assessment-clinical-guideline-incl",
  "iso3": "MEX",
  "assayClass": "All assays",
  "routeName": "Health technology assessment / clinical guideline inclusion (CENETEC, GPC, institutional HTA)",
  "routeType": "hta_appraisal",
  "decisionBody": "CENETEC (Centro Nacional de Excelencia Tecnológica en Salud) within the Secretaría de Salud for national HTA and Guías de Práctica Clínica; IMSS and ISSSTE also run their own internal technology-evaluation functions for their institutional catalogues",
  "howItWorks": "Important to state plainly: this is an ENABLING step, not a payment route. CENETEC produces HTA reports and national clinical guidelines but has no binding reimbursement authority and controls no budget — it is not NICE. Its value is that a favourable HTA report, and above all a mention in a Guía de Práctica Clínica or a CENATRA-endorsed transplant protocol, is what lets an institutional director defend a budget line or a CNIS submission. IMSS's own internal evaluation is arguably more consequential in practice than CENETEC's, because IMSS is both payer and provider and did 52.4% of national kidney transplant volume. Sequence this BEFORE the CNIS submission, not after.",
  "submissionWindow": "Guideline update cycles are irregular; CENETEC HTA can be commissioned by institutions on request",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": null,
  "precedent": "CENETEC has assessed molecular and genomic technologies. No transplant molecular surveillance assessment known."
 },
 {
  "id": "mex-cofepris-registro-sanitario-mandatory-gate-before-an",
  "iso3": "MEX",
  "assayClass": "All assays",
  "routeName": "COFEPRIS registro sanitario — mandatory gate before any of the above",
  "routeType": "regulatory_gate",
  "decisionBody": "COFEPRIS (Comisión Federal para la Protección contra Riesgos Sanitarios), Secretaría de Salud",
  "howItWorks": "Nothing can be sold, tendered, listed or bought in Mexico without this. IVDs are regulated as 'agentes de diagnóstico' under the Reglamento de Insumos para la Salud, risk-classified I/II/III. Three routes: ordinary full dossier; acuerdos de equivalencia based on prior approval by a recognised foreign agency (classically US FDA, Health Canada and Japan — note that an EU notified-body CE mark has NOT generally sufficed, which removes the shortcut for a UK/EU-only company); and the newer 'vía regulatoria abreviada (Reliance)' pathway, which COFEPRIS explicitly describes as leaning on prior international approvals and for which it publishes a requirements guide (this pathway VERIFIED live on gob.mx/cofepris). A Mexican-domiciled titular with an Aviso de Funcionamiento or Licencia Sanitaria and a named Responsable Sanitario is COMPULSORY — do not let a distributor hold it. Statutory review is of the order of 30 working days (equivalence/abbreviated) and 60 working days (ordinary), but plan for 6-18 months elapsed because of deficiency letters and a known backlog. Registration is valid 5 years and renewable. Add Spanish labelling, NOM-241-SSA1-2021 GMP compliance and tecnovigilancia obligations.",
  "submissionWindow": "Rolling; no fixed window",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": null,
  "precedent": "Routine — molecular IVDs are registered in Mexico as a matter of course"
 },
 {
  "id": "mex-national-fee-schedule-reimbursement-code-for-molecul",
  "iso3": "MEX",
  "assayClass": "All assays",
  "routeName": "National fee schedule / reimbursement code for molecular transplant surveillance — DOES NOT EXIST",
  "routeType": "none",
  "decisionBody": "",
  "howItWorks": "State this plainly because it drives the whole commercial model. Mexico has no national tariff or fee schedule that reimburses a molecular transplant surveillance test. There is no equivalent of the French RIHN, the German NUB, a US MolDX LCD, or Brazil's ANS ROL. IMSS publishes annual 'Costos Unitarios por Nivel de Atención Médica' in the Diario Oficial de la Federación, but these are cost-recovery unit costs used for billing non-entitled patients and inter-institutional exchange, expressed at the level of generic categories such as a laboratory study; they are NOT test-specific molecular codes and they are not a reimbursement mechanism a vendor can bill against. The CAUSES benefits catalogue that once carried explicit tariffs for the uninsured died with Seguro Popular; INSABI that replaced it was itself abolished in 2023 in favour of IMSS-Bienestar, and no successor explicit-tariff catalogue with molecular diagnostics has taken its place. CONSEQUENCE: a post-transplant surveillance assay in Mexico is funded out of some institution's own budget or out of a patient's pocket, never reimbursed. This is why the near-term Mexican opportunity sits with pre-transplant HLA typing, crossmatch and living-donor workup — activities that already have budget lines inside vertically integrated institutions — rather than with dd-cfDNA-style serial monitoring, which has no line to sit on. Deliberately no price is given here: no verified Mexican tariff for any molecular transplant test exists to quote.",
  "submissionWindow": null,
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": null,
  "precedent": "No. No molecular transplant test has a Mexican reimbursement code."
 },
 {
  "id": "arg-hospital-laboratory-budget-direct-institutional-purc",
  "iso3": "ARG",
  "assayClass": "All assays",
  "routeName": "Hospital laboratory budget / direct institutional purchase at high-volume transplant centres",
  "routeType": "block_contract",
  "decisionBody": "Individual hospital: laboratory or immunogenetics director plus the institution's comité de compras. In practice Hospital Italiano de Buenos Aires, Fundación Favaloro, Hospital Universitario Austral, Sanatorio Allende (Córdoba), Hospital Privado Universitario de Córdoba.",
  "howItWorks": "The private and charitable transplant centres run their own laboratories and their own procurement. A new molecular test is bought as a reagent line item against the lab's operating budget, then either absorbed into the transplant episode price the centre bills the obra social or prepaga, or bundled into a per-patient follow-up package. No national listing is required and no payer sign-off is needed to start. This is the only route that can generate revenue in months rather than years, and it is how essentially every novel transplant assay enters Argentina first. The constraint is volume: it is a per-site sale, and because CABA accounts for roughly 45% of national transplant activity, five to eight institutions represent most of the addressable private market.",
  "submissionWindow": "Rolling. Aligned to each institution's annual budget cycle, typically set in Q4 for the following calendar year.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "ARS",
  "precedent": "Yes. Argentine private transplant centres have historically self-funded non-listed molecular assays (dd-cfDNA, molecular HLA typing beyond the INCUCAI-mandated minimum, viral load panels) out of laboratory budget or by sending samples to reference labs, in the absence of any national code. HIGH confidence in the mechanism, MEDIUM confidence that dd-cfDNA specifically has been bought this way."
 },
 {
  "id": "arg-negotiated-biochemistry-tariff-with-individual-obras",
  "iso3": "ARG",
  "assayClass": "All assays",
  "routeName": "Negotiated biochemistry tariff with individual obras sociales and prepagas (Nomenclador Bioquímico Único / NBU unit model)",
  "routeType": "fee_schedule",
  "decisionBody": "Each obra social or prepaga individually, negotiating with the provincial biochemistry federation (e.g. FABA in Buenos Aires province, FEBA, ABC in CABA) or directly with the laboratory. CUBRA (Confederación Unificada Bioquímica de la República Argentina) maintains the NBU unit framework nationally.",
  "howItWorks": "Argentina has no binding, current, universal national fee schedule for laboratory tests. The old Nomenclador Nacional de Prestaciones Médicas is effectively frozen and obsolete for pricing purposes. Real-world private biochemistry billing runs on the Nomenclador Bioquímico Único: each test carries a fixed number of NBU units, and the peso value per unit is negotiated periodically (in practice several times a year, because of inflation) between each payer and each provincial federation or laboratory group. A new molecular test enters by being assigned a unit count and a value in a bilateral contract, or by being billed as a 'práctica no nomenclada' at a negotiated per-test price. Advantage: no ministry, no national listing, no HTA. Disadvantage: it must be re-won payer by payer, there are hundreds of obras sociales, and peso unit values erode continuously against a dollar-denominated reagent cost.",
  "submissionWindow": "Rolling, but unit values are renegotiated at high frequency because of inflation; contracts are commonly reopened quarterly or more often.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "ARS",
  "precedent": "Yes. Molecular tests including PCR viral load, HPV genotyping, thrombophilia panels and oncology mutation panels are routinely billed to obras sociales and prepagas either against NBU codes or as separately negotiated non-nomenclated practices. MEDIUM-HIGH confidence."
 },
 {
  "id": "arg-sistema-nico-de-reintegros-sur-now-operating-alongsi",
  "iso3": "ARG",
  "assayClass": "All assays",
  "routeName": "Sistema Único de Reintegros (SUR, now operating alongside SURGE)",
  "routeType": "national_catalogue",
  "decisionBody": "Superintendencia de Servicios de Salud (SSSalud), under the Ministerio de Salud de la Nación; payments executed with ARCA (the tax and customs agency).",
  "howItWorks": "SUR is the mechanism by which obras sociales nacionales are reimbursed from the Fondo Solidario de Redistribución for high-cost, low-incidence episodes, transplantation prominently among them. VERIFIED this session: SSSalud's own transparency pages list 'Sistema Único de Reintegros (SUR + SURGE)' as a live recurring transfer programme. The system operates off a closed annex of coded pathologies, modules and practices with administratively fixed peso reimbursement values, and claims are electronically cross-validated against SINTRA, INCUCAI and ANMAT registries. The practical consequence for a diagnostics vendor is binary and severe: if your test does not have a SUR code, the obra social bears 100% of its cost with no recovery, so it will refuse. Getting a new code onto the annex is a national administrative act requiring SSSalud and Ministry of Health assent, typically supported by CONETEC health technology assessment. There is no published open application window for third parties; changes arrive as resolutions, usually driven by clinical societies, INCUCAI or the transplant centres rather than by industry directly. WARNING: the exact governing resolution could not be re-verified in this session. The SUR was historically framed by SSSalud Resolución 400/2016 and successive annex updates, but the appearance of 'SURGE' indicates a post-2023 restructuring that I could not confirm. Treat the resolution number as unverified.",
  "submissionWindow": "No published industry-facing window. Annex revisions are issued as SSSalud resolutions at irregular intervals. Expect 24-48 months from first engagement to a code, if achievable at all.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "ARS",
  "precedent": "Partially. SUR reimburses transplant episodes and high-cost immunosuppression, and the annexes have historically included histocompatibility and virological monitoring within transplant modules rather than as standalone molecular codes. I found no verified precedent of a standalone novel molecular diagnostic being added to SUR as its own line. LOW-MEDIUM confidence."
 },
 {
  "id": "arg-programa-m-dico-obligatorio-pmo-inclusion",
  "iso3": "ARG",
  "assayClass": "All assays",
  "routeName": "Programa Médico Obligatorio (PMO) inclusion",
  "routeType": "national_catalogue",
  "decisionBody": "Ministerio de Salud de la Nación by resolution, informed by CONETEC (Comisión Nacional de Evaluación de Tecnologías de Salud). SSSalud enforces compliance on obras sociales and prepagas.",
  "howItWorks": "The PMO is the legally mandated minimum benefit basket that every obra social and every prepaga must cover. Transplantation is already inside the PMO. Adding a specific new diagnostic to the PMO makes coverage compulsory across the entire ~61% of the population that holds obra social, prepaga or PAMI cover, which is the single highest-value regulatory prize in the market and correspondingly the hardest to win. It requires a ministerial resolution, normally preceded by a CONETEC evidence appraisal, and is politically constrained because every addition imposes an unfunded cost on payers who are already in financial stress. Note that Argentina has never enacted the long-proposed independent national HTA agency; CONETEC is a ministerial commission, advisory rather than binding, so the decision remains fundamentally political.",
  "submissionWindow": "None published. Ministerial resolution, no fixed cycle. Realistically 3-5 years and requires Argentine clinical evidence and society sponsorship.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "ARS",
  "precedent": "Yes for molecular testing in general. HPV DNA testing and HIV/HCV viral load and genotyping are covered obligations delivered through national programmes and the PMO. No precedent for a transplant-specific molecular monitoring assay. MEDIUM confidence."
 },
 {
  "id": "arg-public-tender-provincial-and-national-procurement-co",
  "iso3": "ARG",
  "assayClass": "All assays",
  "routeName": "Public tender / provincial and national procurement (COMPR.AR, BAC, PBAC)",
  "routeType": "tender",
  "decisionBody": "Provincial ministries of health and individual public hospitals. Nationally COMPR.AR; CABA uses Buenos Aires Compras (BAC) under Ley 2095; Buenos Aires province uses PBAC under Ley 13.981. Provincial transplant bodies such as CUCAIBA (Buenos Aires) run the CRAI regional labs.",
  "howItWorks": "Free-at-point-of-use public hospitals (Garrahan, El Cruce, Posadas, provincial centres) buy reagents through formal public procurement: licitación pública, licitación privada or compra directa depending on value thresholds set by each jurisdiction. A tender award is a supply contract for reagents, not a reimbursement code, and it is paid from the hospital's or province's budget. Because Argentina is federal, this must be repeated jurisdiction by jurisdiction: 24 provinces plus CABA plus national hospitals. Two hard practical barriers for a foreign assay: bids generally require the product to already hold an ANMAT registration at the time of bidding, and peso-denominated multi-month contracts against dollar-cost reagents are financially dangerous in Argentina's FX and import-control environment. Insist on FX adjustment clauses or short contract terms.",
  "submissionWindow": "Rolling, per published tender notice. Typical bid-to-award cycle 3-9 months; annual reagent contracts common.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "ARS",
  "precedent": "Yes. Public hospital molecular diagnostics (PCR platforms, viral load reagents, and the very large COVID-era molecular reagent procurements) have been bought through exactly these portals. HIGH confidence in the mechanism."
 },
 {
  "id": "arg-national-vertical-programme-with-centralised-purchas",
  "iso3": "ARG",
  "assayClass": "All assays",
  "routeName": "National vertical programme with centralised purchase and free distribution",
  "routeType": "tender",
  "decisionBody": "Ministerio de Salud de la Nación programme directorates (e.g. Instituto Nacional del Cáncer for HPV; the national HIV/STI/hepatitis directorate for viral load), plus INCUCAI for anything transplant-specific.",
  "howItWorks": "Argentina's strongest historical route for getting a molecular test to national scale is not a fee schedule at all: it is a national vertical programme that buys the assay centrally and distributes it free to designated laboratories. This bypasses the PMO, bypasses SUR, and bypasses the obras sociales entirely. For a transplant assay the natural sponsor is INCUCAI, which already controls the authorised laboratory network and already receives national funding for histocompatibility and organ allocation. The realistic ask is an INCUCAI-endorsed pilot in the CRAI network or in the national histocompatibility labs, funded from programme budget, evidencing Argentine clinical utility, which then becomes the evidence base for SUR or PMO listing.",
  "submissionWindow": "No formal window. Programme budget cycles are annual; engagement is relationship-led via INCUCAI and the Sociedad Argentina de Trasplantes.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "ARS",
  "precedent": "Yes, and this is the clearest molecular precedent in the country. HPV DNA primary screening was introduced in Jujuy from 2011 and scaled nationally through the Programa Nacional de Prevención de Cáncer Cervicouterino with centralised reagent purchase and free provision, including self-collection. HIV and HCV viral load and genotyping are provided the same way. HIGH confidence for HPV and viral load; NO precedent for a transplant molecular assay."
 },
 {
  "id": "arg-pami-inssjp-national-pensioners-insurer",
  "iso3": "ARG",
  "assayClass": "All assays",
  "routeName": "PAMI / INSSJP (national pensioners' insurer)",
  "routeType": "block_contract",
  "decisionBody": "Instituto Nacional de Servicios Sociales para Jubilados y Pensionados (PAMI/INSSJP), a national institute operating independently of SSSalud with its own nomenclador and its own contracted provider network.",
  "howItWorks": "PAMI is the single largest health financier in Argentina by covered lives among older patients and sits outside the obra social reimbursement machinery. It contracts laboratories and providers directly under its own tariff schedules and its own tender processes, and it maintains a distinct list of covered practices. Because a substantial share of prevalent kidney transplant recipients age into PAMI, it is a material payer for post-transplant surveillance specifically, even though it is a marginal payer for the transplant episode itself. It must be approached as a completely separate negotiation from SUR and from the private payers.",
  "submissionWindow": "Per PAMI contracting and tender cycles; not publicly fixed.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "unverified",
  "priceLow": null,
  "priceHigh": null,
  "currency": "ARS",
  "precedent": "Not established for molecular transplant testing. PAMI does contract for laboratory services generally. LOW confidence on any molecular precedent."
 },
 {
  "id": "arg-private-pay-out-of-pocket",
  "iso3": "ARG",
  "assayClass": "All assays",
  "routeName": "Private pay / out of pocket",
  "routeType": "private_pay",
  "decisionBody": "The patient, or the ordering physician's private laboratory. No authority involved beyond ANMAT registration of the product.",
  "howItWorks": "Where no code exists, Argentine private laboratories simply price the test and the patient pays. This is the default status of any non-nomenclated molecular assay, and combined with hospital-budget purchasing it is where a new transplant test will actually start. It is genuinely viable in CABA and the wealthier metropolitan catchments, where a significant prepaga-holding population is accustomed to topping up. The strategic hazard is that a peso list price set against a dollar reagent cost is unstable; Argentine labs commonly re-price monthly or index informally to the dollar, and doing so openly can attract price-control attention. Volume will be low but it establishes an Argentine clinical dataset, which is the actual prerequisite for every other route on this list.",
  "submissionWindow": "N/A, immediate on ANMAT registration.",
  "difficulty": "low",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "ARS",
  "precedent": "Yes and routinely. Non-covered molecular and genomic tests, including send-out genomic panels to overseas reference labs, are sold private-pay in Argentina. HIGH confidence."
 },
 {
  "id": "arg-judicial-amparo-de-facto-coverage-by-court-order",
  "iso3": "ARG",
  "assayClass": "All assays",
  "routeName": "Judicial amparo (de facto coverage by court order)",
  "routeType": "none",
  "decisionBody": "Federal and provincial courts, applying the constitutional right to health against obras sociales and prepagas.",
  "howItWorks": "This is not a policy route but it is an unavoidable feature of Argentine market access and must be understood. Where a payer refuses a non-PMO item, patients routinely obtain a recurso de amparo compelling coverage, often via interim measure within weeks. Over time an accumulation of amparos against a given technology creates payer cost exposure that itself becomes an argument for formal listing, and payers sometimes begin covering pre-emptively to avoid litigation costs. It should never be an industry-driven strategy (sponsoring litigation is reputationally and legally hazardous), but it is why a technology with strong clinical society backing can achieve real coverage in Argentina without ever being formally listed.",
  "submissionWindow": null,
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "ARS",
  "precedent": "Yes, extensively, for high-cost drugs and for non-listed diagnostics and genomic tests. HIGH confidence in the mechanism; not specific to transplant molecular diagnostics."
 },
 {
  "id": "arg-incucai-laboratory-authorisation-gating-condition-no",
  "iso3": "ARG",
  "assayClass": "All assays",
  "routeName": "INCUCAI laboratory authorisation (gating condition, not a payment route)",
  "routeType": "regulatory_gate",
  "decisionBody": "INCUCAI (Instituto Nacional Central Único Coordinador de Ablación e Implante), with provincial organismos jurisdiccionales such as CUCAIBA.",
  "howItWorks": "INCUCAI holds a statutory monopoly on authorising histocompatibility and transplant-related laboratories and sets their quality standards. This means that for a transplant-specific molecular assay the gatekeeper is not the individual laboratory director and not the payer: it is INCUCAI. A test performed outside an INCUCAI-authorised laboratory has no standing in the national allocation and follow-up system, and results will not be accepted into SINTRA. The corollary is strategically important and often missed: INCUCAI endorsement is worth more than any single payer contract, because it simultaneously unlocks the authorised laboratory network, the national registry data flow, and the credibility needed for SUR or PMO listing. Engage INCUCAI first, before any payer. WARNING: I could not re-verify the specific resolution number for the histocompatibility quality standards in this session (the prior pass cited Resolución 406/15); treat that citation as unverified.",
  "submissionWindow": "No fixed window; laboratory authorisation and standards updates are handled administratively by INCUCAI.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": null,
  "precedent": "Yes. Molecular HLA typing methods have been adopted across the INCUCAI-authorised network. HIGH confidence in the gatekeeper role."
 },
 {
  "id": "arg-anmat-product-registration-mandatory-gate-before-any",
  "iso3": "ARG",
  "assayClass": "All assays",
  "routeName": "ANMAT product registration (mandatory gate before any route above)",
  "routeType": "regulatory_gate",
  "decisionBody": "ANMAT (Administración Nacional de Medicamentos, Alimentos y Tecnología Médica), Ministerio de Salud de la Nación.",
  "howItWorks": "VERIFIED. IVDs register through the HELENA platform as 'productos de Diagnóstico in vitro clase a y b'. Company authorisation is separate and prior, through GEMHA. Both the director técnico and the representante legal must digitally sign every filing, so an Argentine legal representative is compulsory. Each dossier requires the company's Disposición de habilitación, a valid BPF/GMP certificate, and an apostilled or consularised and translated Certificado de Libre Venta under Disposición 5706/17. Fees apply to standard registration; revalidations and the Article 6 Disposición 2675 'baja importación' authorisation for low-volume IVDs are explicitly non-aranceladas. ANMAT's stated clock starts only when the digitally signed documents are submitted (the HELENA guidance references a 15-day plazo for the relevant trámite class), but real-world elapsed time is materially longer and depends on completeness of the dossier and on whether import licensing is also required.",
  "submissionWindow": "Rolling, electronic submission via helena.anmat.gob.ar. Company habilitación via gemha.anmat.gob.ar must be completed first.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "ARS",
  "precedent": "N/A, universal requirement."
 },
 {
  "id": "col-cups-code-assignment-clasificaci-n-nica-de-procedimi",
  "iso3": "COL",
  "assayClass": "All assays",
  "routeName": "CUPS code assignment (Clasificación Única de Procedimientos en Salud)",
  "routeType": "regulatory_gate",
  "decisionBody": "Ministerio de Salud y Protección Social — Dirección de Regulación de Beneficios, Costos y Tarifas del Aseguramiento en Salud",
  "howItWorks": "CUPS is the single national procedure nomenclature. Nothing in Colombia can be authorised, billed, audited or reported to ADRES/SISPRO without a CUPS code, so a code is the entry gate before any payment discussion. CUPS is republished by resolution roughly annually — the current version is Resolución 2706 de 2025, signed 23 Dec 2025 and in force from 1 Jan 2026, containing ~13,639 active codes across chapters including clinical laboratory and immunology (chapter 90). New codes, disaggregations and description changes are folded into each annual resolution after a Ministry-run technical review with scientific societies. A sponsor cannot 'file' for a code the way it would with CPT/PLA in the US; the practical route is to get a Colombian scientific society (e.g. the transplant, nephrology or immunology societies), a high-volume IPS, or the INS to request the code from the Ministry, or to have it created as a consequence of a PBS/UPC update. Note that CUPS explicitly treats medical devices/reagents as 'inherent to the procedure that originates them' — the reagent is not separately payable, it is bundled into the procedure code. Until a specific code exists, a new molecular test is billed under a generic/unclassified immunology or molecular biology code, which invites audit rejection (glosa).",
  "submissionWindow": "Continuous requests to the Ministry, but changes land only in the annual CUPS resolution published in December and effective 1 January.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "COP",
  "precedent": "Yes. Molecular tests routinely carry discrete CUPS codes — e.g. SARS-CoV-2 molecular identification at CUPS 90.8.8.56, HPV DNA testing for cervical screening, HIV/HCV viral load and HIV genotypic resistance, and HLA typing/crossmatch codes in the 90.8 immunology chapter (transplant histocompatibility is an established, coded, funded activity)."
 },
 {
  "id": "col-inclusion-in-the-upc-financed-benefits-list-pbs-anne",
  "iso3": "COL",
  "assayClass": "All assays",
  "routeName": "Inclusion in the UPC-financed benefits list (PBS) — Annex 3, clinical laboratory procedures",
  "routeType": "national_catalogue",
  "decisionBody": "Ministerio de Salud y Protección Social (Dirección de Regulación de Beneficios, Costos y Tarifas del Aseguramiento en Salud), technically supported by IETS (Instituto de Evaluación Tecnológica en Salud)",
  "howItWorks": "This is the single most valuable route and the hardest. The Ministry publishes an annual resolution listing services and technologies financed from UPC (the risk-adjusted capitation payment ADRES transfers to EPS insurers per affiliate). The 2026 instrument is Resolución 2765 de 2025, in force 1 Jan 2026, replacing Resolución 2718 de 2024. It has four technical annexes; Annex 2 is the list of health procedures financed with UPC and Annex 3 is specifically the list of CLINICAL LABORATORY procedures financed with UPC — that is where a new molecular test must land. Once in Annex 3, every EPS (contributivo and subsidiado) is obliged to fund it from UPC and the test becomes standard-of-care billable at any habilitated IPS nationwide, covering ~94% of transplant patients. Process: the Ministry runs an 'actualización integral' cycle each year with an evidence-and-market analysis (HTA by IETS, therapeutic-group analysis, technologies flowing from Ministry-adopted Clinical Practice Guidelines, budget-impact analysis), a public socialisation with pharma, EPS, IPS and patient groups (for the 2026 cycle this was held 11–15 August 2025), then a December resolution effective 1 January. Realistically a sponsor needs: INVIMA registration in hand, Colombian or at minimum Latin-American clinical evidence, a CUPS code, a favourable IETS report, a Ministry-adopted clinical practice guideline recommending the test (this is the strongest lever), and a budget-impact case. Expect 2–4 years from first engagement to Annex 3, and it will not happen at all without a national clinical champion. A caution specific to this cycle: the Ministry's 2026 UPC additions were incremental (formalising SARS-CoV-2 molecular testing and manual dengue antigen), which is the realistic calibration for how much new molecular technology enters per year.",
  "submissionWindow": "Annual. Ministry socialisation of the update methodology mid-August; resolution issued late December; in force 1 January. Engagement must begin in the first half of the calendar year to land in the following year's resolution.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "COP",
  "precedent": "Yes, and good precedent. HPV DNA testing was adopted as primary cervical screening and publicly funded (with formal IETS/Ministry budget-impact analysis against conventional cytology); SARS-CoV-2 molecular testing is explicitly UPC-financed (CUPS 90.8.8.56); HIV/HCV viral load and HIV genotypic resistance testing are long-standing PBS items; HLA typing and crossmatch for transplant are funded. Germline BRCA1/2 testing is understood to be accessible for defined hereditary breast/ovarian indications, but I could not verify its Annex 3 status directly and will not assert it. Multi-gene NGS tumour panels are NOT, to my knowledge, UPC-financed and are accessed via the non-UPC route or private pay."
 },
 {
  "id": "col-non-upc-financing-mipres-prescription-paid-through-a",
  "iso3": "COL",
  "assayClass": "All assays",
  "routeName": "Non-UPC financing: MIPRES prescription paid through ADRES presupuestos máximos",
  "routeType": "innovation_list",
  "decisionBody": "Prescribing physician via MIPRES; funded by ADRES (Administradora de los Recursos del SGSSS) within each EPS's presupuesto máximo; exclusions set by the Ministry under the Resolución 330 de 2017 procedure",
  "howItWorks": "Since Ley Estatutaria 1751 de 2015 Colombia is legally a negative-list system: anything not on the explicit exclusions list must in principle be funded with public money, even if it is not in the UPC annexes. In practice this creates a second tier. A technology that is neither UPC-financed nor excluded is prescribed by the treating clinician through the MIPRES platform, and the EPS is reimbursed for it out of the presupuesto máximo — a capped annual per-EPS budget that ADRES transfers on top of UPC, with giro directo (direct payment) available to the IPS/provider. The methodology and per-EPS amounts are set annually by Ministry resolution (e.g. Resolución 067 de 2025). Providers and suppliers must be registered in REPS and in MIPRES to be paid. This is the only realistic near-term public route for a novel molecular transplant test, and it can start the day a CUPS code and INVIMA registration exist. Three severe caveats. (1) The budget is CAPPED — once an EPS exhausts its presupuesto máximo, further prescriptions are unfunded, and EPS routinely block MIPRES prescriptions for exactly this reason. (2) The four EPS financing ~58% of kidney transplants are all under Supersalud intervention or corrective plans, with Nueva EPS carrying negative equity above COP 10 trillion and multi-trillion-peso arrears to IPS, so a MIPRES-funded test converts into a receivable of uncertain collectability — this is the dominant commercial risk in Colombia, not the science. (3) Where an EPS refuses, the backstop is the tutela (constitutional injunction): a judge orders the EPS to fund the test and the EPS recovers from ADRES. Tutela is genuinely effective per patient and is how most Colombian patients access genomic testing today, but it is litigation-driven, unforecastable and cannot be a commercial plan. Separately, the exclusions procedure under Resolución 330 de 2017 runs annually with a nomination window of 1 March to 30 April, a technical-scientific analysis group with IETS support (45 business days, extendable 10), a patient/citizen consultation phase (up to 45 days), then a Ministry decision — a sponsor should monitor it defensively, because it is the mechanism by which a technology can be pushed OUT of public funding.",
  "submissionWindow": "MIPRES prescription is continuous and per-patient. The Resolución 330 exclusions nomination window is 1 March to 30 April each year.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "COP",
  "precedent": "Yes. High-cost molecular and genomic tests outside the UPC package — NGS tumour panels, hereditary cancer panels, specialised genetic diagnostics — are routinely accessed in Colombia through MIPRES and/or tutela rather than through PBS inclusion."
 },
 {
  "id": "col-eps-ips-negotiated-contract-prospective-global-payme",
  "iso3": "COL",
  "assayClass": "All assays",
  "routeName": "EPS–IPS negotiated contract / prospective global payment (PGP) transplant bundle",
  "routeType": "block_contract",
  "decisionBody": "Individual EPS insurer and individual IPS transplant centre, bilaterally. No national body involved.",
  "howItWorks": "Colombia has NO binding national fee schedule. The old reference manuals — ISS 2001 (Acuerdo 256 de 2001, laboratory tariffs at Chapter II Art. 25) and the SOAT manual — are only negotiation anchors, still cited with uplift factors in some 2025 contracts, but prices are freely negotiated between each EPS and each IPS. Transplant is increasingly contracted as a bundled prospective payment (pago global prospectivo) or an episode 'paquete' covering workup, surgery and follow-up. The commercially fastest route for a new molecular surveillance test is therefore NOT a national listing at all: it is to persuade a small number of high-volume transplant IPS (Cardioinfantil, Valle del Lili, Pablo Tobón Uribe, Fundación Santa Fe de Bogotá) to embed the test inside their existing bundle price, or to renegotiate the bundle upward with the EPS on a rejection-avoidance/biopsy-displacement economic argument. This bypasses CUPS-level payment fights, works with the ~82% of kidney transplant volume concentrated in Bogotá, Antioquia and Valle del Cauca, and reduces the sales problem to roughly 6–10 institutional conversations. The trade-off is that the IPS absorbs the cost inside a fixed bundle, so the price must be demonstrably self-financing.",
  "submissionWindow": "Contract renegotiation cycles, typically annual, per EPS–IPS pair. No fixed national window.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "COP",
  "precedent": "Not verified for any molecular transplant test specifically. Bundled/PGP contracting for transplant episodes is standard Colombian practice, and specialised laboratory work is routinely inside those bundles, but I found no published example of a novel molecular test being funded this way."
 },
 {
  "id": "col-central-public-procurement-ins-national-transplant-n",
  "iso3": "COL",
  "assayClass": "All assays",
  "routeName": "Central public procurement — INS national transplant network and the new INDTOT",
  "routeType": "tender",
  "decisionBody": "Instituto Nacional de Salud (INS, current coordinator of the Red de Donación y Trasplantes and its reference immunology laboratory) and, prospectively, INDTOT (Instituto Nacional de Donación y Trasplante de Órganos y Tejidos); procurement executed through SECOP II / Colombia Compra Eficiente",
  "howItWorks": "This is the structural opening created by the transplant reform passed by Congress in June 2026. INDTOT is being stood up as a Ministry-attached institute with its own legal personality and budget, mandated to operate the national donation and transplant system and to administer a national information system integrating hospitals, EPS, tissue banks, IMMUNOLOGY LABORATORIES and regional coordinations. Critically, the law creates a statutory National Registry of Incompatible Donors and Highly Sensitised Patients — a funded legal obligation to generate and maintain HLA antibody and histocompatibility data at national scale. That is a direct central-procurement mandate for the exact assay class in question, and it is the only route in Colombia where a payer actually has a legal duty to buy the test rather than a discretion to refuse it. Practically: a national reference-laboratory contract or a centralised testing service tendered through SECOP II, or subcontracted to the INS immunology reference lab, or to a small number of designated regional labs. Because deceased donors are ~89% concentrated in Bogotá, Antioquia and Valle del Cauca, a centralised or three-site model is technically feasible and cheap to serve. Timing is the risk: INDTOT must be constituted, regulated by decree, staffed and budgeted before it can tender, and Colombian institute stand-ups typically run 12–24+ months. Also relevant: public hospitals (ESE) and departmental health secretariats procure laboratory services through SECOP II tenders in their own right.",
  "submissionWindow": "Not yet open. Watch for the implementing decree constituting INDTOT and its first budget cycle; then SECOP II tender notices. Engagement should be with INS transplant network and Ministry policy staff now, pre-tender.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "COP",
  "precedent": "Partially. The INS already operates as national reference laboratory for transplant immunology and public health molecular testing (it ran centralised SARS-CoV-2 molecular testing and network accreditation), so centrally funded molecular testing through a national institute is an established Colombian pattern. No precedent yet for INDTOT itself, which does not operationally exist."
 },
 {
  "id": "col-reg-menes-de-excepci-n-military-police-health-system",
  "iso3": "COL",
  "assayClass": "All assays",
  "routeName": "Regímenes de excepción (military/police health system, FOMAG teachers, Ecopetrol, universities)",
  "routeType": "block_contract",
  "decisionBody": "Each excepted regime independently — e.g. Subdirección de Salud de las Fuerzas Militares / Sanidad Policía, Fiduprevisora–FOMAG for the teachers' regime, Ecopetrol's own health service",
  "howItWorks": "About 6% of Colombian kidney transplants sit outside the SGSSS in regímenes de excepción. These regimes are NOT bound by the PBS/UPC annexes; they define their own benefit plans and contract providers directly, often by direct contracting or their own tenders. They are small in volume but can be materially faster and better-paying than intervened EPS, and they are a legitimate beachhead for generating Colombian clinical and health-economic data before attempting UPC inclusion. Payment terms and solvency vary widely by regime.",
  "submissionWindow": "Regime-specific contracting cycles; no published national window.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "COP",
  "precedent": null
 },
 {
  "id": "col-private-pay-out-of-pocket-medicina-prepagada-and-vol",
  "iso3": "COL",
  "assayClass": "All assays",
  "routeName": "Private pay — out-of-pocket, medicina prepagada and voluntary health policies",
  "routeType": "private_pay",
  "decisionBody": "Patient, or the prepaid/voluntary insurer (Colsanitas/Keralty, Sura, Colmédica, MedPlus)",
  "howItWorks": "Direct cash pay at a private laboratory or IPS, or coverage under a medicina prepagada plan or póliza de salud purchased on top of mandatory EPS affiliation. No listing, no CUPS dependency, no HTA — the only gate is INVIMA registration of the reagent and habilitación of the performing laboratory. This is how most Colombian patients currently obtain non-PBS genomic testing and it is the only route available on day one. It is also how private reference labs currently sell send-out molecular testing. The limitation is obvious: it reaches a small, Bogotá/Medellín/Cali-weighted, high-income slice of a transplant population that is overwhelmingly publicly insured, so it validates the assay commercially but does not build a market. Prepaid insurers do maintain their own coverage lists and can add a test by internal medical-policy decision, which is faster than any public route.",
  "submissionWindow": null,
  "difficulty": "low",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "COP",
  "precedent": "Yes, routinely — NGS panels, hereditary cancer testing and specialised molecular diagnostics are sold private-pay in Colombia today, frequently as send-outs to foreign reference laboratories."
 },
 {
  "id": "chl-fonasa-arancel-mai-public-institutional-fee-schedule",
  "iso3": "CHL",
  "assayClass": "All assays",
  "routeName": "Fonasa Arancel MAI (public institutional fee schedule)",
  "routeType": "fee_schedule",
  "decisionBody": "Ministerio de Salud (MINSAL) + Fondo Nacional de Salud (Fonasa), with mandatory concurrence of Ministerio de Hacienda / DIPRES; enacted by joint Decreto Exento",
  "howItWorks": "MAI is the tariff applied when care is delivered inside the public network (hospitals and consultorios) to Fonasa beneficiaries, who carry roughly 79% of Chilean transplant volume per the previous pass. Clinical laboratory tests sit in the laboratory group of the Arancel. A test with no MAI code is not a funded prestacion: a public hospital cannot bill it and has no line item for it. Creating a NEW code is not an administrative act by Fonasa alone — it requires MINSAL to define the prestacion, a costing exercise, budget-impact sign-off from Hacienda/DIPRES because MAI codes create an open-ended fiscal commitment across the whole public network, and then publication by decree. The arancel is reissued annually (values typically effective 1 January), but that annual cycle is a revaluation exercise, not a reliable window for introducing genuinely new technologies. Practical read: this is the route that unlocks the 79% of volume, and it is also the slowest and least tractable route for a foreign vendor acting alone. It is normally reached only AFTER the technology is already embedded in a MINSAL clinical guideline or a GES basket.",
  "submissionWindow": "No published open submission window for new technologies. Arancel decree reissued annually (effective around 1 January); new-code creation is negotiated, not applied for.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CLP",
  "precedent": "Yes, at category level. Molecular/nucleic-acid tests are established in the Chilean public arancel — HIV viral load is a routinely funded public prestacion tied to the GES HIV/AIDS guarantee, and SARS-CoV-2 RT-PCR was added and funded at national scale during 2020, demonstrating that MINSAL/Fonasa can create and price a molecular code quickly when there is political will. I could not verify specific code numbers or values in this session and will not guess them. No dd-cfDNA or transplant molecular surveillance code is known to exist."
 },
 {
  "id": "chl-fonasa-arancel-mle-modalidad-libre-eleccion-fonasa-b",
  "iso3": "CHL",
  "assayClass": "All assays",
  "routeName": "Fonasa Arancel MLE (Modalidad Libre Eleccion) — Fonasa beneficiaries treated privately",
  "routeType": "fee_schedule",
  "decisionBody": "MINSAL + Fonasa, by decree; providers enrol at Nivel 1/2/3",
  "howItWorks": "MLE lets Fonasa beneficiaries (groups B, C, D) use private providers and labs, paying a copayment while Fonasa reimburses a scheduled amount that varies by the provider's registered level. This is the mechanism by which a private Santiago laboratory can be paid partly from public funds. Same fundamental constraint as MAI: the prestacion must have a code. A dd-cfDNA or molecular surveillance test with no MLE code is billed to the patient in full as a prestacion no arancelada. MLE matters strategically because it is the bridge — a test can be established in the private sector on self-pay, generate Chilean utilisation and cost data, and then be argued into MLE more easily than straight into MAI, because MLE spend is bounded by copayment behaviour rather than being an open network commitment.",
  "submissionWindow": "Same annual decree cycle as MAI; no open technology-submission window.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CLP",
  "precedent": "Molecular laboratory prestaciones exist in the MLE arancel structure generally. No transplant-specific molecular precedent identified."
 },
 {
  "id": "chl-ges-auge-inclusion-in-the-kidney-transplant-guarante",
  "iso3": "CHL",
  "assayClass": "All assays",
  "routeName": "GES / AUGE — inclusion in the kidney transplant guarantee basket (canasta)",
  "routeType": "hta_appraisal",
  "decisionBody": "MINSAL (Subsecretaria de Salud Publica and Departamento de Evaluacion de Tecnologias Sanitarias) with Ministerio de Hacienda; formal advice from the Consejo Consultivo GES; enacted by Decreto Supremo GES signed by MINSAL and Hacienda",
  "howItWorks": "GES (Garantias Explicitas en Salud, the AUGE regime under Ley 19.966) is the single highest-value pathway in Chile, because a GES guarantee is legally binding on BOTH Fonasa and every Isapre — it is the one mechanism that forces private insurers to cover something. Chronic kidney disease and kidney transplantation, including post-transplant immunosuppression, are existing GES health problems, so the relevant guarantee already exists; the ask is not a new health problem but the addition of a surveillance test to the existing canasta and its Guia Clinica. The statute requires the GES decree to be reviewed on a fixed cycle (three years under Ley 19.966), and the process demands an evidence dossier, a cost-effectiveness assessment, an explicit budget-impact estimate, and Hacienda approval, because every item added is a nationwide legal entitlement. In practice revisions have slipped beyond the statutory cycle. Realistic horizon for a novel assay: five years or more, and it will not happen without Chilean clinical champions in the transplant community and locally generated evidence. Note the structural prize: GES inclusion solves the Isapre problem at the same stroke, converting a discretionary private-pay test into a mandatory covered benefit for the whole insured population.",
  "submissionWindow": "Statutory review cycle of three years for the GES decree; MINSAL runs an evidence-gathering and prioritisation stage ahead of each revision. Exact dates for the next revision could not be verified this session.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CLP",
  "precedent": "HIV/AIDS is a GES health problem whose basket includes viral load monitoring — i.e. a molecular monitoring test funded through the GES mechanism. That is a genuine and directly analogous precedent for a nucleic-acid surveillance assay entering a GES basket. Confidence medium-high; the specific basket line items could not be re-verified this session."
 },
 {
  "id": "chl-ley-ricarte-soto-ley-20-850-fondo-de-tratamientos-de",
  "iso3": "CHL",
  "assayClass": "All assays",
  "routeName": "Ley Ricarte Soto (Ley 20.850) — Fondo de Tratamientos de Alto Costo",
  "routeType": "hta_appraisal",
  "decisionBody": "MINSAL, via a formal ETESA process with a Comision Ciudadana de Vigilancia and a Comision de Recomendacion Priorizada; decree signed with Hacienda",
  "howItWorks": "Ley 20.850 created a dedicated national fund for high-cost treatments with a genuine, transparent HTA process — arguably the most formalised technology-assessment route Chile has. Its statutory scope is medicamentos, dispositivos medicos and alimentos, i.e. therapies, not standalone diagnostics. A surveillance assay is therefore very unlikely to qualify on its own. The realistic angle is indirect: where the fund covers a high-cost therapy, the diagnostic test required to confirm eligibility under the protocol gets funded as part of that protocol. If a molecular test were positioned as the mandatory gate to an expensive intervention rather than as a monitoring assay, this route becomes arguable. For a post-transplant rejection surveillance test with no linked high-cost therapy, I would score this as effectively closed.",
  "submissionWindow": "Decree revised on a statutory three-year cycle, with a public/expert nomination and prioritisation stage preceding each decree.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CLP",
  "precedent": "Enzyme-replacement therapies for lysosomal storage disorders funded under this law require enzymatic and/or genetic confirmation of diagnosis, so genetic confirmatory testing is de facto funded as part of covered protocols. Confidence medium — the mechanism is consistent with how the fund's protocols work but I could not verify the specific line items this session."
 },
 {
  "id": "chl-public-tender-to-isp-via-chilecompra-mercado-publico",
  "iso3": "CHL",
  "assayClass": "All assays",
  "routeName": "Public tender to ISP via ChileCompra / Mercado Publico",
  "routeType": "tender",
  "decisionBody": "Instituto de Salud Publica (ISP) as contracting authority, operating under Ley 19.886 de Compras Publicas through the Mercado Publico platform; ISP's own institutional budget",
  "howItWorks": "This is the pragmatic near-term public-sector route, and it follows directly from the previous pass's finding that histocompatibility testing is a state monopoly held by ISP. Because there is effectively one buyer rather than a market of hospital labs, you are not selling into a fee schedule at all — you are selling reagents, instruments or a service contract to a single state institution, paid from its own budget line, awarded by public tender. Mechanisms under Ley 19.886, roughly in ascending order of size: Compra Agil for low-value purchases (threshold set in UTM), Convenio Marco framework agreements administered by ChileCompra, Licitacion Publica for open competitive tenders, and Trato Directo (sole source) which is permitted only with published legal justification — relevant for a genuinely unique patented assay with no substitute, though ISP will be conservative about invoking it. Timeline per tender cycle is on the order of three to twelve months once ISP has budgeted for it; the real gating item is not procurement mechanics but getting ISP to want the test and to carry it in its annual budget. Note also that ISP charges its own published tariff for reference laboratory services rendered to hospitals, so an alternative structure is to have the assay performed BY ISP and priced into ISP's service tariff rather than sold as a product. CENABAST (Central Nacional de Abastecimiento) runs aggregated public purchasing and is a parallel channel, though its centre of gravity is pharmaceuticals and consumables rather than specialist molecular reagents.",
  "submissionWindow": "Continuous; tenders are published on Mercado Publico as ISP's budget allows. No fixed technology-submission window. Influence the specification before the tender is drafted, not after.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CLP",
  "precedent": "Yes at category level — ISP procures Luminex-based anti-HLA antibody platforms and molecular HLA typing reagents through public procurement, which is by definition a molecular transplant test funded by this route. That is the single most directly relevant precedent in Chile. No dd-cfDNA precedent identified."
 },
 {
  "id": "chl-public-hospital-budget-self-managed-network-establis",
  "iso3": "CHL",
  "assayClass": "All assays",
  "routeName": "Public hospital budget / self-managed network establishments (EAR) — direct purchase",
  "routeType": "block_contract",
  "decisionBody": "Individual hospital director (Establecimiento de Autogestion en Red) and the relevant Servicio de Salud, within Ley 19.886 thresholds",
  "howItWorks": "Chile's larger public hospitals hold Establecimiento de Autogestion en Red status, which gives them meaningful budget autonomy and the ability to purchase directly under the low-value mechanisms of Ley 19.886 (notably Compra Agil below the UTM threshold, and Trato Directo with written justification). For a novel test this is the pilot route: a transplant unit at a major public hospital buys a limited number of tests from its own budget to generate local evidence, without any code, decree or national decision. It does not scale — the budget is finite and competing with everything else the hospital buys — but it is how Chilean clinicians in practice get access to technologies that the arancel has not caught up with, and it produces exactly the local utilisation and outcome data the GES and arancel routes will later demand. Treat it as evidence-generation infrastructure rather than as a revenue line.",
  "submissionWindow": "Continuous, subject to hospital budget cycles (calendar-year).",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CLP",
  "precedent": "Not verified for any specific molecular transplant test. The mechanism itself is routine for specialist send-away testing in Chilean public hospitals."
 },
 {
  "id": "chl-isapre-coverage-discretionary-contractual-non-tariff",
  "iso3": "CHL",
  "assayClass": "All assays",
  "routeName": "Isapre coverage — discretionary, contractual, non-tariffed",
  "routeType": "private_pay",
  "decisionBody": "Each individual Isapre (Banmedica, Colmena, Cruz Blanca, Consalud, Vida Tres, Nueva Masvida etc.), per the beneficiary's contracted plan; Superintendencia de Salud regulates conduct but does not mandate coverage outside GES",
  "howItWorks": "Isapres cover roughly 20% of Chilean transplant recipients per the previous pass — the paying minority concentrated in the Santiago private clinics. Isapres are legally obliged to cover GES guarantees; outside GES, coverage is purely contractual and benchmarked against the Fonasa arancel as a reference tariff. A test with no arancel code is a prestacion no arancelada, which in practice means either zero reimbursement or a discretionary case-by-case percentage negotiated by the treating clinician, often via the clinic's convenio with the insurer. There is no formal listing process to apply to, no committee, and no published window. What actually moves an Isapre is a convenio negotiated between the insurer and a specific provider (clinic or laboratory), plus clinician pressure. This is genuinely reachable within twelve months but produces variable, unpredictable reimbursement and cannot be relied on for pricing. The Isapre sector has also been under acute financial and legal stress in recent years following Supreme Court rulings on risk tables and premium adjustments, which has made insurers markedly more resistant to new non-mandatory spend — a real headwind. Verify the current state of Isapre solvency and the Superintendencia's position before modelling revenue here.",
  "submissionWindow": "None. Continuous, provider-by-provider convenio negotiation.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CLP",
  "precedent": "Isapres do reimburse high-cost genomic and molecular testing on a discretionary or partial basis at private Santiago providers. Confidence medium; no transplant-specific precedent verified."
 },
 {
  "id": "chl-private-pay-self-funded-testing-through-santiago-pri",
  "iso3": "CHL",
  "assayClass": "All assays",
  "routeName": "Private pay / self-funded testing through Santiago private clinics and laboratories",
  "routeType": "private_pay",
  "decisionBody": "None — patient or clinic commercial decision. Requires only that the performing laboratory holds an Autorizacion Sanitaria from the SEREMI de Salud.",
  "howItWorks": "The only route available immediately. Chile has an established out-of-pocket market for advanced genomic and molecular testing delivered through the high-end private Santiago clinics identified in the previous pass — Las Condes, Alemana, Davila, Santa Maria, UC Christus — and their associated laboratory networks, including specialist genomics units attached to Clinica Alemana and Clinica Las Condes. Two viable structures: (a) send-out, where Chilean samples are shipped to an accredited laboratory abroad and billed to the patient or clinic in USD, which avoids Chilean device registration entirely but attracts import/export and sample-shipment logistics; or (b) local delivery, where the assay is run in a Chilean laboratory as a laboratory-developed test under that lab's SEREMI authorisation, again largely avoiding device registration. Route (b) is preferable for cost, turnaround and for generating the Chilean evidence base needed for every other pathway on this list. The population is small — a minority of roughly 375 annual kidney transplants — so this is a beachhead and an evidence-generation strategy, not a market. Prices are set commercially; I have no verified Chilean price points and will not estimate them.",
  "submissionWindow": "None — immediate.",
  "difficulty": "low",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CLP",
  "precedent": "Yes. Privately funded genomic and molecular testing including oncology panels and hereditary disease sequencing is routinely delivered and self-paid through Chilean private clinics and genomics units. Confidence medium-high on the category; no dd-cfDNA transplant precedent identified."
 },
 {
  "id": "chl-isp-registration-import-authorisation-the-regulatory",
  "iso3": "CHL",
  "assayClass": "All assays",
  "routeName": "ISP registration / import authorisation — the regulatory gate before any paid route",
  "routeType": "regulatory_gate",
  "decisionBody": "Instituto de Salud Publica de Chile (ISP), Departamento ANAMED, Subdepartamento de Dispositivos Medicos; laboratory premises authorised by the SEREMI de Salud",
  "howItWorks": "See the regulatory_note field for full detail. Short version: ISP is the IVD authority; historically only a narrow enumerated list of device types required full registro sanitario under DS 825/1998 MINSAL, with most IVDs entering on an ISP import authorisation and Certificado de Destinacion Aduanera, but blood-bank screening reagents are an exception subject to registration and lot release. A Chilean-domiciled importer or representative holding an ISP/SEREMI establishment authorisation is effectively compulsory — a foreign manufacturer cannot hold the authorisation itself. Delivering the assay as a laboratory service rather than a kitted product largely bypasses device registration and shifts the burden to the performing lab's Autorizacion Sanitaria and participation in ISP's PEEC external quality scheme. CRITICAL CAVEAT: Chile has had a modernised risk-classified device regulation in preparation for several years and I could not confirm this session whether it is now in force or whether IVDs have been brought into mandatory registration. This must be verified with ANAMED before any regulatory plan is committed.",
  "submissionWindow": "Continuous.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CLP",
  "precedent": "Not applicable — this is a gate, not a funding route."
 },
 {
  "id": "per-essalud-petitorio-nacional-de-patologia-clinica-y-an",
  "iso3": "PER",
  "assayClass": "All assays",
  "routeName": "EsSalud Petitorio Nacional de Patologia Clinica y Anatomia Patologica (IETSI national test catalogue)",
  "routeType": "national_catalogue",
  "decisionBody": "IETSI (Instituto de Evaluacion de Tecnologias en Salud e Investigacion), EsSalud",
  "howItWorks": "This is THE route that matters in Peru. EsSalud performs ~85-90% of national transplant activity and is effectively the only buyer. A laboratory test is only orderable and fundable inside EsSalud if it carries an entry (with a SAP code) in the Petitorio Nacional de Patologia Clinica y Anatomia Patologica, which IETSI maintains and amends by numbered Resolucion, each addition backed by a Ficha Tecnica. Once listed with a SAP code, the test is budgeted centrally and consumables are bought by tender. CRITICAL COMMERCIAL CONSTRAINT: under Directiva N 001-IETSI-ESSALUD-2018 (approved by Resolucion N 13-IETSI-ESSALUD-2018), section 7.3.8, the request to include, modify or exclude an item must come FROM an EsSalud internal body: an organo desconcentrado, an organo prestador nacional, an IPRESS or a gerencia central. A manufacturer or foreign supplier CANNOT self-submit. The entry strategy is therefore to recruit a clinical champion, in practice the Banco de Organos y Laboratorio de Histocompatibilidad at Hospital Rebagliati, and have them raise the Anexo (formats published on the IETSI site in Word/PDF) with your dossier as supporting evidence. Note the petitorio historically lists reagent/kit lines and analysers separately, and several histocompatibility analysers are held under 'cesion en uso' (instrument placed at no capital cost, revenue recovered on reagents), which is the commercially proven model for getting a platform into Rebagliati.",
  "submissionWindow": "Rolling. IETSI issues petitorio resolutions continuously through the year rather than in an annual window, so there is no fixed cut-off; the real gate is the internal EsSalud sponsor's willingness to raise the Anexo.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "PEN",
  "precedent": "YES, and it is the direct analogue. 'HLA tipificacion molecular para operativos de trasplante', SAP code 030107286, added by Resolucion N 089-IETSI-ESSALUD-2025 dated 21/05/2025. The petitorio also carries BRCA1/BRCA2 mutation detection, Mycobacterium tuberculosis DNA and resistance kits, respiratory pathogen panels, monkeypox molecular detection, and HLA molecular typing generally. Supporting instrument precedent: 'Modular para biologia molecular histocompatibilidad', 'Analizador semiautomatizado para biologia molecular histocompatibilidad' and 'Analizador semiautomatizado para deteccion de anticuerpos anti HLA', all under Resolucion N 148-GCPS-ESSALUD-2014 (09/10/2014), status 'Cesion en Uso'. IMPORTANT GAP: no donor-derived cell-free DNA, chimerism or transplant NGS entry appears in the petitorio; the only sequencing-adjacent line is a generic 'Modular para analisis de secuencias de acidos nucleicos'. So molecular transplant testing has precedent, but dd-cfDNA specifically would be a first-in-country listing."
 },
 {
  "id": "per-ietsi-health-technology-assessment-dictamen-de-evalu",
  "iso3": "PER",
  "assayClass": "All assays",
  "routeName": "IETSI health technology assessment (Dictamen de Evaluacion de Tecnologia Sanitaria)",
  "routeType": "hta_appraisal",
  "decisionBody": "Direccion de Evaluacion de Tecnologias Sanitarias (DETS), IETSI, EsSalud",
  "howItWorks": "Where a technology is genuinely new rather than a line-extension, IETSI's DETS runs a formal HTA and publishes a Dictamen Preliminar assessing efficacy and safety, followed by Dictamen de Recomendacion / Dictamen Definitivo, which either supports ('aprueba el uso') or does not support use within EsSalud. This is the evidence gate that sits behind or alongside a petitorio listing for anything novel. Dictamenes are numbered by year (e.g. N 003-DETS-IETSI-2024) and published openly on the IETSI site and in the EsSalud repository, so the evidentiary bar and the reasoning style are fully inspectable in advance, which is a real advantage for dossier preparation. IETSI is methodologically conservative and leans hard on comparative clinical outcome evidence and budget impact; diagnostic accuracy alone tends not to be sufficient. Expect scrutiny of whether the test changes management versus the existing standard (for transplant, protocol biopsy and DSA monitoring). Same submission constraint as the petitorio: the request originates internally within EsSalud, not from the vendor.",
  "submissionWindow": "Rolling; no published fixed window. Elapsed time from request to Dictamen is typically many months to over a year based on the published dictamen series.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "PEN",
  "precedent": "YES for molecular diagnostics. Dictamen Preliminar N 003-DETS-IETSI-2024 assessed a rapid molecular test for carbapenemase detection in patients with severe sepsis/septic shock. IETSI has also evaluated HPV DNA testing. There is a published dictamen stream covering medical devices and biomedical equipment separately from pharmaceuticals. No dd-cfDNA or transplant molecular dictamen identified."
 },
 {
  "id": "per-essalud-public-procurement-seace-tender-cesion-en-us",
  "iso3": "PER",
  "assayClass": "All assays",
  "routeName": "EsSalud public procurement (SEACE tender / cesion en uso reagent-rental)",
  "routeType": "tender",
  "decisionBody": "EsSalud central procurement (Gerencia Central de Logistica / Gerencia Central de Prestaciones de Salud), under OECE oversight",
  "howItWorks": "Petitorio listing creates the right to use the test; the actual cash comes from a procurement award. Since 22 April 2025 public buying runs under Ley N 32069 (Ley General de Contrataciones Publicas) and its Reglamento DS N 009-2025-EF, which replaced Ley 30225; tenders are published on SEACE. For a market this small (roughly 158 kidney transplants nationally), a per-test list price is commercially unworkable; the realistic structure is a multi-year suministro contract for kits with the analyser supplied under 'cesion en uso', which is exactly how EsSalud already holds its histocompatibility molecular biology and anti-HLA antibody analysers (Resolucion N 148-GCPS-ESSALUD-2014). Practical frictions: technical specifications are drafted with reference to the petitorio Ficha Tecnica, so whoever shapes the Ficha Tecnica shapes the tender; EsSalud benchmarks against reference prices and historical purchase records, which penalises a first-in-country test with no domestic price history; and bidding requires a Peruvian legal entity registered in the RNP with the DIGEMID registro sanitario already in hand. Established local distributors have a structural advantage.",
  "submissionWindow": "Tied to EsSalud's annual Plan Anual de Contrataciones (PAC); individual convocatorias published on SEACE through the year with statutory bid periods.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "PEN",
  "precedent": "YES for the mechanism (HLA typing kits and histocompatibility molecular platforms are procured this way, with analysers under cesion en uso). No identified Peruvian tender for a transplant dd-cfDNA or molecular rejection assay."
 },
 {
  "id": "per-minsa-cpms-coding-then-sis-tarifario-de-procedimient",
  "iso3": "PER",
  "assayClass": "All assays",
  "routeName": "MINSA CPMS coding then SIS Tarifario de Procedimientos Medicos y Sanitarios",
  "routeType": "fee_schedule",
  "decisionBody": "MINSA (owns the CPMS catalogue, by Resolucion Ministerial) and Seguro Integral de Salud (sets the tariff, by Resolucion Jefatural)",
  "howItWorks": "This is the tax-funded, non-EsSalud route, covering the handful of MINSA and regional-government kidney programmes. It is a genuine national fee schedule and it is a strict two-step. STEP 1: the procedure must exist in the Catalogo de Procedimientos Medicos y Sanitarios del Sector Salud (CPMS), created by DS 024-2005-SA and updated by Resolucion Ministerial (RM 902-2017-MINSA, RM 215-2022-MINSA, most recently RM 550-2023-MINSA, ~11,000+ procedures). Without a CPMS code the test cannot be recorded, billed or audited; SUSALUD enforces CPMS coding across IAFAS and IPRESS. STEP 2: SIS must then put a price against that code in its Tarifario de Procedimientos Medicos y Sanitarios, approved by Resolucion Jefatural and revised roughly annually (RJ N 000190-2023-SIS-J homologated codes to RM 550-2023-MINSA; RJ N 049-2024 added high-specialisation oncology/cardiology/neurology procedures; RJ N 000024-2026-SIS/J is the current 2026 tarifario). The catalogue has been expanding fast, from 3,078 procedures in the Oct 2023 tarifario to 3,841, which shows the door is open in principle. In practice this route is slow, budget-constrained, and given that MINSA runs only a small minority of transplants it is strategically secondary to EsSalud. There is also a concerted MINSA/EsSalud referential tariff exercise (costing of ~350 PEAS procedures, coordinated by DGAIN under Decreto Legislativo 1302) used for intercambio prestacional cross-billing between the two systems.",
  "submissionWindow": "CPMS updated by RM at irregular multi-year intervals (2017, 2022, 2023). SIS tarifario revised approximately annually by Resolucion Jefatural.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "PEN",
  "precedent": "PARTIAL. The CPMS/SIS tarifario contains molecular and high-specialisation diagnostic procedures and has recently absorbed high-specialisation oncology and neurology items, so molecular tests are fundable in principle. No identified transplant-specific molecular monitoring line item."
 },
 {
  "id": "per-fissal-fondo-intangible-solidario-de-salud-high-cost",
  "iso3": "PER",
  "assayClass": "All assays",
  "routeName": "FISSAL (Fondo Intangible Solidario de Salud) high-cost disease fund",
  "routeType": "block_contract",
  "decisionBody": "FISSAL, a unit of SIS, MINSA",
  "howItWorks": "FISSAL is the ring-fenced fund that finances high-cost conditions, rare/orphan diseases and high-complexity procedures for SIS-insured patients, explicitly including kidney, liver and haematopoietic progenitor transplantation and the full chronic kidney disease pathway (haemodialysis, peritoneal dialysis, transplant). Coverage is automatic from the moment an SIS insured person is diagnosed with a condition on the listed high-cost or rare-disease lists, across 400+ covered conditions; in 2026 to date it financed 510,837 high-complexity services for 141,313 insured people. Relevance for a new test: FISSAL pays for the transplant episode and CKD care rather than line-itemising individual novel diagnostics, so the realistic play is to get post-transplant molecular surveillance recognised as part of the financed transplant/CKD package rather than to seek a standalone FISSAL tariff. That still requires the underlying CPMS code and SIS tariff to exist first, which makes this route downstream of, not an alternative to, the CPMS/SIS pathway. This is the weakest-characterised route in this analysis and the mechanism for adding a new diagnostic to a FISSAL-financed package was not established from public sources.",
  "submissionWindow": "Not established from public sources.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "unverified",
  "priceLow": null,
  "priceHigh": null,
  "currency": "PEN",
  "precedent": "NO molecular transplant test identified as FISSAL-funded. Precedent exists only at package level: kidney and liver transplantation and CKD care are financed."
 },
 {
  "id": "per-private-pay-and-eps-private-insurance-above-peas-pla",
  "iso3": "PER",
  "assayClass": "All assays",
  "routeName": "Private pay and EPS / private insurance (above-PEAS plans)",
  "routeType": "private_pay",
  "decisionBody": "Individual EPS and private insurers (Pacifico, Rimac and others), regulated by SUSALUD; ultimately the patient",
  "howItWorks": "Peru has no ROL-equivalent mandatory private coverage list for novel diagnostics. The floor is the PEAS (Plan Esencial de Aseguramiento en Salud), a prioritised list of insurable conditions and guaranteed interventions that ALL IAFAS (public, private and mixed) must finance as a minimum, reviewed on a 2-year cycle, with explicit guarantees of timeliness and quality enforceable by SUSALUD. PEAS is a minimum, not a ceiling: EPS routinely sell above-PEAS supplementary cover, and EsSalud's own plans exceed PEAS. A new molecular test not in PEAS is therefore a discretionary benefit each insurer decides on individually, or straight cash pay. There is an established Peruvian private molecular/genetic testing market (Bioarray, Genetics, SuizaLab, Biolinks, Multilab, Biogenomica offering NGS cancer panels and genetic testing), so the delivery channel exists. Realistically this route is a beachhead for evidence generation and clinician familiarity, not a revenue base: the private transplant sector is brand new (Clinica Delgado for kidney, Clinica San Pablo accredited for liver Aug 2024, first private patient on the national list Oct 2025) and the addressable volume is a handful of patients. NO PRICE GIVEN: published Peruvian private prices exist only for unrelated tests (COVID-19 PCR roughly S/160-350; DNA/paternity testing roughly S/700-1,400 across named labs) and it would be misleading to extrapolate these to a transplant molecular assay. No Peruvian private price for any transplant molecular test was found.",
  "submissionWindow": "N/A. Cash-pay is immediate on DIGEMID registration and lab accreditation; individual EPS benefit decisions are commercial negotiations with no published window. PEAS itself is reviewed every 2 years.",
  "difficulty": "low",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "PEN",
  "precedent": "YES for private molecular/genomic testing generally (NGS cancer panels and genetic panels are sold privately in Lima). NO identified precedent for a transplant molecular test being privately funded in Peru."
 },
 {
  "id": "per-digemid-registro-sanitario-for-in-vitro-diagnostic-d",
  "iso3": "PER",
  "assayClass": "All assays",
  "routeName": "DIGEMID Registro Sanitario for in vitro diagnostic devices (mandatory gate before any route above)",
  "routeType": "regulatory_gate",
  "decisionBody": "DIGEMID (Direccion General de Medicamentos, Insumos y Drogas), MINSA",
  "howItWorks": "Nothing can be sold, imported or supplied to EsSalud/MINSA without this. IVD reagents and calibrators fall inside the medical device definition. Four risk classes under DS 003-2020-SA classification rules; a clinical-decision molecular transplant assay is realistically Class III or IV. Application is made on the class-specific TUPA Solicitud-Declaracion Jurada (TUPA 252 for Class IV), which admits ONLY an applicant categorised as a Laboratorio or Drogueria, holding a Peruvian RUC, with a named Director Tecnico and Representante Legal. A foreign manufacturer therefore MUST appoint a Representante Local Autorizado who becomes Titular del Registro Sanitario and holds legal responsibility, or incorporate and license its own Peruvian drogueria. Published evaluation window is 45 calendar days for the higher classes; validity 5 years, renewable. Dossier expects GMP/ISO 13485 evidence, technical file, performance data, Spanish labelling and a legalised Certificado de Libre Comercializacion from the country of origin, ideally from a PAVS high-surveillance country. Sequencing is important: DIGEMID registration is a prerequisite for bidding into an EsSalud tender, so it must be started well before the petitorio/IETSI work matures. Separately, the performing laboratory needs MINSA accreditation by Resolucion Ministerial on a 3-year renewal cycle.",
  "submissionWindow": "Rolling; applications filed online via the DIGEMID platform or in person at any time.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "PEN",
  "precedent": "YES, routine. Molecular IVD kits (TB DNA/resistance, HPV DNA, respiratory panels, SARS-CoV-2 PCR, NGS cancer panels) are registered and marketed in Peru, so there is no novel regulatory question about the device category itself."
 },
 {
  "id": "ury-pias-cat-logo-de-prestaciones-technology-incorporati",
  "iso3": "URY",
  "assayClass": "All assays",
  "routeName": "PIAS Catálogo de Prestaciones — technology incorporation (the only true national benefit-catalogue route for a laboratory test)",
  "routeType": "national_catalogue",
  "decisionBody": "Ministerio de Salud Pública (MSP), Dirección General de la Salud. Evidence is routed to advisory commissions under Ordenanza 152/020: the Comisión Técnica Asesora del MSP, the Comisión Honoraria Administradora del FNR, and the Comisión del Formulario Terapéutico de Medicamentos (the last for drugs). Final act is a Ministerial ordinance/decree amending the Catálogo.",
  "howItWorks": "The PIAS (Plan Integral de Atención a la Salud), created by Decreto 465/008, is the catalogue of benefits every provider in the Sistema Nacional Integrado de Salud (SNIS) must deliver to its members — ASSE (public) and the mutualistas/IAMCs (private non-profit) alike. Anexo II of the decree is the Catálogo de Prestaciones; Ordenanza 289/018 consolidated it into a single document, and it is also published as an online 'Catálogo del PIAS en formato digital'. If a test is in the Catálogo, the integral provider is legally obliged to supply it and pays for it out of its FONASA capitation (cuota salud) — there is NO separate per-test national tariff paid on top. If a test is NOT in the Catálogo and not inside an FNR module, no entity is obliged to pay for it at all. Getting in is via the trámite 'Solicitudes de incorporación al Plan Integral de Atención a la Salud (PIAS)', governed by Ordenanza 740/019 ('procedimiento para la solicitud de ingreso de tecnologías') as modified by Ordenanza 152/020. Submission is a signed letter on letterhead plus form FO-13220-009 (Solicitud de Evaluación de Incorporación), supporting evidence, the specific indication requested, and form FO-11012-001 for electronic notifications, filed at the Departamento de Administración Documental, 18 de Julio 1892, Montevideo. The trámite is free of charge. NOTE: at the time of checking, the MSP page states the request form is temporarily suspended pending updates — verify status before planning a submission.",
  "submissionWindow": "Annual. Requests are received from January until 30 June each year; they are evaluated after the window closes and the catalogue update is communicated to interested parties annually. Realistically 12–24 months from submission to an ordinance, and there is no published statutory decision deadline.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "UYU",
  "precedent": "Not directly verifiable at line-item level — the Anexo II catalogue file could not be retrieved (the visualizador-pias.msp.gub.uy viewer was unreachable and the Ordenanza 289/018 PDF contains only the resolution, not the annex). However, indirect precedent is strong and documented: multiple FNR coverage normativas make molecular/genetic tests a mandatory authorisation gate and then explicitly push the cost of non-FNR-listed paraclinical studies onto the Prestador Integral 'cuando se encuentren comprendidos dentro de la Canasta de Prestación Obligatoria (PIAS)'. Tests treated this way include SMN1 MLPA/sequencing for spinal muscular atrophy (n_trat_ame), CFTR mutation analysis for cystic fibrosis (n_trat_fibrosis_quistica, where the genetic study is stated to be a requirement for authorising elexacaftor/tezacaftor/ivacaftor), GLA gene molecular study for Fabry disease (n_trat_fabry), HCV PCR/viral load/genotype (n_trat_hepatitisc), and BRAF V600 mutation testing 'con método validado' for melanoma (n_trat_melanoma). So molecular testing is de facto funded in Uruguay through the provider/PIAS channel — but as a clinical obligation flowing down from an FNR drug normativa, not as a test that anyone lobbied onto the catalogue in its own right."
 },
 {
  "id": "ury-fnr-normativa-de-cobertura-adding-an-item-to-a-trans",
  "iso3": "URY",
  "assayClass": "All assays",
  "routeName": "FNR normativa de cobertura — adding an item to a transplant módulo under the convenio de aranceles",
  "routeType": "innovation_list",
  "decisionBody": "Comisión Honoraria Administradora del Fondo Nacional de Recursos (the FNR's governing body, which approves normativas by Acta), with the MSP. Tariffs are set by a negotiated 'convenio de aranceles' between the FNR and the IMAEs.",
  "howItWorks": "The FNR (Ley 16.343, Decreto reglamentario 358/993) is the national reinsurance fund and pays IMAEs per authorised act. Its coverage is organised as ~28 técnicas normativas, 2 dispositivo normativas and ~45 medicamento normativas — and critically, there is NOT ONE laboratory-test normativa among them. For renal transplant (normativa n_trenal_adultos, October 2023) the FNR finances: the recipient pre-transplant module, the cadaveric transplant, the living-donor transplant, and post-transplant cover comprising the ambulatory follow-up modules 'que estén establecidos por el convenio de aranceles vigente' plus IMAE admissions for transplant- or immunosuppression-related complications. The pre-transplant module has a taxative itemised annex — and that annex contains NO HLA typing, NO anti-HLA antibody testing, NO crossmatch and NO donor-specific antibody assay. Its only molecular entry is HCV-PCR. The normativa then states in terms that any other paraclinical study the FNR requires but which is not on the taxative list is 'de cargo del Prestador Integral' where it falls within PIAS. IMAEs may only invoice procedures the FNR has authorised in advance through the Sistema María. So the FNR route for a new molecular test means persuading the Comisión Honoraria to rewrite a normativa's financed-item annex and then getting a price into the convenio de aranceles — two separate acts.",
  "submissionWindow": "No published open call or annual window for adding items to a técnica normativa. Normativas are revised at the FNR's own initiative (dates on the current documents range from 2012 to 2025), so entry depends on catching a revision cycle or being sponsored by the IMAE/INDT clinical community.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "UYU",
  "precedent": "None found. No FNR normativa finances a molecular or genomic laboratory test as a line item. The pattern across FNR normativas is the opposite: molecular tests (SMN1, CFTR, GLA, BRAF V600, HCV PCR/genotype) are made mandatory documentation the requesting clinician must supply, with the cost falling on the Prestador Integral. For Fabry the FNR even reserves the right to re-confirm the result at a reference centre rather than pay for the original test."
 },
 {
  "id": "ury-prestador-integral-capitation-asse-and-the-mutualist",
  "iso3": "URY",
  "assayClass": "All assays",
  "routeName": "Prestador Integral capitation — ASSE and the mutualistas/IAMCs paying out of the FONASA cuota salud, and INDT's state budget for histocompatibility",
  "routeType": "block_contract",
  "decisionBody": "Each Prestador Integral individually (ASSE for the public sector; each IAMC/mutualista board for the private sector) decides its own laboratory purchasing. For transplant immunogenetics specifically the effective decision-maker is the Instituto Nacional de Donación y Trasplante (INDT), which operates as the single national histocompatibility laboratory and is funded from the state budget rather than by a per-test fee.",
  "howItWorks": "This is where laboratory tests actually get paid for in Uruguay. Providers receive a risk-adjusted capitation (cuota salud) from FONASA via the Seguro Nacional de Salud, and out of it must deliver everything in the PIAS Catálogo. A test that is inside PIAS is therefore a cost the provider absorbs, not a revenue line it earns — which inverts the usual vendor pitch: you are selling a cost to the entity that has to swallow it, so the case must be net-cost-saving (avoided biopsies, avoided admissions, avoided graft loss), not clinically interesting. The FNR renal normativa makes the hand-off explicit, assigning non-listed studies to the Prestador Integral. For a transplant molecular test the practical commercial funnel is even narrower: INDT is the sole national histocompatibility laboratory and holds the waiting list for every centre including the private INU programme, so the buying decision is one laboratory's budget line, not a reimbursement code.",
  "submissionWindow": "None. Continuous — this is a commercial sale into an annual institutional budget cycle, not a regulatory submission.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "UYU",
  "precedent": "Yes, in substance. Molecular testing required by FNR normativas (CFTR, SMN1, GLA, HCV genotype, BRAF) is routinely performed and paid for in Uruguay through this channel. What is NOT established is any precedent for a high-cost, high-frequency surveillance molecular test — the tests funded this way are one-off diagnostic gates, not repeated monitoring."
 },
 {
  "id": "ury-public-procurement-asse-msp-indt-reagent-tenders-via",
  "iso3": "URY",
  "assayClass": "All assays",
  "routeName": "Public procurement — ASSE / MSP / INDT reagent tenders via the Compras Estatales portal",
  "routeType": "tender",
  "decisionBody": "The purchasing entity (ASSE, MSP, INDT, Hospital de Clínicas), operating under the Uruguayan public procurement regime (TOCAF) through the Agencia Reguladora de Compras Estatales (ARCE/ACCE) portal www.comprasestatales.gub.uy. Centralised purchasing of health supplies for state agencies runs through the Unidad Centralizada de Adquisiciones (UCA) under the Ministerio de Economía y Finanzas.",
  "howItWorks": "Once a test is inside PIAS or an FNR module, the actual consumable is bought by public tender (licitación pública or compra directa depending on value thresholds under the TOCAF). This is the mechanism, not the coverage decision — winning a tender does not create reimbursement, and a test with no coverage decision behind it will not appear as a tender line. For a market of roughly 157 transplants a year concentrated in one laboratory in Montevideo, tender volumes will be small enough to fall below the public-tender thresholds and be done as direct purchase, which is faster but gives the incumbent supplier an advantage. Foreign bidders must be registered in RUPE (Registro Único de Proveedores del Estado) and, in practice, bid through a locally established distributor because the product must already hold an MSP registro sanitario held by an empresa habilitada.",
  "submissionWindow": "Rolling — tenders are published on the Compras Estatales portal as the purchasing entity issues them.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "UYU",
  "precedent": "Not verified in this pass. Specific tender records for molecular diagnostic reagents at ASSE/INDT were not retrieved (web search budget for the session was exhausted before this could be checked). Treat the mechanism as certain and any specific molecular-reagent tender history as unknown."
 },
 {
  "id": "ury-private-pay-out-of-pocket-at-private-laboratories",
  "iso3": "URY",
  "assayClass": "All assays",
  "routeName": "Private pay / out-of-pocket at private laboratories",
  "routeType": "private_pay",
  "decisionBody": "None — commercial. The only gate is the MSP registro sanitario for the reagent (Decreto 3/008) and MSP habilitación of the laboratory performing it.",
  "howItWorks": "Tests outside PIAS can be sold directly to patients or to private clinics. Uruguay has a real private molecular laboratory sector (Institut Pasteur de Montevideo, and private genomics/biotech laboratories in Montevideo) capable of running specialised assays, and mutualista members already pay 'tasas moderadoras' (co-payment tickets) for some diagnostic orders, so out-of-pocket payment for tests is culturally normal. This is the fastest route to first revenue and the natural way to generate Uruguayan clinical data to support a later PIAS submission. The ceiling is small: Uruguay's population is ~3.4 million with roughly 157 transplants a year, and out-of-pocket capacity for a high-cost recurring surveillance test is limited.",
  "submissionWindow": null,
  "difficulty": "low",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "UYU",
  "precedent": "Yes in general terms — private laboratories in Montevideo sell molecular and genetic testing directly. No transplant-specific molecular test precedent was verified."
 },
 {
  "id": "cri-ccss-institutional-public-tender-sicop-ley-general-d",
  "iso3": "CRI",
  "assayClass": "All assays",
  "routeName": "CCSS institutional public tender (SICOP, Ley General de Contratación Pública 9986)",
  "routeType": "tender",
  "decisionBody": "Caja Costarricense de Seguro Social (CCSS) — Dirección/Área de Adquisiciones de Bienes y Servicios at national level, or the individual hospital's procurement unit for lower-value purchases; awards above threshold require refrendo (endorsement) by the Contraloría General de la República",
  "howItWorks": "There is no national fee schedule and no per-test tariff for laboratory tests in Costa Rica. CCSS is simultaneously the insurer, the hospital owner and the laboratory operator, so a new molecular test is not 'reimbursed' — it is BOUGHT, as reagents plus instrument (often as a reagent-rental or equipment-in-loan arrangement), out of the CCSS institutional budget through a public tender. All public procurement runs through the SICOP electronic platform under Ley General de Contratación Pública No. 9986 (in force Dec 2022) and its reglamento. Lab reagents are typically contracted as 'entrega según demanda' (delivery-on-demand) framework contracts, where CCSS commits to no fixed quantity and draws down against need over the contract term — the reglamento (art. 195) expressly provides for this. Sequence in practice: (1) the clinical service and laboratory head write a technical justification and specification; (2) the item must exist as a coded line in the CCSS institutional catalogue of goods (see separate pathway); (3) the tender is published on SICOP with technical specs that a foreign supplier must be able to meet through a local bidder; (4) bids are evaluated on technical compliance then price, with price weighting heavy; (5) objections/appeals to the specification or the award go to the Contraloría General de la República, which routinely adds months; (6) contract and refrendo. Only a legally established Costa Rican entity can bid, and the reagents must already hold Ministry of Health EMB registration (or be exempt) at bid time — you cannot register in parallel with the tender. Because specifications drive who can win, the real commercial work is pre-tender technical engagement with the laboratory and the Gerencia Médica so that the specification reflects the assay's architecture rather than a competitor's.",
  "submissionWindow": "No fixed annual window. Tenders appear on SICOP when the institution's annual procurement plan (Plan Anual de Compras, published early in the fiscal year) schedules them. Realistic elapsed time from first clinical champion contact to first paid sample is 18–36 months: catalogue coding and budget line first, then a tender cycle typically 6–12 months from publication to award, plus Contraloría refrendo and any appeal.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CRC",
  "precedent": "Yes, strong. CCSS has funded and rolled out molecular diagnostics nationally through this mechanism: high-risk HPV DNA molecular testing replaced cytology as primary cervical screening for women aged 30–64, run centrally at the Laboratorio Nacional de Citologías after regional pilots (Pacífico Central and Chorotega). CCSS has also brought next-generation sequencing in-house at Hospital Rafael Ángel Calderón Guardia for genetic mutation detection in haematological malignancies, reported as the first use of NGS in the country. So both PCR-based and NGS-based tests have been paid for out of CCSS budget via institutional purchasing."
 },
 {
  "id": "cri-codification-in-the-ccss-institutional-catalogue-of-",
  "iso3": "CRI",
  "assayClass": "All assays",
  "routeName": "Codification in the CCSS institutional catalogue of goods and services (prerequisite gate)",
  "routeType": "national_catalogue",
  "decisionBody": "CCSS — Dirección de Aprovisionamiento / Área de Gestión de Bienes y Servicios, acting on a technical request from the requesting laboratory service; drug equivalents go through the Comité Central de Farmacoterapia and the Lista Oficial de Medicamentos, but diagnostics use the goods catalogue, not the LOM",
  "howItWorks": "Before CCSS can tender for a product it must exist as a coded item in the institutional catalogue with an agreed technical description. For a genuinely novel test category (e.g. donor-derived cfDNA, molecular biopsy transcript panels, high-resolution HLA by sequencing) no code exists, so the first task is not selling — it is getting a new code created with a description that permits your technology rather than one written around an incumbent. This is an unglamorous administrative step that foreign entrants routinely miss and it is the single most common reason a well-received clinical pitch produces no tender for two years. The requesting unit (in transplant, realistically the centralised Seroteca or the transplant service at a national hospital) drives the request; a distributor with CCSS experience is effectively mandatory to navigate it.",
  "submissionWindow": "Rolling; driven by the requesting clinical unit rather than a calendar. Typically several months once a clinical service formally requests it.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CRC",
  "precedent": "Implicit in every CCSS diagnostic purchase, including the HPV molecular screening rollout and the Calderón Guardia NGS service; I did not find a public, searchable catalogue document confirming the exact committee names, so treat the unit naming as indicative."
 },
 {
  "id": "cri-adoption-by-the-centralised-national-reference-labor",
  "iso3": "CRI",
  "assayClass": "All assays",
  "routeName": "Adoption by the centralised national reference laboratory (Seroteca Nacional / national lab model)",
  "routeType": "block_contract",
  "decisionBody": "CCSS Gerencia Médica together with the national Seroteca (centralised histocompatibility/serum bank) and the transplant services; Ministry of Health SETDT sets the transplant-system rules but does not buy",
  "howItWorks": "This is the decisive structural fact for a transplant test in Costa Rica. CCSS has centralised donor–recipient compatibility testing for all five authorised transplant centres into a single national Seroteca, which stores donor and recipient sera under controlled conditions and runs the immunological compatibility testing that hospitals previously did separately, with recent technology upgrades aimed at broader immunological testing and shorter turnaround to reduce hyperacute rejection risk. The same centralised-reference-lab pattern was used for HPV molecular screening at the Laboratorio Nacional de Citologías. So for a transplant molecular assay there is ONE laboratory to win, not five hospitals — a single instrument placement plus a reagent-supply contract covers the entire national programme. That makes the sales cycle long but the win total and defensible: whoever's platform sits in the Seroteca owns the country. Commercially the right shape is a reagent-rental / managed-service contract (instrument, consumables, service, training bundled into a per-test or per-period price) tendered as an on-demand supply contract, because CCSS capital budgets are tighter than operating budgets. Note the Spanish-derived system design: the programme was rebuilt from 2016 with AECID funding and technical cooperation from Spain's ONT, so protocols, terminology and reference practice mirror Spanish transplant practice — evidence packages and validation dossiers framed against Spanish/European practice will land better than US-framed ones.",
  "submissionWindow": "No window; driven by Seroteca capacity planning and CCSS capital/operating cycles. Expect 2–3 years from clinical engagement to a national contract for a new test category.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CRC",
  "precedent": "Yes for the mechanism (centralised national lab funded by CCSS budget, technology upgraded institutionally) but NOT yet for any transplant molecular rejection-surveillance test specifically. No dd-cfDNA, molecular biopsy or transcript-based rejection assay is known to be funded in Costa Rica."
 },
 {
  "id": "cri-health-technology-assessment-ets-exists-for-medicine",
  "iso3": "CRI",
  "assayClass": "All assays",
  "routeName": "Health technology assessment (ETS) — exists for medicines, effectively absent for diagnostics",
  "routeType": "hta_appraisal",
  "decisionBody": "CCSS Dirección de Farmacoepidemiología and Comité Central de Farmacoterapia (medicines, feeding the Lista Oficial de Medicamentos); CCSS participates in PAHO's RedETSA and imports assessments from partner agencies",
  "howItWorks": "Honest finding: Costa Rica has a functioning HTA apparatus, but it is built around medicines. The published CCSS ETS output is a catalogue of full assessments of medicines, governed by the Dirección de Farmacoepidemiología's manual, and its product is inclusion in the LOM. There is no equivalent standing appraisal committee, evidence template or public decision register for in-vitro diagnostics. For a lab test, adoption is decided by clinical/technical justification from the service, sign-off by hospital and Gerencia Médica management, and budget availability — not by a formal cost-effectiveness appraisal with a published decision. This cuts both ways: there is no NICE-style hurdle to clear and no formal evidence threshold to satisfy, but there is also no defined dossier to submit and no appealable 'no'. Practically, you should still build a Spanish-language economic case (cost per avoided biopsy, cost per avoided graft loss, CCSS-perspective budget impact over 3–5 years) because that is what the Gerencia Médica business case will need, even though no committee formally demands it. CCSS's RedETSA membership means a Spanish-language assessment from another Latin American agency, or a Spanish ONT-aligned position, carries real persuasive weight.",
  "submissionWindow": "None defined for diagnostics.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": null,
  "precedent": "No published CCSS ETS appraisal of a molecular diagnostic test was found. The ETS catalogue located is medicines-only."
 },
 {
  "id": "cri-recurso-de-amparo-before-the-sala-constitucional-ind",
  "iso3": "CRI",
  "assayClass": "All assays",
  "routeName": "Recurso de amparo before the Sala Constitucional (individual patient judicial route)",
  "routeType": "none",
  "decisionBody": "Sala Constitucional de la Corte Suprema de Justicia (Sala IV), ordering CCSS to provide and pay",
  "howItWorks": "Not a reimbursement mechanism, but a real and frequently used funding route in Costa Rica that must be understood. A patient denied a service by CCSS — including a test or treatment not on any institutional list — can file a recurso de amparo, and the Sala Constitucional has repeatedly held that refusing a medically necessary service can violate the constitutional right to health, ordering CCSS to provide it within a fixed deadline, with criminal penalties (three months to two years' imprisonment, or fines) for officials who fail to comply. In practice CCSS satisfies such orders by outsourcing to a private laboratory or funding a send-out. For a diagnostics company this produces one-off, unpredictable, single-patient revenue and can seed clinical familiarity, but it is not a scalable commercial strategy and pursuing it deliberately would damage the institutional relationship you need for the tender route. Treat it as an explanation for occasional out-of-list CCSS payments, not as a market-entry plan.",
  "submissionWindow": "Any time; amparo is a fast-track constitutional procedure, typically resolved in weeks to a few months.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CRC",
  "precedent": "Yes for the mechanism generally (numerous rulings compelling CCSS to fund non-listed treatments and tests, e.g. Sentencia 2025021259 of 9 July 2025 restating the compliance penalties). No specific transplant molecular test precedent identified."
 },
 {
  "id": "cri-private-pay-private-hospitals-and-private-insurance-",
  "iso3": "CRI",
  "assayClass": "All assays",
  "routeName": "Private pay, private hospitals and private insurance (including send-out to foreign reference labs)",
  "routeType": "private_pay",
  "decisionBody": "Private hospitals and laboratories individually (Hospital Clínica Bíblica, Hospital CIMA, Hospital Metropolitano; private labs including Laboratorios Echandi and Laboratorio San José); private insurers set their own benefits, supervised by SUGESE (Superintendencia General de Seguros) — the state insurer INS is the largest",
  "howItWorks": "Costa Rica has no Brazilian-style ROL de Procedimentos and no ANS-equivalent: SUGESE regulates insurers' solvency, registration and policy wording, not a mandatory list of covered procedures. Coverage of a new molecular test is therefore a policy-by-policy commercial decision by each insurer, and out-of-pocket self-pay is common. This channel is fast — no tender, no catalogue code, and if delivered as a send-out (sample shipped abroad, report returned) no Ministry of Health IVD registration is triggered at all — so it is the practical way to generate first Costa Rican data and KOL familiarity while the CCSS route grinds forward. The severe limitation for transplant specifically: essentially all solid-organ transplantation is done by CCSS in its five Ministry-authorised public hospitals, so the private-pay addressable population for graft surveillance is very small, mostly self-paying patients and cross-border/medical-tourism cases. A private NGS capability now exists locally — Laboratorios Echandi established the first private NGS unit in the country for cancer and other genetic markers — which is a plausible local partner for in-country delivery if you later want to avoid shipping samples.",
  "submissionWindow": "None; commercial negotiation, weeks to months.",
  "difficulty": "low",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "USD",
  "precedent": "Yes for molecular/genomic testing in the private sector (Laboratorios Echandi NGS unit; routine private send-outs of specialised genetic tests to US reference laboratories). No transplant rejection-surveillance test precedent identified."
 },
 {
  "id": "cri-ministry-of-health-sanitary-registration-of-equipo-y",
  "iso3": "CRI",
  "assayClass": "All assays",
  "routeName": "Ministry of Health sanitary registration of Equipo y Material Biomédico (mandatory gate before any CCSS sale)",
  "routeType": "regulatory_gate",
  "decisionBody": "Ministerio de Salud — Dirección de Regulación de Productos de Interés Sanitario, Unidad de Registros, via the Regístrelo electronic platform",
  "howItWorks": "Not a payment route, but the gate that controls all of them. IVD reagents and analysers are registered as 'Equipo y Material Biomédico' under Decreto 34482-S as amended by Decreto 43902 (30 Nov 2022) adopting RTCR 505:2022. Four risk classes; Class 1 is exempt from registration but its importer must still be registered and hold a Permiso de Funcionamiento; Classes 2–4 require full registration. Registration is entirely electronic on Regístrelo and is valid 5 years, renewable by sworn declaration. Dossier: application, apostilled/legalised Certificate of Free Sale from the country of origin, technical and medical specifications and labelling/IFU in Spanish, GMP or quality-system certificate, fee scaled by class. The titular del registro must be a Costa Rican manufacturer or authorised importer with a current Permiso de Funcionamiento and a designated responsible professional (regente) — a foreign manufacturer cannot hold the registration itself, so a local legal representative or distributor is compulsory in fact as well as in form. Registration must be complete before bidding into a CCSS tender. Negotiate registration ownership and transfer rights in the distribution contract, because the registration sits with the local entity and recapturing it from a departing distributor is slow.",
  "submissionWindow": "Rolling. Public sources confirm the 5-year validity and electronic filing but I could not verify a statutory review clock in working days; budget several months for Class 2–4 including CFS legalisation, apostille and Spanish translation, plus resubmission cycles for prevenciones (requests for further information).",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "CRC",
  "precedent": "Routine — all imported IVD reagents used by CCSS, including the HPV molecular screening reagents and NGS consumables, pass through this route."
 },
 {
  "id": "ecu-tarifario-de-prestaciones-para-el-sistema-nacional-d",
  "iso3": "ECU",
  "assayClass": "All assays",
  "routeName": "Tarifario de Prestaciones para el Sistema Nacional de Salud (national fee schedule)",
  "routeType": "fee_schedule",
  "decisionBody": "Ministerio de Salud Publica (Autoridad Sanitaria Nacional) issues the Acuerdo Ministerial. Technical decision is made by the Subcomision de Tarifario, escalated through the Comite de Gestion de la Red Publica Integral de Salud (CGR). MSP, IESS, ISSFA and ISSPOL all sit on the governing structure.",
  "howItWorks": "This is the single national price list that governs how the public subsystems pay each other and pay private (red complementaria) providers. It binds MSP, IESS, ISSFA, ISSPOL, SOAT/FONSAT and private insurers when they settle against public providers. Pricing is not a flat fee: each procedure carries Unidades de Valor Relativo (UVR) differentiated by facility complexity level, multiplied by a Factor de Conversion Monetario (FCM) expressed in US dollars. The product is explicitly described in the tarifario as the 'techo maximo' (ceiling), not a floor, so payers can settle below it. Laboratory is one of the servicios de apoyo diagnostico components with its own conversion factor, and UVRs are published in three tiers: L-1 (first level), L-2A (second level) and L-2B (third level / high complexity). Crucially, 'Genetica Molecular' is named in the tarifario as a third-level, high-complexity laboratory discipline in its own right, alongside anatomia patologica, inmunologia and genetica. Molecular tests already carry codes and UVRs in the Genetica Molecular block, including CROSS MATCH, CROSS MATCH (servicio 24h), P.R.A. (88 antigenos), P.R.A. 24 horas, HIV carga viral, carga viral para hepatitis C, citomegalovirus por ADN/cuantificacion, HPV genotipificacion, deteccion de HER2/neu por PCR, mutacion Factor V Leiden, inestabilidad de microsatelites and a panel LMA por PCR. So the category is established and the door is not closed.\n\nHOW YOU ADD A NEW TEST. The tarifario sets out an explicit inclusion mechanism (Seccion A, numeral 10, 'Procedimientos No Incluidos'). You cannot apply as a manufacturer. The request must be channelled by an INSTITUTIONAL representative (an MSP or IESS hospital, or the relevant subsystem) to the national Comite de Gestion de la Red, which formally refers it to the Subcomision de Tarifario. The Subcomision reviews it against the current CPT reference and must issue a technical report with conclusions and recommendations to the CGR within a maximum of 20 dias termino (working days). The CGR then has a maximum of 72 hours to ask the Autoridad Sanitaria Nacional for the reform. MSP then issues the Acuerdo Ministerial. The statutory clock is therefore short; the real delay is upstream, getting a hospital or a subsystem to sponsor the request and getting it onto the CGR agenda, and downstream, waiting for MSP to actually sign.\n\nINTERIM FALLBACK. Until a code exists, the tarifario provides that where a facility performs a clinical procedure not defined in the tarifario and therefore with no UVR assigned, it may be paid at a tariff equivalent to a procedure of homologable complexity, provided the requester files the quantification sheet at Anexo 4. That is the practical bridge: get an existing high-complexity Genetica Molecular L-2B code accepted as the comparator while the formal inclusion runs. It is discretionary and payer-dependent, so it is a negotiating position, not an entitlement.\n\nNO HTA GATE. Ecuador has no functioning independent health technology assessment agency that appraises diagnostics in the NICE/IQWiG/HAS sense. The Subcomision de Tarifario performs the de facto costing and technical assessment. That cuts both ways: there is no formal evidence dossier or cost-effectiveness threshold to clear, but there is also no transparent, appealable process and no published methods manual to argue against a refusal.\n\nVERSIONING. The base document is the 2014 version; it was reissued and expanded by Acuerdo Ministerial 0286-2018 (Registro Oficial Edicion Especial No. 751, Tomo II) and reformed by later acuerdos including 00088-2019 and 00120-2020. The tarifario states that updating, revision, inclusion, modification and exclusion of procedures and of the FCM is to be done ANNUALLY. Verify the exact instrument in force before quoting any number, because the UVR values and the FCM have moved between versions.",
  "submissionWindow": "Rolling. A request can be raised at any time through the institutional representative to the Comite de Gestion de la Red; once referred, the Subcomision de Tarifario has 20 dias termino to report and the CGR 72 hours to escalate. Separately the tarifario itself is meant to be revised annually, so aligning with the annual revision cycle is the higher-probability path for a non-urgent addition.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "USD",
  "precedent": "YES, and it is a directly relevant molecular precedent. RT-PCR for SARS-CoV-2 (hisopado nasofaringeo) was given a national tariff of USD 45.08 by MSP on 20 April 2021, set by the Subcomision del Tarifario de Prestaciones para el Sistema Nacional de Salud and formalised by Acuerdo Ministerial (reported as 00003-2021), with ACESS designated to police compliance and laboratories required to display the maximum price. That is proof the exact mechanism described above can price a brand-new molecular assay nationally. Caveats: it was a pandemic emergency, the political will was extraordinary, and it functioned as much as a price-capping measure on the private sector as a reimbursement decision. Beyond COVID, the standing precedent is the existing Genetica Molecular L-2B block, which already funds viral load quantification (HIV, HCV, CMV), HPV genotyping, HER2 by PCR, thrombophilia mutations, microsatellite instability, and the transplant immunogenetics tests (crossmatch, PRA 88 antigenos). No precedent found for a next-generation-sequencing or multi-gene genomic signature being given its own national code. Treat NGS-based transplant surveillance as breaking new ground."
 },
 {
  "id": "ecu-bundled-transplant-case-rate-paquete-de-prestaciones",
  "iso3": "ECU",
  "assayClass": "All assays",
  "routeName": "Bundled transplant case rate (paquete de prestaciones integrales) - the trap",
  "routeType": "drg_addon",
  "decisionBody": "Same as the fee schedule: MSP via the Subcomision de Tarifario and the Comite de Gestion de la Red. Applied in practice by the paying subsystem (IESS or MSP) against the transplanting hospital.",
  "howItWorks": "THIS IS THE MOST IMPORTANT SINGLE FINDING FOR A TRANSPLANT DIAGNOSTIC IN ECUADOR. Kidney transplantation is not paid per item. It is paid as an integrated bundle. Code 70100145, 'Trasplante renal donante cadaverico, incluye actualizacion prequirugica, cirugia del donante y receptor', carries a published all-in value of USD 17,050.00 in the 2014 tarifario, with a parallel living-donor package. The bundle's inclusion list explicitly names, at item 1.4, 'Genetica Molecular (Histocompatibilidad: Tipificacion HLA A, B y DR, del donante)' and, at item 3, 'Genetica molecular (Cross-Match contra el donante)'. Diagnostic laboratory and imaging during the admission are also inside the bundle, as is maintenance immunosuppression to discharge, ciclosporin/rapamycin level monitoring, and post-operative consultations for up to fifteen days after surgery.\n\nWHAT THAT MEANS COMMERCIALLY. Any molecular test performed peri-transplant or in the first fifteen post-operative days is, by default, already paid for inside the USD 17,050 and is not separately billable. Selling into that window means asking the hospital to absorb your cost out of a fixed case rate. That is a cost-displacement sale, not a reimbursement sale, and it only works if you can show you remove more cost from the bundle than you add. Conversely, a POST-TRANSPLANT SURVEILLANCE test used from day sixteen onward falls outside the bundle and can be pursued as a standalone Genetica Molecular L-2B code. For a donor-derived cfDNA or molecular rejection-surveillance product, that timing distinction is the whole commercial argument and should shape the intended-use wording from the start.\n\nTWO USEFUL CARVE-OUTS ALREADY IN THE TEXT. First, the tarifario expressly provides that when a transplant operation is called, at least two candidates from the institutional list are worked up, and where the recipient turns out not to be suitable, 'los costos generados por la realizacion de estos estudios seran facturados en forma individual'. So histocompatibility testing on non-transplanted candidates IS separately invoiceable. Second, the bundle covers complications only up to the value of the treatment at the provider's risk; beyond that, prior authorisation from the financier is required and the excess is billed. Both are precedents for unbundling.\n\nADDING AN ADD-ON. There is no formal 'innovation add-on' instrument comparable to Germany's NUB or France's RIHN. Changing what sits inside or outside the bundle runs through the same Procedimientos No Incluidos route as any other tarifario amendment.",
  "submissionWindow": "Same as the fee schedule route: rolling request via institutional sponsor, with an annual revision cycle.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": 17050,
  "priceHigh": 17050,
  "currency": "USD",
  "precedent": "Yes for molecular testing being funded inside the bundle: HLA A, B and DR typing of the donor and donor-specific crossmatch are named line items within the deceased-donor kidney package, and PRA and crossmatch also exist as standalone Genetica Molecular codes. No precedent found for a new molecular test being added to a transplant bundle as an incremental, separately reimbursed add-on."
 },
 {
  "id": "ecu-sercop-public-procurement-subasta-inversa-catalogo-e",
  "iso3": "ECU",
  "assayClass": "All assays",
  "routeName": "SERCOP public procurement (subasta inversa, catalogo electronico, compra corporativa)",
  "routeType": "tender",
  "decisionBody": "SERCOP (Servicio Nacional de Contratacion Publica) runs the platform and the rules. The buying decision sits with the individual contracting entity: the IESS hospital (Carlos Andrade Marin, Teodoro Maldonado Carbo, Jose Carrasco Arteaga), the MSP hospital, or a central corporate purchasing process covering the whole Red Publica Integral de Salud (MSP, IESS, ISSFA, ISSPOL).",
  "howItWorks": "Even where a tarifario code exists, no reagent or instrument reaches a public laboratory except through SERCOP. This is the transactional route and in practice it is the one that determines revenue timing. Processes are published on compraspublicas.gob.ec, with a dedicated corporate health purchasing portal (compracorporativasalud.compraspublicas.gob.ec) and a medicines auction platform. The applicable modalities are subasta inversa electronica (reverse auction, the workhorse for reagents and consumables, and price-destructive by design), catalogo electronico (framework catalogue for standardised goods), infima cuantia (low-value direct purchase below a threshold set as a coefficient of the annual budget, useful for pilots and small volumes), and regimen especial. Corporate purchasing pools demand across the four subsystems, which is how the government has procured large medicine baskets.\n\nWHAT THIS MEANS FOR A NOVEL ASSAY. Reverse auction is a hostile format for a sole-source, patent-protected, differentiated test, because it awards on lowest price against a technical specification. The practical play is to work with the sponsoring hospital's laboratory on the pliegos (technical specification) so that the specification reflects the test's genuine performance requirements, and to route small-volume early business through infima cuantia or a specification narrow enough that it is functionally single-source. Alternatively, sell the SERVICE rather than the reagent: hospitals do contract external laboratory services, which converts the sale into a services contract rather than a goods auction.\n\nWORKING CAPITAL. IESS payment delay to suppliers and periodic public health budget squeezes are the known commercial risk. Being dollarised removes FX risk but does nothing for days sales outstanding. Assume long collection cycles and price them in.",
  "submissionWindow": "Continuous but process-specific. Each procurement has its own published calendar (publication, questions, offers, negotiation/auction, award). There is no annual national window; you monitor the portal or you are told by the sponsoring hospital.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "USD",
  "precedent": "Yes in the general sense: molecular reagents including HIV and hepatitis C viral load and, during the pandemic, SARS-CoV-2 RT-PCR reagents have been procured for public laboratories through public procurement, and corporate reverse auctions have been used to buy medicine baskets across all four subsystems. I did not find, and am not asserting, a specific published award for a transplant-specific molecular test."
 },
 {
  "id": "ecu-msp-maximum-price-acuerdo-ministerial-national-price",
  "iso3": "ECU",
  "assayClass": "All assays",
  "routeName": "MSP maximum-price acuerdo ministerial (national price ceiling for a named test)",
  "routeType": "national_catalogue",
  "decisionBody": "Ministerio de Salud Publica, on the technical determination of the Subcomision del Tarifario. Enforcement by ACESS (Agencia de Aseguramiento de la Calidad de los Servicios de Salud y Medicina Prepagada).",
  "howItWorks": "A distinct instrument from the tarifario proper, and worth understanding because it is the fastest thing Ecuador has ever done with a molecular test. MSP can issue an Acuerdo Ministerial fixing a single national maximum price for a named test, binding on public AND private laboratories, with ACESS policing display and compliance. This is a price-control instrument, not a funding instrument: it tells everyone what they may charge, it does not create a budget. For a novel high-value assay it is a THREAT as much as an opportunity, because the same mechanism that established a national price for RT-PCR could cap a premium test below its viable price. It is included here because it is the only demonstrated example of the Ecuadorian state moving quickly on a new molecular diagnostic, and because any commercial model should be stress-tested against the possibility of a ceiling being imposed.",
  "submissionWindow": "Ad hoc. Used in response to a public health need; not a route an applicant can initiate.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": 45.08,
  "priceHigh": 45.08,
  "currency": "USD",
  "precedent": "YES. Acuerdo Ministerial (reported as 00003-2021), 20 April 2021, set the RT-PCR nasopharyngeal swab tariff at USD 45.08 nationwide, determined by the Subcomision del Tarifario and enforced by ACESS, which required laboratories to display the maximum price visibly. The price shown here is that historical COVID figure and must not be used as a proxy for what any other molecular test would be paid."
 },
 {
  "id": "ecu-private-pay-and-medicina-prepagada",
  "iso3": "ECU",
  "assayClass": "All assays",
  "routeName": "Private pay and medicina prepagada",
  "routeType": "private_pay",
  "decisionBody": "Each prepaid health company individually (Salud S.A., Ecuasanitas, BMI, Confiamed and similar), plus the patient paying cash. Sector regulator is the Superintendencia de Companias, Valores y Seguros, with ACESS on service quality, under the Ley Organica que Regula a las Companias que Financien Servicios de Atencion Integral de Salud Prepagada (Registro Oficial 863, 17 October 2016).",
  "howItWorks": "NOTE FOR CROSS-COUNTRY COMPARISON: Ecuador has NO equivalent of Brazil's ANS Rol de Procedimentos. There is no national list of procedures that private health financiers are legally compelled to cover. The 2016 law requires each plan to specify in its contract what is covered, its content, scope and limits, and requires effective access to what is contracted, and the Superintendencia approves mandatory contract clauses. But coverage of any given test is a contract-by-contract commercial matter, not a regulated entitlement. There is therefore no single list to get onto and no single body to persuade. Each insurer must be sold individually.\n\nWHY THIS IS A THIN CHANNEL FOR TRANSPLANT. Solid organ transplantation in Ecuador is overwhelmingly delivered by the public and social-security network, and transplant care carries a statutory gratuity for Ecuadorians under the donation and transplant law. The prepaid market is small, concentrated in Quito and Guayaquil, and transplant is commonly excluded or capped. Direct cash pay by patients exists but is very limited given the population's income distribution. Realistically this is a route for early access, key-opinion-leader familiarisation and a handful of self-pay cases, not a commercial base. Where the tarifario applies to a settlement between a private insurer and a public provider, the tarifario ceiling governs.",
  "submissionWindow": null,
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "USD",
  "precedent": "Private laboratories in Quito and Guayaquil do sell molecular tests (HPV genotyping, viral load, oncology PCR panels) on a self-pay and prepaid-reimbursed basis, and RT-PCR was sold privately under the USD 45.08 ceiling. No precedent identified for a prepaid insurer covering a transplant-specific molecular surveillance test."
 },
 {
  "id": "ecu-arcsa-registro-sanitario-for-the-ivd-regulatory-prec",
  "iso3": "ECU",
  "assayClass": "All assays",
  "routeName": "ARCSA Registro Sanitario for the IVD (regulatory precondition)",
  "routeType": "regulatory_gate",
  "decisionBody": "ARCSA (Agencia Nacional de Regulacion, Control y Vigilancia Sanitaria 'Dr Leopoldo Izquieta Perez'), under the Ministerio de Salud Publica.",
  "howItWorks": "Mandatory before import, distribution or commercialisation. Governed as of 28 April 2026 by Resolucion ARCSA-DE-2026-003-DASP, which replaces ARCSA-DE-026-2016-YMIH and expressly covers in vitro diagnostic devices and biochemical diagnostic reagents on a risk-classified basis. Two routes: general inscription, or a simplified recognition route for products approved by high-surveillance agencies that are IMDRF members, with a stated 30-business-day evaluation. Registration valid 5 years, renewable. Final Spanish labels due within one year of approval and before sale. A local, Ecuador-domiciled authorised representative holding an ARCSA operating permit is COMPULSORY and holds the registration. ARCSA must publish implementing instructivos within nine months of the resolution, i.e. by roughly late January 2027, so the operational detail is currently unsettled. See regulatory_note for the full treatment including which foreign approvals help.",
  "submissionWindow": "Rolling; no fixed windows.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": 905,
  "priceHigh": 905,
  "currency": "USD",
  "precedent": "Yes, extensively. Molecular IVDs including HIV and HCV viral load assays, HPV molecular tests and SARS-CoV-2 RT-PCR kits are registered and sold in Ecuador, so there is nothing novel about registering a nucleic-acid-based IVD here. No precedent identified for a transplant donor-derived cfDNA or NGS-based rejection assay."
 },
 {
  "id": "ecu-indot-accreditation-of-the-histocompatibility-immuno",
  "iso3": "ECU",
  "assayClass": "All assays",
  "routeName": "INDOT accreditation of the histocompatibility / immunogenetics laboratory (transplant-specific gate)",
  "routeType": "regulatory_gate",
  "decisionBody": "INDOT (Instituto Nacional de Donacion y Trasplante de Organos, Tejidos y Celulas), under the Ley Organica de Donacion y Trasplante de Organos, Tejidos y Celulas.",
  "howItWorks": "Separate from and additional to the ARCSA product registration. No laboratory may perform histocompatibility or immunogenetics testing for transplant in Ecuador without INDOT accreditation, and the law makes the national health authority jointly liable for damages arising from accrediting establishments or professionals that did not meet the requirements, which is why the process is inspection-based and conservative. Application is by public or private legal entities, via gob.ec online or in person at INDOT Quito, Guayaquil or Cuenca, using Form 001 LHI (application) and Form 002 LHI (requirements specification), against technical requirements document RG-353 v6 (April 2025) and Resolucion 39-INDOT-2023. Twenty-two mandatory items are required, including quality management certification, equipment inventory, external proficiency-testing certificates, staff training records and standard operating procedures. The laboratory director needs a minimum of 160 hours of continuing education and technical staff a minimum of 40 hours. Documentary review is followed by an on-site inspection visit, then electronic issue of the certificate. The applicant facility bears the accrediting commission's travel and per diem costs. ACCREDITATION IS VALID ONLY 2 YEARS and must be re-earned.\n\nCOMMERCIAL CONSEQUENCE. The buyer universe is not 'Ecuadorian laboratories', it is the small set of INDOT-accredited histocompatibility laboratories, which is at most a handful. Introducing a new molecular method into one of them touches the accredited SOP set and the proficiency-testing evidence, so a method change is not invisible to INDOT; expect the lab to want the new assay documented and covered by an EQA scheme before the next re-accreditation. Budget the two-year cycle into the adoption timeline.",
  "submissionWindow": "Rolling application; re-accreditation required every 2 years. Processing time is not published.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "USD",
  "precedent": "Yes. INDOT-accredited laboratories already run molecular HLA typing, crossmatch and PRA for the national programme, and those tests are funded through the tarifario and inside the transplant bundle. So a molecular method operating inside an accredited transplant laboratory and being paid for is established practice."
 },
 {
  "id": "pan-css-public-tender-licitacion-publica-panamacompra-fo",
  "iso3": "PAN",
  "assayClass": "All assays",
  "routeName": "CSS public tender (licitacion publica / PanamaCompra) for laboratory reagents and consumables",
  "routeType": "tender",
  "decisionBody": "Caja de Seguro Social (CSS) — Direccion Nacional de Servicios y Prestaciones en Salud plus CSS procurement, with the technical specification written by the Laboratorio Nacional de Trasplante / CSS clinical laboratory at Ciudad de la Salud. Notices published on PanamaCompra (panamacompra.gob.pa) as mandated by Ley 419 de 2024. Contract awards above threshold are reviewed by the Contraloria General de la Republica and can be scrutinised by ACODECO on competition grounds.",
  "howItWorks": "This is the realistic primary route and effectively the ONLY route to volume. CSS is an integrated payer-provider: it does not reimburse an external lab per test against a schedule, it buys reagents, kits, instruments and occasionally services through public tender and then performs the test in-house. To be paid, your assay must appear as a line item in a CSS tender — which means the CSS lab must first want it and write it into the technical specification (pliego de cargos). A foreign supplier does not create demand here; the CSS laboratory director does, and the whole exercise is therefore a clinical-adoption exercise disguised as a procurement one. Mechanics: CSS publishes a Plan Anual de Compras; tenders run as Licitacion Publica or Licitacion por Mejor Valor on PanamaCompra; bidders must be registered in the ProponenteS registry and must hold a Panamanian aviso de operacion, so a local distributor bids, not the manufacturer. Registro sanitario must already be in hand at bid time — this is the classic sequencing trap. Documented example of the mechanism in this exact product class: Licitacion Publica 08-2024 for clinical laboratory test products and blood bank traceability supplies, which ACODECO reviewed (report AC-001-24). Prices are in balboas at 1:1 USD parity. Payment cycles are slow and have already disrupted MINSA's private dialysis contracts, so price for working capital.",
  "submissionWindow": "No fixed annual window. Tenders are posted ad hoc on PanamaCompra with short response times (one observed reagent tender, ID 110242004, was published 11 March 2025 with a 17 March 2025 deadline — six days). The meaningful window is much earlier: influencing the CSS annual procurement plan and the pliego de cargos, which happens in the months before publication. Confidence on the planning cycle timing is low.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "PAB",
  "precedent": "YES, and it is directly on point but cuts against a supplier. The CSS Laboratorio Nacional de Trasplante at Ciudad de la Salud is the sole histocompatibility laboratory for the national programme and, per CSS press (Feb 2025), runs next-generation sequencing for donor/recipient HLA typing — described as the only such capability in Central America and the Caribbean. So molecular and genomic transplant testing IS publicly funded in Panama, via CSS capital purchase plus reagent tender. COVID-19 RT-PCR was also scaled nationally through ICGES/CSS/MINSA. The precedent proves the money exists; it also proves CSS's instinct is to insource, not to buy a send-out service."
 },
 {
  "id": "pan-css-institutional-laboratory-budget-insourcing-at-th",
  "iso3": "PAN",
  "assayClass": "All assays",
  "routeName": "CSS institutional laboratory budget — insourcing at the Laboratorio Nacional de Trasplante (Ciudad de la Salud)",
  "routeType": "block_contract",
  "decisionBody": "CSS Direccion Ejecutiva Nacional de Servicios y Prestaciones en Salud and the Ciudad de la Salud laboratory leadership, within the CSS budget approved by the Junta Directiva de la CSS and ultimately the Asamblea Nacional through the national budget",
  "howItWorks": "CSS funds its own laboratory as a cost centre: staff, instruments and reagents come out of institutional budget rather than any per-test tariff. There is no test-level payment event at all — the test is 'funded' by being on the lab's menu. For a new molecular transplant assay this means the commercial ask is a platform-and-reagent placement (instrument plus consumable stream, possibly reagent rental), not a reimbursement submission. The barrier here is unusually high for a specific reason: CSS has already bought NGS capability for the national transplant laboratory and positions it publicly as a point of national pride, so any external molecular transplant test is competing with a sunk in-house capability and an institutional preference to run things internally. The credible entry is therefore to sell INTO that laboratory — assay chemistry, panel design, software/interpretation on their existing sequencer — rather than to sell a competing send-out service around it.",
  "submissionWindow": "Aligned to the CSS budget cycle (Panama's fiscal year is the calendar year), so business-case work needs to land well before budget approval for the following year. I could not verify the exact internal submission dates — treat as unknown.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "PAB",
  "precedent": "YES — the NGS HLA typing platform at the Laboratorio Nacional de Trasplante is itself the precedent for a genomic capability being funded straight out of CSS institutional budget rather than through any tariff or coverage decision."
 },
 {
  "id": "pan-minsa-hospital-santo-tomas-institutional-budget-and-",
  "iso3": "PAN",
  "assayClass": "All assays",
  "routeName": "MINSA / Hospital Santo Tomas institutional budget and tender (uninsured population)",
  "routeType": "block_contract",
  "decisionBody": "Ministerio de Salud (MINSA) and individual hospital administrations, notably Hospital Santo Tomas; procurement again via PanamaCompra; MINSA-CSS cross-billing governed by the two institutions' cost-compensation agreement",
  "howItWorks": "MINSA covers the roughly one-third to one-quarter of the population not insured by CSS and runs Hospital Santo Tomas, the main MINSA-side transplant centre. Funding works the same way as CSS — hospital budget plus tender — but the budgets are smaller and payment discipline is visibly worse (MINSA's arrears to private dialysis providers are the cautionary example). There is a CSS-MINSA cost-compensation mechanism under which the two institutions invoice each other for services delivered to the other's population, and Hospital Santo Tomas publishes an institutional cost list for services. Important nuance: that cost list is an internal cost-recovery / charge schedule for patients and cross-institutional billing, NOT a reimbursement fee schedule that a new test can be added to and paid against. Do not model it as a tariff you can list on.",
  "submissionWindow": "Unknown; follows MINSA's annual budget and procurement planning on the calendar fiscal year",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "PAB",
  "precedent": "Not established for any molecular transplant test on the MINSA side. Molecular testing generally (COVID RT-PCR) was funded across MINSA/ICGES during the pandemic, but that was emergency financing and is weak precedent for routine adoption."
 },
 {
  "id": "pan-no-national-fee-schedule-no-hta-no-coverage-list-exi",
  "iso3": "PAN",
  "assayClass": "All assays",
  "routeName": "No national fee schedule / no HTA / no coverage list exists for laboratory tests",
  "routeType": "none",
  "decisionBody": "n/a — no Panamanian equivalent of Brazil's ANS ROL de Procedimentos, France's RIHN/NABM, Germany's EBM or a NICE-style HTA body was identified",
  "howItWorks": "This is the key negative finding and it should shape the whole market-entry model. Panama has no national tariff or nomenclature of laboratory tests that a new molecular assay can be added to in order to trigger payment; no health technology assessment agency that appraises diagnostics; no innovation/temporary-funding list (nothing analogous to RIHN, NUB or an ATU-style bridge); and no mandated private-insurance benefit catalogue. Payment happens either because CSS bought the reagents through tender, or because a patient or private insurer paid a private laboratory. Practical consequence: there is no 'submission' to make and no dossier to file with a payer — the entire access strategy is procurement plus clinical champion, and evidence requirements are set informally by the CSS laboratory rather than by any published methods guide. Note also that at 48 kidney and 6 liver transplants nationally in 2024, the surveillance-testing denominator is on the order of a few hundred tests a year even at aggressive protocol frequency, which is below the threshold where a formal coverage apparatus would ever be built.",
  "submissionWindow": null,
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": null,
  "precedent": null
 },
 {
  "id": "pan-private-pay-via-private-laboratory-send-out-to-inter",
  "iso3": "PAN",
  "assayClass": "All assays",
  "routeName": "Private pay via private laboratory send-out to international reference labs",
  "routeType": "private_pay",
  "decisionBody": "The ordering nephrologist/transplant physician and the paying patient; commercially, the private laboratory that owns the send-out relationship",
  "howItWorks": "This is the only route that can be opened quickly and without a Panamanian public-sector decision, and it is how specialised molecular testing reaches Panamanian patients today. Panamanian private laboratories openly market international referral: Laboratorio Clinico Fernandez, for example, advertises partnerships with Quest Diagnostics, Labcorp and Synlab to 'gestionar el envio de analisis especializados que no se realizan en Panama'. The patient (or their insurer) pays out of pocket; the local lab takes a margin on the send-out. For a new transplant molecular test the practical entry is to become an accessible send-out option for one or two Panama City private labs serving the private transplant follow-up population. Two important constraints: (1) the addressable population is tiny — essentially all transplant activity is inside CSS, so the private follow-up cohort is a small fraction of an already small national cohort; (2) the regulatory position of a pure send-out (specimen exported, kit never imported) is materially more favourable than importing a kit, but is unconfirmed and needs Panamanian legal advice. Prices are set commercially and I found no published figures — I am not going to invent one.",
  "submissionWindow": null,
  "difficulty": "low",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "USD",
  "precedent": "YES for the mechanism — specialised molecular tests unavailable in Panama are routinely sent to Quest, Labcorp and Synlab and paid privately. No public evidence of any transplant-specific molecular test (dd-cfDNA, MMDx-type biopsy transcriptomics) moving through this channel in Panama."
 },
 {
  "id": "pan-private-health-insurance-discretionary-no-mandated-b",
  "iso3": "PAN",
  "assayClass": "All assays",
  "routeName": "Private health insurance (discretionary, no mandated benefit list)",
  "routeType": "private_pay",
  "decisionBody": "Individual insurers (ASSA, Palig, Mapfre, Bupa Global and similar), supervised prudentially by the Superintendencia de Seguros y Reaseguros de Panama (SSRP). SSRP regulates solvency and policy conduct; I found no evidence it mandates a covered-procedure catalogue.",
  "howItWorks": "Unlike Brazil, where the ANS ROL de Procedimentos legally compels private insurers to cover listed procedures, Panama appears to have no mandatory benefit list — coverage is a contractual matter set plan by plan. That means there is no listing decision to win and no regulator to petition; each claim is adjudicated against policy wording, typically as an out-of-network or send-out benefit with prior authorisation. Some international/premium plans do explicitly market genetic testing benefits (Bupa's Global Health Plan lists 'pruebas geneticas de cancer'), which shows the category is not categorically excluded, but a transplant-rejection surveillance assay with no local code and no listing is very likely to be adjudicated as experimental/investigational absent an explicit policy provision. Realistically this channel converts only where a patient has a high-end international plan, and even then case-by-case.",
  "submissionWindow": null,
  "difficulty": "high",
  "status": "not_started",
  "confidence": "unverified",
  "priceLow": null,
  "priceHigh": null,
  "currency": "USD",
  "precedent": "Partial and indirect only — cancer genetic testing appears as a named benefit in at least one international plan sold in Panama. No evidence of any transplant molecular test being reimbursed by a Panamanian insurer."
 },
 {
  "id": "pan-registro-sanitario-as-a-gating-step-icges-gorgas-lab",
  "iso3": "PAN",
  "assayClass": "All assays",
  "routeName": "Registro sanitario as a gating step — ICGES/Gorgas (lab IVDs) and MINSA DNDM (medical devices)",
  "routeType": "regulatory_gate",
  "decisionBody": "Instituto Conmemorativo Gorgas de Estudios de la Salud (ICGES), Departamento de Evaluacion de Insumos y Reactivos de Laboratorio / LCRSP, under Decreto Ejecutivo 148 de 9 de agosto de 1999 — for clinical laboratory reagents, equipment and supplies for in vitro diagnosis. Separately, MINSA Direccion Nacional de Dispositivos Medicos (DNDM) under Ley 419 de 1 febrero 2024 and Decreto Ejecutivo 27 de 10 mayo 2024 (and Ley 90 de 2017) for medical devices generally.",
  "howItWorks": "Not a payment route, but it gates every payment route that involves importing product, and it must be complete BEFORE a CSS tender bid. ICGES is the unusual feature: Panama routes clinical lab IVDs through its public health reference laboratory rather than the drug regulator, and ICGES actually evaluates the product against reference reagents, serum panels, standards and controls — a real technical assessment, not a paper filing. That is a meaningful hurdle for a novel assay with no established comparator: it is unclear what reference material ICGES would use for a dd-cfDNA or HLA-NGS assay, and that question should be put to them in writing early. Documented process and fees: memorial endorsed by a lawyer with B/.8.00 stamps per page (up to 60 products per memorial); apostilled GMP certificate from the country of origin with Spanish translation; apostilled manufacturer letter designating the Panamanian applicant as distributor; the applicant's current commercial licence; Form No. 1 per product; inserts and catalogues; samples. B/.60.00 filing fee, plus a variable evaluation fee quoted by ICGES within 30 business days. Registration issued within about 4 months after samples are submitted; valid 5 years; renewal to be started 5 months before expiry. Local representative is effectively compulsory — the registration is held by the locally licensed distributor.",
  "submissionWindow": "Rolling, no windows. Budget 5–7 months realistically from first filing to certificate, longer if samples or apostilles are delayed. Start before, not after, engaging CSS procurement.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "PAB",
  "precedent": "Registro sanitario for molecular/PCR diagnostic reagents through ICGES is routine — the whole COVID RT-PCR reagent supply passed through this system. No evidence of any transplant-specific molecular assay having been registered."
 },
 {
  "id": "dom-pdss-catalogo-de-prestaciones-national-benefits-cata",
  "iso3": "DOM",
  "assayClass": "All assays",
  "routeName": "PDSS Catalogo de Prestaciones (national benefits catalogue, Seguro Familiar de Salud)",
  "routeType": "national_catalogue",
  "decisionBody": "Consejo Nacional de Seguridad Social (CNSS) approves by resolution, acting on a technical proposal from SISALRIL (Superintendencia de Salud y Riesgos Laborales). SISALRIL builds proposals with the Colegio Medico Dominicano and the relevant specialist societies. ARS (private insurers, contributory regime) and SENASA (subsidised regime) then must pay for whatever is in the catalogue.",
  "howItWorks": "The Catalogo de Prestaciones del PDSS is a single national list. Each line carries a description, a CUPS code (older items) or a SIMON internal ID (newer items), a service type (Laboratorio, Anatomia patologica, Farmacos), a coverage type (Ilimitada or Gradualidad) and the split between Cuota ARS and Cuota Afiliado. Critically, the catalogue contains NO price column: laboratory items in the ambulatory/inpatient diagnostic group are listed at 80% ARS / 20% patient, inpatient at 85/15, outpatient drugs at 70/30. Actual peso tariffs sit outside the catalogue, partly published by SISALRIL in its Oficina Virtual (a schedule covering roughly 1,370 procedures with medical honoraria) and partly set by contract between each ARS and each PSS provider. So getting listed wins you a coverage obligation, not a price; the price is a separate negotiation. Getting listed means persuading SISALRIL to put your test in a proposal to the CNSS, which then issues a resolution with an effective date (e.g. CNSS Res. 581-03, ~70 new prestaciones, effective 1 Nov 2023; Res. 624-02, further coverages effective 1 Nov 2025). There is a stated periodic evaluation methodology (SISALRIL/CNSS Resolucion 278-06) but no published, open, dated application window for industry, and no independent HTA agency: this is a regulator-led rather than sponsor-led process, so entry is via SISALRIL and the specialist societies, not a submission portal.",
  "submissionWindow": "A live and unusually favourable window is open. CNSS Resolucion 634-05 of 17 April 2026 formally instructed SISALRIL to conduct a 'revision integral' of the whole PDSS catalogue, applying technical criteria for inclusion, desinversion and modification under the Res. 278-06 methodology, explicitly to incorporate new treatments and technologies not currently covered, with a progress report due to the CNSS within 90 calendar days of notification (i.e. around mid-July 2026). Practically, engagement with the SISALRIL review working group and the Sociedad Dominicana de Nefrologia / transplant community during 2026-2027 is the only realistic entry point. Outside such a review, additions occur ad hoc by CNSS resolution with no fixed calendar.",
  "difficulty": "very_high",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "DOP",
  "precedent": "YES, clear and recent. Molecular and genomic tests are already in the catalogue: GEN BRCA 1 (SIMON 16209) and GEN BRCA 2 (SIMON 16210), both Laboratorio, Ilimitada, 80/20; ESTUDIO PCR PARA VPH DE BAJO Y ALTO RIESGO (SIMON 16497, Anatomia patologica, Ilimitada, 80/20); HEPATITIS B DNA Carga Viral (CUPS 90.6.2.24) and VIH CARGA VIRAL CUALQUIER TECNICA (CUPS 90.6.8.40). Transplant immunogenetics is also already funded inside the dedicated 'Trasplante Renal' group: HISTOCOMPATIBILIDAD ANTIGENO A B C CLASE I (CUPS 90.6.5.01), HISTOCOMPATIBILIDAD ANTIGENO DR DQ CLASE II POR SEROLOGIA (CUPS 90.6.5.06), ANTIGENO FRENTE AL PANEL PRA (SIMON 16183), PRUEBA CROSS MATCH HISTOCOMPATIBILIDAD (SIMON 15402), plus DETERMINACION TACROLIMUS EN SANGRE (16189) and DETERMINACION MICOFENOLATO EN SANGRE (16186). The zero-CUPS/high-SIMON items are recent additions, which shows the list does get extended for exactly this class of test. What is absent is any post-transplant molecular surveillance line: no dd-cfDNA, no gene-expression profiling, no molecular biopsy assessment, no donor-derived chimerism."
 },
 {
  "id": "dom-kidney-transplant-capped-annual-package-cnss-resoluc",
  "iso3": "DOM",
  "assayClass": "All assays",
  "routeName": "Kidney transplant capped annual package (CNSS Resolucion 533-01) - bundling a new test inside the existing envelope",
  "routeType": "drg_addon",
  "decisionBody": "CNSS set the package by Resolucion 533-01; SISALRIL supervises; the paying entity is the patient's ARS (contributory regime) or SENASA (subsidised regime). Day-to-day, whether a specific test is run inside the package is decided by the transplant centre and its contract with the ARS.",
  "howItWorks": "This is not a DRG in the European sense; it is a capped annual per-patient envelope of RD$3,500,000 for an approved kidney transplant recipient, covering the procedure, donor workup and post-transplant medication, with the standard 80% ARS / 20% affiliate split until the affiliate's cap of one minimum taxable salary is exhausted. Because the envelope is a money cap rather than an itemised bill of materials, a centre can in principle absorb a new monitoring assay inside it, provided the ARS accepts the claim and the envelope is not already consumed. This is the fastest realistic route to first revenue in DOM and requires no new CNSS resolution. Its limits are severe: the cap is per patient per year and already has to cover surgery plus immunosuppression, so headroom for a high-priced surveillance assay is small; and with roughly 100 kidney transplants a year across five centres, even full penetration is a very small commercial prize. Kidney is the only solid organ with any social-security cover at all: liver, heart, lung, pancreas and bone marrow have no PDSS package and are entirely out of pocket.",
  "submissionWindow": "No formal window; this is a commercial negotiation with the five transplant centres and their contracting ARS, available continuously. Any uplift to the RD$3.5M cap itself would need a new CNSS resolution and would fall under the Res. 634-05 review.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "derived",
  "priceLow": null,
  "priceHigh": null,
  "currency": "DOP",
  "precedent": "Partial. HLA class I/II typing, PRA and crossmatch are funded around kidney transplantation, and tacrolimus and mycophenolate blood levels are funded as named Trasplante Renal line items, so the system does pay for transplant-specific laboratory monitoring. Approximately 215 patients received transplants under this coverage across the contributory and subsidised regimes between 2021 and 2025. But no molecular transplant surveillance test (dd-cfDNA, gene expression, molecular biopsy) has been paid for this way, and none appears in the catalogue."
 },
 {
  "id": "dom-public-tender-promese-cal-national-reagent-and-suppl",
  "iso3": "DOM",
  "assayClass": "All assays",
  "routeName": "Public tender - PROMESE/CAL national reagent and supply tender, and Servicio Nacional de Salud hospital procurement",
  "routeType": "tender",
  "decisionBody": "Dirección General de Contrataciones Publicas (DGCP) is the governing body for all state procurement (Ley 340-06). Contracting entities are PROMESE/CAL (Programa de Medicamentos Esenciales / Central de Apoyo Logistico) for the national consolidated buy, and the Servicio Nacional de Salud (SNS) plus individual public hospitals for local buys. All processes run through the electronic system SECP on comprasdominicana.gob.do.",
  "howItWorks": "Public-sector volume is bought by open national tender (licitacion publica nacional). The 2026 cycle, PROMESECAL-CCC-LPN-2026-0001, covers 442 renglones spanning medicines, sanitary supplies and laboratory reagents with a budget of RD$2,485,971,407.80 for May 2026 to April 2027. To bid you need: a valid DIGEMAPS registro sanitario for the product; registration as a Proveedor del Estado (RPE) with the DGCP, which in practice means a Dominican legal entity or a Dominican distributor bidding on your behalf; and acceptance of Ley 340-06 preferences that favour national MIPYMEs. The mechanism buys catalogued line items, so a novel assay with no existing renglon is not straightforwardly tenderable: you would first need the test written into the tender specification, which is an upstream lobbying exercise with PROMESE/CAL or the SNS clinical leads. Note also that the public transplant footprint is small, so this route mostly matters for reagents and consumables rather than for a proprietary surveillance test.",
  "submissionWindow": "PROMESE/CAL runs an annual consolidated LPN on a roughly May-to-April supply cycle; the 2026 process was launched in the first half of 2026 for May 2026-April 2027. SNS and individual hospital processes are published continuously on comprasdominicana.gob.do and sns.gob.do/transparencia/compras-y-contrataciones/.",
  "difficulty": "high",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "DOP",
  "precedent": "No evidence found that any molecular transplant test has been bought this way. Laboratory reagents in general are routinely tendered (PROMESECAL-CCC-LPN-2026-0001 includes 'reactivos de laboratorio'), and PCR/viral-load reagents were procured publicly during the COVID period, but no transplant molecular diagnostic precedent was located."
 },
 {
  "id": "dom-direct-sale-to-transplant-centre-hospital-budget",
  "iso3": "DOM",
  "assayClass": "All assays",
  "routeName": "Direct sale to transplant centre / hospital budget",
  "routeType": "block_contract",
  "decisionBody": "The individual transplant centre. Practically five institutions, mostly private or quasi-private (CEDIMAT, Hospital General Plaza de la Salud, HOMS in Santiago and the public units), each with its own laboratory director and procurement. INCORT sets which centres may perform transplants at all under Ley 329-98.",
  "howItWorks": "Sell the assay, or an analyser-plus-reagent contract, directly to the centre's laboratory, which then either absorbs the cost in its per-patient transplant package (see the CNSS 533-01 route), bills the ARS under an existing catalogue code where one can honestly be used, or charges the patient. Because HLA/crossmatch capacity is concentrated in only two or three laboratories nationally, with HOMS described as the only one in the north, this is a very small number of decision-makers and a short sales cycle by international standards. It is the standard beachhead route in DOM and requires only DIGEMAPS registration plus a local distributor, not any payer decision. Private centres and reference laboratories are the practical buyers: Referencia Laboratorio Clinico has recently opened a molecular and anatomical pathology laboratory it describes as the most modern in the Caribbean, which makes a local-run partnership plausible rather than pure send-out.",
  "submissionWindow": "Continuous; no window.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "DOP",
  "precedent": "Not verified for a transplant molecular test. Local molecular capacity clearly exists and is being bought privately (Referencia's new molecular pathology lab; BRCA and HPV PCR are performed in country and are reimbursed), so the model is proven for molecular testing generally, just not for transplant surveillance."
 },
 {
  "id": "dom-private-pay-out-of-pocket-including-send-out-to-a-fo",
  "iso3": "DOM",
  "assayClass": "All assays",
  "routeName": "Private pay (out of pocket), including send-out to a foreign reference laboratory",
  "routeType": "private_pay",
  "decisionBody": "The patient and the ordering nephrologist. No payer or state body involved; DIGEMAPS registration is still needed if a product is imported, though a pure send-out service model may sit outside product registration (unverified - see regulatory note).",
  "howItWorks": "The patient pays cash for a test that is not in the catalogue, either performed locally or shipped to a US or European reference laboratory. This is how essentially all non-catalogue advanced diagnostics reach Dominican patients today, and it is the only route with no institutional gatekeeper. The commercial ceiling is very low: INCORT's own director has stated that the >RD$2M cost of non-covered transplants is unreachable for more than 90% of the population, and liver, heart, lung, pancreas and bone-marrow transplants have no cover at all, which is why those programmes are near-nonexistent. Realistically this route serves a few dozen affluent, mostly Santo Domingo-based patients per year and is best treated as a bridge to catalogue inclusion, not as the business case.",
  "submissionWindow": null,
  "difficulty": "low",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "DOP",
  "precedent": "Yes, in the general sense: non-catalogue genetic and molecular testing is routinely purchased privately or sent abroad in DOM. No transplant-specific molecular test precedent was found."
 },
 {
  "id": "dom-digemaps-registro-sanitario-de-productos-sanitarios-",
  "iso3": "DOM",
  "assayClass": "All assays",
  "routeName": "DIGEMAPS Registro Sanitario de Productos Sanitarios (mandatory gate before any of the above)",
  "routeType": "regulatory_gate",
  "decisionBody": "DIGEMAPS (Direccion General de Medicamentos, Alimentos y Productos Sanitarios), Ministerio de Salud Publica. Secondary gates: MSP habilitacion of the performing laboratory, and INCORT under Ley 329-98 for transplant-specific activity and histocompatibility laboratories.",
  "howItWorks": "No product may be imported, stored, distributed or sold without a registro sanitario. A locally established authorised representative/importer must hold the certificate (compulsory), supported by a notarised or apostilled power of attorney, an establishment sanitary registration for the local entity, an ONAPI local trademark certificate for the brand, an apostilled Certificate of Free Sale, apostilled ISO 13485/GMP quality-system certification, full technical documentation on DIGEMAPS forms DGDF-RP-FO-001/005/007, certificate of analysis, and two samples with over a year of shelf life. Stated timeline 90 business days; consultancies report up to 240 working days in practice. Validity 5 years. Government fee unconfirmed for IVDs (the RD$9,000 figure on the DIGEMAPS page is quoted against medicamentos; one consultancy quotes USD 190 for a device application). Foreign manufacturing sites are reported not to be inspected. No documented FDA/CE reliance shortcut, though an MSP 'procedimiento simplificado' page exists and should be checked. The underlying Reglamento de Productos Sanitarios y/o Dispositivos Medicos is still in draft on the MSP transparency portal, so confirm requirements directly with DIGEMAPS before committing budget.",
  "submissionWindow": "Rolling; submissions via https://solicitudes.digemaps.gob.do, office hours Mon-Fri 08:00-17:00.",
  "difficulty": "medium",
  "status": "not_started",
  "confidence": "estimated",
  "priceLow": null,
  "priceHigh": null,
  "currency": "DOP",
  "precedent": null
 }
] as unknown as A.Pathway[];
